
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("69gCp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "CmdbLandingPageViewOld", () => $018d18a94c79acc3$export$a27bcd6df4355097);
$parcel$export(module.exports, "CmdbLandingPageView", () => $018d18a94c79acc3$export$badc5c3c0edac849);
$parcel$export(module.exports, "ConditionalRedirectOrRouteView", () => $018d18a94c79acc3$export$8f126bd42a3e2335);
$parcel$export(module.exports, "default", () => $018d18a94c79acc3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lB25E = parcelRequire("lB25E");

var $8HeFz = parcelRequire("8HeFz");

var $frZnw = parcelRequire("frZnw");

var $1CIRW = parcelRequire("1CIRW");

var $hqVAg = parcelRequire("hqVAg");

var $8FqXR = parcelRequire("8FqXR");

var $272oI = parcelRequire("272oI");

var $2RidI = parcelRequire("2RidI");

var $gXRa1 = parcelRequire("gXRa1");
const $018d18a94c79acc3$export$a27bcd6df4355097 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RidI.default), {
        appName: (0, $frZnw.APP_NAMES).INSIGHT_LANDING_PAGE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gXRa1.InsightAppBaseV2), null, ({ workspaceId: workspaceId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1CIRW.InsightGlobalConfigContainer), {
            isGlobal: true,
            workspaceId: workspaceId,
            createAnalyticsEvent: createAnalyticsEvent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqVAg.InsightLandingPageContainer), {
            workspaceId: workspaceId,
            createAnalyticsEvent: createAnalyticsEvent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8FqXR.LandingPage), null)))));
};
const $018d18a94c79acc3$export$badc5c3c0edac849 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RidI.default), {
        appName: (0, $frZnw.APP_NAMES).INSIGHT_LANDING_PAGE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gXRa1.InsightAppBaseV2), null, ({ workspaceId: workspaceId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1CIRW.InsightGlobalConfigContainer), {
            isGlobal: true,
            workspaceId: workspaceId,
            createAnalyticsEvent: createAnalyticsEvent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqVAg.InsightLandingPageContainer), {
            workspaceId: workspaceId,
            createAnalyticsEvent: createAnalyticsEvent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8HeFz.CmdbAsyncActionsContainer), {
            workspaceId: workspaceId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8FqXR.LandingPage), null))))));
};
const $018d18a94c79acc3$export$8f126bd42a3e2335 = ()=>{
    const [{ location: location, route: route }] = (0, $lB25E.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    if ((0, $272oI.isInsightRoute)(location.pathname)) {
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
            action: 'redirected',
            actionSubject: 'routeView'
        }), 'jsmCmdbAssetsRouteRedirect landing-page', {
            redirectedFrom: route.path,
            redirectedTo: (0, $272oI.getRootPath)()
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: (0, $272oI.getLandingPageUrl)()
        });
    }
    return (0, $eI5EY.fg)('assets_rearch_async_actions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($018d18a94c79acc3$export$badc5c3c0edac849, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($018d18a94c79acc3$export$a27bcd6df4355097, null);
};
var $018d18a94c79acc3$export$2e2bcd8739ae039 = $018d18a94c79acc3$export$8f126bd42a3e2335;

});
parcelRegister("8HeFz", function(module, exports) {

$parcel$export(module.exports, "CmdbAsyncActionsContainer", () => $113a7715e39f3ce2$export$43fcf5148d300a7a);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $lDZ4v = parcelRequire("lDZ4v");
const $113a7715e39f3ce2$export$43fcf5148d300a7a = ({ workspaceId: workspaceId, children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagService)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "CmdbAsyncActions",
        packageName: "jiraServicedeskCmdbAsyncActions",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lDZ4v.CmdbAsyncActionsStoreContainer), {
        isGlobal: true,
        workspaceId: workspaceId,
        createAnalyticsEvent: createAnalyticsEvent,
        showFlag: showFlag,
        dismissFlag: dismissFlag,
        formatMessage: formatMessage
    }, children));
};

});
parcelRegister("lDZ4v", function(module, exports) {

$parcel$export(module.exports, "CmdbAsyncActionsStoreContainer", () => $e1c898517f4d32fd$export$e6bd8f42407e77f7);
$parcel$export(module.exports, "useBulkObjectQrCode", () => $e1c898517f4d32fd$export$b2ee609850a68d87);
$parcel$export(module.exports, "useCmdbAsyncActions", () => $e1c898517f4d32fd$export$b7f849aee72f4fd6);

var $WBLbN = parcelRequire("WBLbN");

var $5Cely = parcelRequire("5Cely");

var $kj79T = parcelRequire("kj79T");
const $e1c898517f4d32fd$var$initialState = {
    isPolling: false,
    tasks: [],
    bulkDelete: {
        isSubmitting: false
    },
    bulkEdit: {
        isSubmitting: false
    },
    bulkExport: {
        isSubmitting: false
    },
    bulkQrCode: {
        isSubmitting: false
    }
};
const $e1c898517f4d32fd$var$store = (0, $WBLbN.createStore)({
    initialState: $e1c898517f4d32fd$var$initialState,
    actions: $5Cely.actions
});
const $e1c898517f4d32fd$export$e6bd8f42407e77f7 = (0, $WBLbN.createContainer)($e1c898517f4d32fd$var$store, {
    onInit: (0, $kj79T.fetchInitialTasks)
});
const $e1c898517f4d32fd$export$e6aa8ccef89c70b4 = (0, $WBLbN.createHook)($e1c898517f4d32fd$var$store);
const $e1c898517f4d32fd$export$699a68ceb7db7af5 = (0, $WBLbN.createHook)($e1c898517f4d32fd$var$store, {
    selector: ({ bulkDelete: bulkDelete })=>bulkDelete
});
const $e1c898517f4d32fd$export$4dbf1e24ed027e8e = (0, $WBLbN.createHook)($e1c898517f4d32fd$var$store, {
    selector: ({ bulkEdit: bulkEdit })=>bulkEdit
});
const $e1c898517f4d32fd$export$dfb4b2bd76b9780 = (0, $WBLbN.createHook)($e1c898517f4d32fd$var$store, {
    selector: ({ bulkExport: bulkExport })=>bulkExport
});
const $e1c898517f4d32fd$export$b2ee609850a68d87 = (0, $WBLbN.createHook)($e1c898517f4d32fd$var$store, {
    selector: ({ bulkQrCode: bulkQrCode })=>bulkQrCode
});
const $e1c898517f4d32fd$export$b7f849aee72f4fd6 = (0, $WBLbN.createActionsHook)($e1c898517f4d32fd$var$store);

});
parcelRegister("5Cely", function(module, exports) {

$parcel$export(module.exports, "actions", () => $baf53d59bb5acbe8$export$e324594224ef24da);

var $213MI = parcelRequire("213MI");

var $1H9Mu = parcelRequire("1H9Mu");

var $9SJVM = parcelRequire("9SJVM");

var $gMpdq = parcelRequire("gMpdq");
const $baf53d59bb5acbe8$export$e324594224ef24da = {
    showTaskFlags: $213MI.showTaskFlags,
    startTaskPolling: $1H9Mu.startTaskPolling,
    submitAsyncObjectExportTask: $9SJVM.submitAsyncObjectExportTask,
    submitBulkQrCodeTask: $gMpdq.submitBulkQrCodeTask
};

});
parcelRegister("213MI", function(module, exports) {

$parcel$export(module.exports, "showTaskFlags", () => $08e52ceb15f2000b$export$6084fd3743caa46);
const $08e52ceb15f2000b$export$6084fd3743caa46 = ()=>async ()=>undefined;

});

parcelRegister("1H9Mu", function(module, exports) {

$parcel$export(module.exports, "startTaskPolling", () => $c9370a99c0515e2d$export$2888c4840b025e2a);
const $c9370a99c0515e2d$export$2888c4840b025e2a = ()=>async ()=>undefined;

});

parcelRegister("9SJVM", function(module, exports) {

$parcel$export(module.exports, "submitAsyncObjectExportTask", () => $57523b77787f1782$export$1635ea2519092923);

var $jMP2a = parcelRequire("jMP2a");

var $eZfBZ = parcelRequire("eZfBZ");

var $bMh3u = parcelRequire("bMh3u");

var $14FTs = parcelRequire("14FTs");

var $cYSJU = parcelRequire("cYSJU");

var $6Fge5 = parcelRequire("6Fge5");

var $6TAb9 = parcelRequire("6TAb9");

var $1H9Mu = parcelRequire("1H9Mu");
const $57523b77787f1782$export$1635ea2519092923 = ({ objectCount: objectCount, ...body })=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { tasks: tasks, bulkExport: { isSubmitting: isSubmitting } } = getState();
        if (isSubmitting) return;
        setState({
            bulkExport: {
                isSubmitting: true
            }
        });
        try {
            const { taskId: taskId } = await (0, $cYSJU.createAsyncBulkExportTask)(workspaceId, {
                ...body
            });
            setState({
                tasks: (0, $14FTs.mergeTasks)(tasks, [
                    {
                        identifier: taskId,
                        operationType: (0, $bMh3u.OPERATION_TYPE_BULK_EXPORT),
                        status: (0, $bMh3u.STATUS_QUEUED)
                    }
                ]),
                bulkExport: {
                    isSubmitting: false
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'submitAsyncBulkExportTask succeeded');
            dispatch((0, $6TAb9.showSuccessFlag)({
                id: taskId,
                objectCount: objectCount,
                action: (0, $bMh3u.OPERATION_TYPE_BULK_EXPORT)
            }));
            dispatch((0, $1H9Mu.startTaskPolling)());
        } catch (error) {
            (0, $eZfBZ.fireJsonOnlyErrorAnalytics)({
                error: error,
                meta: {
                    id: 'submitAsyncBulkExportTask',
                    packageName: 'jiraServicedeskCmdbAsyncActions',
                    teamName: 'falcons'
                }
            });
            setState({
                bulkExport: {
                    isSubmitting: false
                }
            });
            dispatch((0, $6Fge5.showErrorFlag)({
                action: (0, $bMh3u.OPERATION_TYPE_BULK_EXPORT)
            }));
            throw error;
        }
    };

});
parcelRegister("eZfBZ", function(module, exports) {

$parcel$export(module.exports, "ANALYTIC_CONTEXTS", () => $6d93f232242cadb5$export$ca021921d5c56515);
$parcel$export(module.exports, "ttiRecommendedSlo", () => $6d93f232242cadb5$export$dc391c7d81907d3a);
$parcel$export(module.exports, "trackJsdFetchErrors", () => $6d93f232242cadb5$export$ebdbd98df5a27905);
$parcel$export(module.exports, "fireJsonOnlyErrorAnalytics", () => $6d93f232242cadb5$export$32233c6edb041cf2);

var $guiFP = parcelRequire("guiFP");

var $fV97Z = parcelRequire("fV97Z");
const $6d93f232242cadb5$export$ca021921d5c56515 = {
    AUTOMATION_SETTINGS: 'AutomationSettings',
    KNOWLEDGE: 'Knowledge',
    QUEUES: 'Queues',
    CSAT: 'Csat'
};
const $6d93f232242cadb5$export$cca3c4e11cb0a5ce = 1000;
const $6d93f232242cadb5$export$dc391c7d81907d3a = 4000;
const $6d93f232242cadb5$export$ebdbd98df5a27905 = async (payload)=>{
    const { error: error, attributes: attributes } = payload;
    if (error instanceof (0, $fV97Z.JsdFetchError)) {
        const { reasonKey: reasonKey } = error;
        (0, $guiFP.trackFetchErrors)({
            ...payload,
            attributes: {
                ...attributes,
                reasonKey: reasonKey
            }
        });
        return;
    }
    (0, $guiFP.trackFetchErrors)(payload);
};
function $6d93f232242cadb5$export$32233c6edb041cf2({ error: error, ...rest }) {
    let useError = false;
    if (error instanceof Error) try {
        JSON.parse(error.message);
        useError = true;
    } catch (e) {
        useError = false;
    }
    (0, $guiFP.default)({
        error: error instanceof Error && useError ? error : undefined,
        ...rest
    });
}

});
parcelRegister("fV97Z", function(module, exports) {

$parcel$export(module.exports, "JsdFetchError", () => $c9869c00ba1fbd5b$export$fee0012ae6cb3438);
$parcel$export(module.exports, "performGetRequest", () => $c9869c00ba1fbd5b$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $c9869c00ba1fbd5b$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $c9869c00ba1fbd5b$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $c9869c00ba1fbd5b$export$8ef51cba9d28f819);

var $8blac = parcelRequire("8blac");

var $kkgbD = parcelRequire("kkgbD");

var $fVqUX = parcelRequire("fVqUX");


var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $lRmyA = parcelRequire("lRmyA");
const $c9869c00ba1fbd5b$var$VALIDATION_ERROR_KEY = 'validation.error';
class $c9869c00ba1fbd5b$export$fee0012ae6cb3438 extends (0, $7byHA.default) {
    constructor(statusCode, message, reasonKey, response){
        super(statusCode, (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(message) ? `Fetch call failed with status code: ${statusCode}` : message);
        this.name = 'JsdFetchError';
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))(reasonKey)) this.reasonKey = reasonKey;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))(response)) this.response = response;
    }
}
const $c9869c00ba1fbd5b$var$transformMessageErrorsFromServer = (errors = [])=>errors.reduce((messages, { errorMessage: errorMessage })=>{
        messages.push(errorMessage);
        return messages;
    }, []).join(' ');
const $c9869c00ba1fbd5b$var$putOptions = {
    ...(0, $fVqUX.default),
    method: 'PUT'
};
const $c9869c00ba1fbd5b$var$postOptions = {
    ...(0, $fVqUX.default),
    method: 'POST'
};
const $c9869c00ba1fbd5b$var$deleteOptions = {
    ...(0, $fVqUX.default),
    method: 'DELETE'
};
const $c9869c00ba1fbd5b$var$patchOptions = {
    ...(0, $fVqUX.default),
    method: 'PATCH'
};
const $c9869c00ba1fbd5b$var$processResponse = async (response)=>{
    if ((0, $1c3fbb431a173cc6$export$9de493bcd9b1d977) === response.status) {
        const jsonResponse = await response.json();
        const { errors: errors, reasonKey: reasonKey } = jsonResponse;
        if (reasonKey === $c9869c00ba1fbd5b$var$VALIDATION_ERROR_KEY) throw (0, $lRmyA.transformValidationErrorFromServer)(jsonResponse);
        const message = $c9869c00ba1fbd5b$var$transformMessageErrorsFromServer(errors);
        throw new $c9869c00ba1fbd5b$export$fee0012ae6cb3438(response.status, message, reasonKey, jsonResponse);
    }
    if (!response.ok) {
        const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
        if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`, traceId);
        else throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`);
    }
    if (response.status === (0, $1c3fbb431a173cc6$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $c9869c00ba1fbd5b$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch(url, {
        ...(0, $fVqUX.default),
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$9ead1f9103e6de6b = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$putOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$692a4d9808143175 = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$postOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$8ef51cba9d28f819 = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$deleteOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$52be6ab13d7e758d = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$patchOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);

});
const $1c3fbb431a173cc6$export$ff39ebd4bb12b718 = 201;
const $1c3fbb431a173cc6$export$3288b14b6745c572 = 204;
const $1c3fbb431a173cc6$export$9de493bcd9b1d977 = 400;
const $1c3fbb431a173cc6$export$67d19e9a991baa07 = 401;
const $1c3fbb431a173cc6$export$a3269a3914b007e3 = 403;
const $1c3fbb431a173cc6$export$8bca792d963eb0ef = 404;
const $1c3fbb431a173cc6$export$4a3cb39801694eee = 407;
const $1c3fbb431a173cc6$export$fa405bbf47d510e2 = 408;
const $1c3fbb431a173cc6$export$c09e7ea0fc79f34f = 409;
const $1c3fbb431a173cc6$export$5244030134e99 = 412;
const $1c3fbb431a173cc6$export$f90ac1df0b60853d = 413;
const $1c3fbb431a173cc6$export$a447d0a965e16776 = 422;
const $1c3fbb431a173cc6$export$3b48aba8957000cd = 426;
const $1c3fbb431a173cc6$export$6763168a631449a2 = 429;
const $1c3fbb431a173cc6$export$e813cd7045fcc98d = 500;
const $1c3fbb431a173cc6$export$2ce38d41a306034e = 502;
const $1c3fbb431a173cc6$export$974c37534b0191b1 = 503;
const $1c3fbb431a173cc6$export$5400e8dddac3fcf3 = 504;



parcelRegister("bMh3u", function(module, exports) {

$parcel$export(module.exports, "OPERATION_TYPE_BULK_EXPORT", () => $cb54d4ac6d035acb$export$c331466741bc25dd);
$parcel$export(module.exports, "OPERATION_TYPE_BULK_QR_CODE", () => $cb54d4ac6d035acb$export$ac103f1dc164db47);
$parcel$export(module.exports, "STATUS_QUEUED", () => $cb54d4ac6d035acb$export$5151c63487c6074a);
const $cb54d4ac6d035acb$export$c4a0fd6df07697e9 = 'BulkEdit';
const $cb54d4ac6d035acb$export$940d318e182226db = 'BulkDelete';
const $cb54d4ac6d035acb$export$c331466741bc25dd = 'BulkExport';
const $cb54d4ac6d035acb$export$ac103f1dc164db47 = 'QrCode';
const $cb54d4ac6d035acb$export$5151c63487c6074a = 'Queued';
const $cb54d4ac6d035acb$export$f1c7e78b7edcac86 = 'InProgress';
const $cb54d4ac6d035acb$export$81f34347d5a84d5f = 'Completed';
const $cb54d4ac6d035acb$export$7ee58d019dd6dcbe = (id)=>id;

});

parcelRegister("14FTs", function(module, exports) {

$parcel$export(module.exports, "mergeTasks", () => $bca9ca082205cfdd$export$e574549178e429d1);
const $bca9ca082205cfdd$export$e574549178e429d1 = (existingTasks, newTasks)=>{
    const taskMap = new Map();
    (existingTasks ?? []).forEach((item)=>taskMap.set(item.identifier, item));
    (newTasks ?? []).forEach((item)=>taskMap.set(item.identifier, {
            ...taskMap.get(item.identifier),
            ...item
        }));
    return Array.from(taskMap.values());
};

});

parcelRegister("cYSJU", function(module, exports) {

$parcel$export(module.exports, "createAsyncBulkExportTask", () => $4ad763e948b17d5d$export$9a27b34ed9dfe3bb);

var $lRmyA = parcelRequire("lRmyA");

var $eEeZ0 = parcelRequire("eEeZ0");

var $gKyXP = parcelRequire("gKyXP");
const $4ad763e948b17d5d$export$9a27b34ed9dfe3bb = (workspaceId, params)=>{
    if (params.filter.qlQueryParams == null && params.filter.filterParams == null) throw new Error('Must supply either `filters` or `iqlParams` to `createAsyncBulkExportTask`');
    const body = (0, $gKyXP.generateFilterBody)(params.filter);
    return (0, $lRmyA.performPostRequest)((0, $eEeZ0.getCmdbAsyncObjectExportUrl)(workspaceId), {
        body: JSON.stringify(body)
    });
};

});
parcelRegister("gKyXP", function(module, exports) {

$parcel$export(module.exports, "generateFilterBody", () => $6a37d9571818a4c0$export$b5cbff222f57fa30);

var $3cub4 = parcelRequire("3cub4");
const $6a37d9571818a4c0$export$b5cbff222f57fa30 = (filter)=>{
    const body = {
        ...filter
    };
    if (filter.qlQuerySearch && filter.qlQueryParams) body.qlQueryParams = {
        ...filter.qlQueryParams,
        ...(0, $3cub4.UNUSED_REQUIRED_PROPERTIES)
    };
    else if (!filter.qlQuerySearch && filter.filterParams) body.filterParams = {
        ...filter.filterParams,
        ...(0, $3cub4.UNUSED_REQUIRED_PROPERTIES)
    };
    else throw new Error(`Invalid state, qlQuerySearch: ${filter.qlQuerySearch}, qlQueryParams: ${filter.qlQueryParams}, filterParams: ${filter.filterParams}`);
    return body;
};

});
parcelRegister("3cub4", function(module, exports) {

$parcel$export(module.exports, "UNUSED_REQUIRED_PROPERTIES", () => $233b6e35bdb5acfe$export$66d9e8b9106c462e);
const $233b6e35bdb5acfe$export$66d9e8b9106c462e = {
    asc: 1,
    attributesToDisplay: {
        attributesToDisplayIds: []
    },
    includeAttributes: false,
    page: 1,
    resultsPerPage: 25
};

});



parcelRegister("6Fge5", function(module, exports) {

$parcel$export(module.exports, "showErrorFlag", () => $d9e53cbbcce3bd62$export$dfa2148cdb92917d);

var $9k6aW = parcelRequire("9k6aW");

var $brK1X = parcelRequire("brK1X");
const $d9e53cbbcce3bd62$export$dfa2148cdb92917d = ({ action: action })=>async (_, { showFlag: showFlag, formatMessage: formatMessage })=>{
        showFlag({
            type: 'error',
            title: formatMessage((0, $9k6aW.default).submitErrorFlagTitle, {
                action: formatMessage((0, $brK1X.mapActionToMessage)(action))
            }),
            description: formatMessage((0, $9k6aW.default).submitErrorFlagDescription)
        });
    };

});
parcelRegister("9k6aW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7385dc1095f19842$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7385dc1095f19842$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    submitSuccessFlagTitle: {
        "id": "servicedesk-cmdb-async-actions.common.submit-success-flag-title",
        "defaultMessage": "Bulk action started: {action} {objectCount} {objectCount, plural, one {object} other {objects}}"
    },
    submitSuccessFlagDescription: {
        "id": "servicedesk-cmdb-async-actions.common.submit-success-flag-description",
        "defaultMessage": "This bulk action may take a while. You will receive a notification once the work is complete."
    },
    submitErrorFlagTitle: {
        "id": "servicedesk-cmdb-async-actions.common.submit-error-flag-title",
        "defaultMessage": "Bulk {action} failed"
    },
    submitErrorFlagDescription: {
        "id": "servicedesk-cmdb-async-actions.common.submit-error-flag-description",
        "defaultMessage": "Please check your network and try again"
    },
    bulkExport: {
        "id": "servicedesk-cmdb-async-actions.common.bulk-export",
        "defaultMessage": "Export"
    },
    bulkQrCode: {
        "id": "servicedesk-cmdb-async-actions.common.bulk-qr-code",
        "defaultMessage": "Print QR code"
    },
    bulkEdit: {
        "id": "servicedesk-cmdb-async-actions.common.bulk-edit",
        "defaultMessage": "Edit"
    },
    bulkDelete: {
        "id": "servicedesk-cmdb-async-actions.common.bulk-delete",
        "defaultMessage": "Delete"
    }
});

});

parcelRegister("brK1X", function(module, exports) {

$parcel$export(module.exports, "mapActionToMessage", () => $445d570ab45db568$export$2530057a1d6c1d80);

var $9k6aW = parcelRequire("9k6aW");
const $445d570ab45db568$export$2530057a1d6c1d80 = (operationType)=>{
    const actionMessages = {
        BulkExport: (0, $9k6aW.default).bulkExport,
        QrCode: (0, $9k6aW.default).bulkQrCode,
        BulkEdit: (0, $9k6aW.default).bulkEdit,
        BulkDelete: (0, $9k6aW.default).bulkDelete
    };
    return actionMessages[operationType];
};

});


parcelRegister("6TAb9", function(module, exports) {

$parcel$export(module.exports, "showSuccessFlag", () => $89c1be8e65766d03$export$fef8478a2c810f18);

var $eUqFw = parcelRequire("eUqFw");

var $iPlKJ = parcelRequire("iPlKJ");

var $9k6aW = parcelRequire("9k6aW");

var $brK1X = parcelRequire("brK1X");
const $89c1be8e65766d03$export$fef8478a2c810f18 = ({ id: id, objectCount: objectCount, action: action })=>async (_, { showFlag: showFlag, formatMessage: formatMessage })=>{
        showFlag({
            id: id,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iPlKJ))), {
                label: ""
            }),
            type: 'info',
            title: formatMessage((0, $9k6aW.default).submitSuccessFlagTitle, {
                action: formatMessage((0, $brK1X.mapActionToMessage)(action)),
                objectCount: objectCount
            }),
            description: formatMessage((0, $9k6aW.default).submitSuccessFlagDescription)
        });
    };

});
parcelRegister("iPlKJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db4ddd0d819bf555$var$_react = $db4ddd0d819bf555$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $db4ddd0d819bf555$var$_refresh = $db4ddd0d819bf555$var$_interopRequireDefault((parcelRequire("h1qCH")));
function $db4ddd0d819bf555$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $db4ddd0d819bf555$var$RefreshIcon = (props)=>/*#__PURE__*/ $db4ddd0d819bf555$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $db4ddd0d819bf555$var$_refresh.default
    }));
$db4ddd0d819bf555$var$RefreshIcon.displayName = 'RefreshIcon';
var $db4ddd0d819bf555$var$_default = module.exports.default = $db4ddd0d819bf555$var$RefreshIcon;

});
parcelRegister("h1qCH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c4933bf44687bb6f7c689a91fdbcfe96>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6472e7a17144be6$var$_react = $c6472e7a17144be6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c6472e7a17144be6$var$_UNSAFE_baseNew = $c6472e7a17144be6$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c6472e7a17144be6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6472e7a17144be6$var$RefreshIcon = (props)=>/*#__PURE__*/ $c6472e7a17144be6$var$_react.default.createElement($c6472e7a17144be6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6V1.75H2m5.5 12.48c-3.218-.254-5.75-2.447-5.75-5.73 0-3.368 2.42-4.921 4-6.29m4 7.77v4.25H14M8.5 1.75c3.218.255 5.75 2.447 5.75 5.73 0 3.352-2.397 4.906-3.977 6.27"/>`
    }, props));
$c6472e7a17144be6$var$RefreshIcon.displayName = 'RefreshIcon';
var $c6472e7a17144be6$var$_default = module.exports.default = $c6472e7a17144be6$var$RefreshIcon;

});




parcelRegister("gMpdq", function(module, exports) {

$parcel$export(module.exports, "submitBulkQrCodeTask", () => $8edeb650331736bb$export$22f6482695c3c60c);

var $jMP2a = parcelRequire("jMP2a");

var $eZfBZ = parcelRequire("eZfBZ");

var $bMh3u = parcelRequire("bMh3u");

var $14FTs = parcelRequire("14FTs");

var $62qNP = parcelRequire("62qNP");

var $6Fge5 = parcelRequire("6Fge5");

var $6TAb9 = parcelRequire("6TAb9");

var $1H9Mu = parcelRequire("1H9Mu");
const $8edeb650331736bb$export$22f6482695c3c60c = ({ objectCount: objectCount, size: size, ...body })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().bulkQrCode.isSubmitting) return;
        setState({
            bulkQrCode: {
                isSubmitting: true
            }
        });
        try {
            const { taskId: taskId } = await (0, $62qNP.createAsyncBulkQrCodeTask)(workspaceId, size, {
                ...body
            });
            setState({
                tasks: (0, $14FTs.mergeTasks)(getState().tasks, [
                    {
                        identifier: taskId,
                        operationType: (0, $bMh3u.OPERATION_TYPE_BULK_QR_CODE),
                        status: (0, $bMh3u.STATUS_QUEUED)
                    }
                ]),
                bulkQrCode: {
                    isSubmitting: false
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'submitAsyncBulkQrCodeTask succeeded');
            dispatch((0, $6TAb9.showSuccessFlag)({
                id: taskId,
                objectCount: objectCount,
                action: (0, $bMh3u.OPERATION_TYPE_BULK_QR_CODE)
            }));
            dispatch((0, $1H9Mu.startTaskPolling)());
        } catch (error) {
            (0, $eZfBZ.fireJsonOnlyErrorAnalytics)({
                error: error,
                meta: {
                    id: 'submitAsyncBulkQrCodeTask',
                    packageName: 'jiraServicedeskCmdbAsyncActions',
                    teamName: 'falcons'
                }
            });
            setState({
                bulkQrCode: {
                    isSubmitting: false
                }
            });
            dispatch((0, $6Fge5.showErrorFlag)({
                action: (0, $bMh3u.OPERATION_TYPE_BULK_QR_CODE)
            }));
            throw error;
        }
    };

});
parcelRegister("62qNP", function(module, exports) {

$parcel$export(module.exports, "createAsyncBulkQrCodeTask", () => $f6988609a5dfcf03$export$2ed432cc0e33a12d);

var $lRmyA = parcelRequire("lRmyA");

var $eEeZ0 = parcelRequire("eEeZ0");

var $gKyXP = parcelRequire("gKyXP");
const $f6988609a5dfcf03$export$2ed432cc0e33a12d = (workspaceId, size, params)=>{
    if (params.qlQueryParams == null && params.filterParams == null) throw new Error('Must supply either `filters` or `qlQueryParams` to `createAsyncBulkQrCodeTask`');
    const body = (0, $gKyXP.generateFilterBody)(params);
    return (0, $lRmyA.performPostRequest)((0, $eEeZ0.getCmdbAsyncBulkQrCodeUrl)(workspaceId, {
        size: size
    }), {
        body: JSON.stringify(body)
    });
};

});



parcelRegister("kj79T", function(module, exports) {

$parcel$export(module.exports, "fetchInitialTasks", () => $a1d9d4a5a610e438$export$cf59b8673dd061d2);

var $1H9Mu = parcelRequire("1H9Mu");
const $a1d9d4a5a610e438$export$f38e02e354f1b81 = 5000;
const $a1d9d4a5a610e438$export$cf59b8673dd061d2 = ()=>async ({ getState: getState, dispatch: dispatch })=>{
        if (!getState().isPolling && !getState().tasks) setTimeout(()=>{
            dispatch((0, $1H9Mu.startTaskPolling)());
        }, $a1d9d4a5a610e438$export$f38e02e354f1b81);
    };

});



parcelRegister("1CIRW", function(module, exports) {

$parcel$export(module.exports, "useInsightGlobalConfig", () => $43039c6281119da3$export$ee996472bb397b41);
$parcel$export(module.exports, "useInsightReferenceTypes", () => $43039c6281119da3$export$efb93af726a65b26);
$parcel$export(module.exports, "useInsightStatusTypes", () => $43039c6281119da3$export$7eefa9cea32e596a);
$parcel$export(module.exports, "useInsightIcons", () => $43039c6281119da3$export$8336b36336c9f3c8);
$parcel$export(module.exports, "useDataManager", () => $43039c6281119da3$export$143bcc72da01e561);
$parcel$export(module.exports, "useNamedInsightIcons", () => $43039c6281119da3$export$979b264266dab4ed);
$parcel$export(module.exports, "useIsRestrictedSchema", () => $43039c6281119da3$export$d07372ba961b2bc5);
$parcel$export(module.exports, "InsightGlobalConfigContainer", () => $43039c6281119da3$export$c4c69c73d422ea06);

var $WBLbN = parcelRequire("WBLbN");

var $bXWsR = parcelRequire("bXWsR");


var $gk6Gt = parcelRequire("gk6Gt");
const $43039c6281119da3$export$d4c72bab9d6cc13a = {
    loading: false,
    error: undefined,
    config: undefined,
    referenceTypes: {
        data: undefined,
        createLoading: false,
        createError: undefined,
        deleteLoading: false,
        deleteError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    statusTypes: {
        data: undefined,
        createLoading: false,
        createError: undefined,
        deleteLoading: false,
        deleteError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    icons: {
        data: undefined,
        deleteLoading: false,
        deleteError: undefined,
        addLoading: false,
        addError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    dataManager: {
        rolesData: undefined,
        rolesError: undefined,
        rolesLoading: false,
        rolesUpdateLoading: false,
        rolesUpdateError: undefined,
        tokensLoading: false,
        tokensData: undefined,
        tokensError: undefined,
        tokenRevokeLoading: false,
        tokenRevokeError: undefined,
        isProvisioned: undefined,
        provisioningLoading: false,
        provisioningError: undefined,
        provisioningUpdateLoading: false,
        provisioningUpdateError: undefined,
        myRoles: undefined,
        myRolesError: undefined,
        myRolesLoading: false,
        featureFlags: {
            [(0, $1a426604eb5f44c6$export$2f383dcad349f1af)]: false
        }
    }
};
const $43039c6281119da3$var$Store = (0, $WBLbN.createStore)({
    initialState: $43039c6281119da3$export$d4c72bab9d6cc13a,
    actions: $bXWsR.actions
});
const $43039c6281119da3$export$ee996472bb397b41 = (0, $WBLbN.createHook)($43039c6281119da3$var$Store, {
    selector: (state)=>state
});
const $43039c6281119da3$export$efb93af726a65b26 = (0, $WBLbN.createHook)($43039c6281119da3$var$Store, {
    selector: ({ referenceTypes: referenceTypes })=>({
            ...referenceTypes,
            data: referenceTypes.data ? (0, $gk6Gt.sortReferenceTypes)(referenceTypes.data) : undefined
        })
});
const $43039c6281119da3$export$7eefa9cea32e596a = (0, $WBLbN.createHook)($43039c6281119da3$var$Store, {
    selector: ({ statusTypes: statusTypes })=>({
            ...statusTypes,
            data: statusTypes.data ? (0, $gk6Gt.sortStatusTypes)(statusTypes.data) : undefined
        })
});
const $43039c6281119da3$export$8336b36336c9f3c8 = (0, $WBLbN.createHook)($43039c6281119da3$var$Store, {
    selector: ({ icons: icons })=>icons
});
const $43039c6281119da3$export$143bcc72da01e561 = (0, $WBLbN.createHook)($43039c6281119da3$var$Store, {
    selector: ({ dataManager: dataManager })=>dataManager
});
const $43039c6281119da3$export$979b264266dab4ed = (0, $WBLbN.createStateHook)($43039c6281119da3$var$Store, {
    selector: ({ icons: icons })=>{
        const map = {};
        (icons.data ?? []).forEach((icon)=>{
            map[icon.name] = icon;
        });
        return map;
    }
});
const $43039c6281119da3$export$9c8eee3abcaa634e = (state, schemaId)=>{
    const restrictedObjectSchemaIds = state.config?.restrictedObjectSchemaIds ?? [];
    return restrictedObjectSchemaIds.includes(parseInt(schemaId, 10));
};
const $43039c6281119da3$export$d07372ba961b2bc5 = (0, $WBLbN.createHook)($43039c6281119da3$var$Store, {
    selector: $43039c6281119da3$export$9c8eee3abcaa634e
});
const $43039c6281119da3$var$autoFetchGlobalConfig = ()=>({ dispatch: dispatch, getState: getState }, { disableOnInit: disableOnInit })=>{
        const { loading: loading, error: error, config: config } = getState();
        if (!disableOnInit && !loading && !error && !config) dispatch((0, $bXWsR.actions).fetchGlobalConfig());
    };
const $43039c6281119da3$export$c4c69c73d422ea06 = (0, $WBLbN.createContainer)($43039c6281119da3$var$Store, {
    onInit: $43039c6281119da3$var$autoFetchGlobalConfig
});

});
parcelRegister("bXWsR", function(module, exports) {

$parcel$export(module.exports, "actions", () => $ebf20cb11499dea5$export$e324594224ef24da);

var $1FL2d = parcelRequire("1FL2d");

var $3RC13 = parcelRequire("3RC13");

var $kVrCm = parcelRequire("kVrCm");

var $lHKef = parcelRequire("lHKef");

var $bKKjD = parcelRequire("bKKjD");

var $gQ1QW = parcelRequire("gQ1QW");

var $elM5U = parcelRequire("elM5U");

var $gFwZd = parcelRequire("gFwZd");

var $3G3H1 = parcelRequire("3G3H1");

var $e0su3 = parcelRequire("e0su3");

var $eNd91 = parcelRequire("eNd91");

var $kxMnp = parcelRequire("kxMnp");

var $7I5Kf = parcelRequire("7I5Kf");

var $1LS4F = parcelRequire("1LS4F");

var $id6f8 = parcelRequire("id6f8");

var $7bZq7 = parcelRequire("7bZq7");
const $ebf20cb11499dea5$export$e324594224ef24da = {
    createReferenceType: $3RC13.createReferenceType,
    createStatusType: $kVrCm.createStatusType,
    deleteIcon: $lHKef.deleteIcon,
    addIcon: $1FL2d.addIcon,
    deleteReferenceType: $bKKjD.deleteReferenceType,
    deleteStatusType: $gQ1QW.deleteStatusType,
    fetchGlobalConfig: $elM5U.fetchGlobalConfig,
    setIcon: $7I5Kf.setIcon,
    updateIcon: $7I5Kf.updateIcon,
    setReferenceType: $id6f8.setReferenceType,
    updateReferenceType: $id6f8.updateReferenceType,
    fetchPrincipalsForRoles: $3G3H1.fetchPrincipalsForRoles,
    fetchMyDataManagerRoles: $gFwZd.fetchMyDataManagerRoles,
    updateDataManagerRole: $kxMnp.updateDataManagerRole,
    fetchProvisioningStatus: $e0su3.fetchProvisioningStatus,
    updateProvisioningStatus: $1LS4F.updateProvisioningStatus,
    fetchDataManagerTokens: $eNd91.fetchDataManagerTokens,
    setStatusType: $7bZq7.setStatusType,
    updateStatusType: $7bZq7.updateStatusType
};

});
parcelRegister("1FL2d", function(module, exports) {

$parcel$export(module.exports, "addIcon", () => $2e1d84d92f18b6bd$export$3488242433cbedb);

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");

var $aSJew = parcelRequire("aSJew");

var $3ksgb = parcelRequire("3ksgb");

var $cay2q = parcelRequire("cay2q");
const $2e1d84d92f18b6bd$export$3488242433cbedb = (newIcon)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                addLoading: true
            }
        });
        try {
            const uploadCredentials = await (0, $cay2q.mediaInfoForUpload)((0, $aSJew.toWorkspaceId)(workspaceId));
            const uploadMediaResult = await (0, $cay2q.mediaUploadFile)({
                mediaBaseUrl: (0, $3ksgb.toMediaBaseUrl)(uploadCredentials.mediaBaseUrl),
                collectionId: (0, $3ksgb.toCollectionId)(uploadCredentials.collectionId),
                fileName: (0, $3ksgb.toFileName)(newIcon.fileName),
                // Remove when cleaning up assets_rearch_media_client_auth
                issuer: (0, $3ksgb.toMediaIssuer)(uploadCredentials.issuer),
                clientId: (0, $3ksgb.toMediaClientId)(uploadCredentials.clientId),
                mediaJwtToken: (0, $3ksgb.toMediaJwt)(uploadCredentials.mediaJwtToken),
                blob: newIcon.blob
            });
            const mediaInfoForPullingResult = await (0, $cay2q.mediaInfoForPulling)((0, $aSJew.toWorkspaceId)(workspaceId), (0, $3ksgb.toMediaFileUuid)(uploadMediaResult.data.id));
            const pollMediaFileReady = ()=>{
                const getMediaFileStatus = ()=>(0, $cay2q.mediaGetFileInfo)({
                        mediaBaseUrl: (0, $3ksgb.toMediaBaseUrl)(mediaInfoForPullingResult.mediaBaseUrl),
                        mediaFileUuid: (0, $3ksgb.toMediaFileUuid)(uploadMediaResult.data.id),
                        // Remove when cleaning up assets_rearch_media_client_auth
                        issuer: (0, $3ksgb.toMediaIssuer)(mediaInfoForPullingResult.issuer),
                        clientId: (0, $3ksgb.toMediaClientId)(uploadCredentials.clientId),
                        mediaJwtToken: (0, $3ksgb.toMediaJwt)(mediaInfoForPullingResult.mediaJwtToken)
                    });
                return new Promise((resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
                reject)=>{
                    const poll = (attempt = 0)=>{
                        const statusPromise = getMediaFileStatus();
                        statusPromise.then((response)=>{
                            const status = response.data.processingStatus;
                            switch(status){
                                default:
                                case (0, $3ksgb.MEDIA_PROCESS_STATUS).PENDING:
                                case (0, $3ksgb.MEDIA_PROCESS_STATUS).RUNNING:
                                    return setTimeout(()=>{
                                        // 20 tries before throwing an error
                                        if (attempt > 20) return reject(new Error('Failed to add icon after 10 tries'));
                                        return poll(attempt + 1);
                                    }, 5000);
                                case (0, $3ksgb.MEDIA_PROCESS_STATUS).SUCCEEDED:
                                    // @ts-expect-error - TS2794 - Expected 1 arguments, but got 0. Did you forget to include 'void' in your type argument to 'Promise'?
                                    return resolve();
                                case (0, $3ksgb.MEDIA_PROCESS_STATUS).FAILED:
                                    return reject(new Error('Media services failed to process file!'));
                            }
                        }).catch((error)=>reject(new Error(error)));
                    };
                    poll();
                });
            };
            await pollMediaFileReady();
            const savedIconEntry = await (0, $cay2q.publishNewIcon)((0, $aSJew.toWorkspaceId)(workspaceId), (0, $3ksgb.toIconName)(newIcon.iconName), (0, $3ksgb.toMediaFileUuid)(uploadMediaResult.data.id));
            // Make flow happy
            if (!Array.isArray(state.icons.data)) throw new Error('Invalid state! Icons data is not array!');
            const newIconsData = state.icons.data.slice(0);
            newIconsData.unshift(savedIconEntry);
            const newState = {
                ...state,
                icons: {
                    ...state.icons,
                    addLoading: false,
                    data: newIconsData
                }
            };
            setState(newState);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'addIcon succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    addLoading: false,
                    addError: error
                }
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'addIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("3ksgb", function(module, exports) {

$parcel$export(module.exports, "MEDIA_PROCESS_STATUS", () => $7cc017dd962563cc$export$a760cae7c12e7f51);
$parcel$export(module.exports, "toMediaBaseUrl", () => $7cc017dd962563cc$export$342e5c2fdd47297c);
$parcel$export(module.exports, "toCollectionId", () => $7cc017dd962563cc$export$59b8a2c37e183bf5);
$parcel$export(module.exports, "toIconName", () => $7cc017dd962563cc$export$41540e96af228b1a);
$parcel$export(module.exports, "toFileName", () => $7cc017dd962563cc$export$249aa0c12095aafd);
$parcel$export(module.exports, "toMediaIssuer", () => $7cc017dd962563cc$export$9dd52a3c923cba73);
$parcel$export(module.exports, "toMediaJwt", () => $7cc017dd962563cc$export$dce78fe68aa68f20);
$parcel$export(module.exports, "toMediaFileUuid", () => $7cc017dd962563cc$export$79083a8ab294d28e);
$parcel$export(module.exports, "toMediaClientId", () => $7cc017dd962563cc$export$b105972f97cb69fa);
const $7cc017dd962563cc$export$a760cae7c12e7f51 = {
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    PENDING: 'pending',
    RUNNING: 'running'
};
const $7cc017dd962563cc$export$342e5c2fdd47297c = (url)=>url;
const $7cc017dd962563cc$export$59b8a2c37e183bf5 = (uuid)=>uuid;
const $7cc017dd962563cc$export$41540e96af228b1a = (iconName)=>iconName;
const $7cc017dd962563cc$export$249aa0c12095aafd = (fileName)=>fileName;
const $7cc017dd962563cc$export$9dd52a3c923cba73 = (mediaIssuer)=>mediaIssuer;
const $7cc017dd962563cc$export$dce78fe68aa68f20 = (mediaIssuer)=>mediaIssuer;
const $7cc017dd962563cc$export$79083a8ab294d28e = (mediaFileUuid)=>mediaFileUuid;
const $7cc017dd962563cc$export$b105972f97cb69fa = (mediaClientId)=>mediaClientId;

});

parcelRegister("cay2q", function(module, exports) {

$parcel$export(module.exports, "mediaInfoForUpload", () => $c8c56b240e08d222$export$c7944179dc1cb15d);
$parcel$export(module.exports, "mediaUploadFile", () => $c8c56b240e08d222$export$6fba374ded90c76b);
$parcel$export(module.exports, "mediaInfoForPulling", () => $c8c56b240e08d222$export$4138ca7fa1c5dcbc);
$parcel$export(module.exports, "mediaGetFileInfo", () => $c8c56b240e08d222$export$c607c6f99a3a53ca);
$parcel$export(module.exports, "publishNewIcon", () => $c8c56b240e08d222$export$a7fc7d8db8ccf9da);

var $eI5EY = parcelRequire("eI5EY");

var $lRmyA = parcelRequire("lRmyA");

var $jYhNy = parcelRequire("jYhNy");
const $c8c56b240e08d222$export$336c36f125eba39c = ({ issuer: issuer, clientId: clientId, mediaJwtToken: mediaJwtToken })=>(0, $eI5EY.fg)('assets_rearch_media_client_auth') ? {
        'X-Client-Id': clientId,
        Authorization: `Bearer ${mediaJwtToken}`
    } : {
        'X-Issuer': issuer,
        Authorization: `Bearer ${mediaJwtToken}`
    };
const $c8c56b240e08d222$export$c7944179dc1cb15d = (workspaceId)=>(0, $lRmyA.performGetRequest)((0, $jYhNy.getCmdbIconTokenUploadingUrl)(workspaceId));
const $c8c56b240e08d222$export$6fba374ded90c76b = ({ mediaBaseUrl: mediaBaseUrl, collectionId: collectionId, fileName: fileName, issuer: // Remove when cleaning up assets_rearch_media_client_auth
issuer, mediaJwtToken: mediaJwtToken, blob: blob, clientId: clientId })=>(0, $lRmyA.performPostRequest)(`${String(mediaBaseUrl)}/file/binary?collection=${String(collectionId)}&name=${String(fileName)}&deletable=true`, {
        headers: {
            ...$c8c56b240e08d222$export$336c36f125eba39c({
                issuer: issuer,
                clientId: clientId,
                mediaJwtToken: mediaJwtToken
            }),
            'Content-Type': blob.type
        },
        body: blob
    });
const $c8c56b240e08d222$export$4138ca7fa1c5dcbc = (workspaceId, fileUuid)=>(0, $lRmyA.performGetRequest)((0, $jYhNy.getCmdbIconTokenFetchingUrl)(workspaceId, fileUuid));
const $c8c56b240e08d222$export$c607c6f99a3a53ca = ({ mediaBaseUrl: mediaBaseUrl, mediaFileUuid: mediaFileUuid, issuer: // Remove when cleaning up assets_rearch_media_client_auth
issuer, mediaJwtToken: mediaJwtToken, clientId: clientId })=>(0, $lRmyA.performGetRequest)(`${String(mediaBaseUrl)}/file/${String(mediaFileUuid)}`, {
        headers: $c8c56b240e08d222$export$336c36f125eba39c({
            issuer: issuer,
            clientId: clientId,
            mediaJwtToken: mediaJwtToken
        })
    });
const $c8c56b240e08d222$export$a7fc7d8db8ccf9da = (workspaceId, iconName, mediaFileUuid)=>(0, $lRmyA.performPostRequest)((0, $jYhNy.getCmdbIconCreateUrl)(workspaceId), {
        body: JSON.stringify({
            name: iconName,
            mediaFileUuid: mediaFileUuid
        })
    });

});
parcelRegister("jYhNy", function(module, exports) {

$parcel$export(module.exports, "getCmdbIconCreateUrl", () => $f9a9ebd5803f1f9d$export$4c6ff27b48881aba);
$parcel$export(module.exports, "getCmdbIconTokenFetchingUrl", () => $f9a9ebd5803f1f9d$export$39e83f10cc93fe99);
$parcel$export(module.exports, "getCmdbIconTokenUploadingUrl", () => $f9a9ebd5803f1f9d$export$7fdc9cd59a492763);
$parcel$export(module.exports, "getCmdbIconByIdUrl", () => $f9a9ebd5803f1f9d$export$b881a625e1bc4876);

var $cPk3F = parcelRequire("cPk3F");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/icon
 */ const $f9a9ebd5803f1f9d$var$getCmdbIconUrl = (workspaceId)=>`${(0, $cPk3F.getCmdbRestBaseUrl)(workspaceId)}/icon`;
const $f9a9ebd5803f1f9d$export$4c6ff27b48881aba = (workspaceId)=>`${$f9a9ebd5803f1f9d$var$getCmdbIconUrl(workspaceId)}/create`;
const $f9a9ebd5803f1f9d$export$39e83f10cc93fe99 = (workspaceId, fileUuid)=>`${$f9a9ebd5803f1f9d$var$getCmdbIconUrl(workspaceId)}/token-for-fetching-icon/${fileUuid}`;
const $f9a9ebd5803f1f9d$export$7fdc9cd59a492763 = (workspaceId)=>`${$f9a9ebd5803f1f9d$var$getCmdbIconUrl(workspaceId)}/token-for-uploading-icon`;
const $f9a9ebd5803f1f9d$export$b881a625e1bc4876 = (workspaceId, iconId)=>`${$f9a9ebd5803f1f9d$var$getCmdbIconUrl(workspaceId)}/${iconId}`;

});



parcelRegister("3RC13", function(module, exports) {

$parcel$export(module.exports, "createReferenceType", () => $0a0e0d6608d85b4f$export$ac28770630794807);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $bBzuE = parcelRequire("bBzuE");
const $0a0e0d6608d85b4f$export$ac28770630794807 = (data)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                createLoading: true
            }
        });
        try {
            const response = await (0, $lRmyA.performPostRequest)((0, $bBzuE.getCmdbConfigReferenceTypeUrl)(workspaceId), {
                body: JSON.stringify({
                    ...data,
                    color: data.color.replace('#', '')
                })
            });
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    createLoading: false,
                    data: [
                        ...state.referenceTypes.data ?? [],
                        response
                    ]
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'createReferenceType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    createLoading: false,
                    createError: error
                }
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'createReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("bBzuE", function(module, exports) {

$parcel$export(module.exports, "getCmdbConfigStatusTypeUrl", () => $8ec0a062f944bbea$export$3269d36b59c9d27f);
$parcel$export(module.exports, "getCmdbConfigStatusTypeByIdUrl", () => $8ec0a062f944bbea$export$229964acb6a55e5);
$parcel$export(module.exports, "getCmdbConfigStatusTypePickerUrl", () => $8ec0a062f944bbea$export$1991fb4d07b18469);
$parcel$export(module.exports, "getCmdbConfigReferenceTypeUrl", () => $8ec0a062f944bbea$export$ad07341c88d2bbab);
$parcel$export(module.exports, "getCmdbConfigReferenceTypeByIdUrl", () => $8ec0a062f944bbea$export$293e2bfa6752a2aa);
$parcel$export(module.exports, "getCmdbConfigRoleByIdUrl", () => $8ec0a062f944bbea$export$225d5f547cc90d86);
$parcel$export(module.exports, "getCmdbConfigRoleObjectSchemaByIdUrl", () => $8ec0a062f944bbea$export$9c1d73050da32aae);
$parcel$export(module.exports, "getCmdbConfigRoleObjectTypeByIdUrl", () => $8ec0a062f944bbea$export$6583ed007df50d2b);
$parcel$export(module.exports, "getCmdbPermsPrincipalUrl", () => $8ec0a062f944bbea$export$a635e2e9382b1621);
$parcel$export(module.exports, "getCmdbPermsRoleAssignmentUrl", () => $8ec0a062f944bbea$export$b3cb4590859563b0);
$parcel$export(module.exports, "getCmdbPermsTokenStatusUrl", () => $8ec0a062f944bbea$export$8ae00db5fd7218c5);
$parcel$export(module.exports, "getMyDataManagerRolesUrl", () => $8ec0a062f944bbea$export$794aa3ae46133f30);

var $53ciZ = parcelRequire("53ciZ");

var $cPk3F = parcelRequire("cPk3F");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/config
 */ const $8ec0a062f944bbea$var$getCmdbConfigUrl = (workspaceId)=>`${(0, $cPk3F.getCmdbRestBaseUrl)(workspaceId)}/config`;
const $8ec0a062f944bbea$export$3269d36b59c9d27f = (workspaceId, queryParams)=>`${$8ec0a062f944bbea$var$getCmdbConfigUrl(workspaceId)}/statustype${queryParams ? `?${(0, $53ciZ.stringify)(queryParams)}` : ''}`;
const $8ec0a062f944bbea$export$229964acb6a55e5 = (workspaceId, statusTypeId)=>`${$8ec0a062f944bbea$var$getCmdbConfigUrl(workspaceId)}/statustype/${statusTypeId}`;
const $8ec0a062f944bbea$export$1991fb4d07b18469 = (workspaceId, queryParams)=>`${$8ec0a062f944bbea$var$getCmdbConfigUrl(workspaceId)}/statustype/picker?${(0, $53ciZ.stringify)(queryParams)}`;
const $8ec0a062f944bbea$export$ad07341c88d2bbab = (workspaceId, queryParams)=>`${$8ec0a062f944bbea$var$getCmdbConfigUrl(workspaceId)}/referencetype${queryParams ? `?${(0, $53ciZ.stringify)(queryParams)}` : ''}`;
const $8ec0a062f944bbea$export$293e2bfa6752a2aa = (workspaceId, referenceTypeId)=>`${$8ec0a062f944bbea$var$getCmdbConfigUrl(workspaceId)}/referencetype/${referenceTypeId}`;
const $8ec0a062f944bbea$export$225d5f547cc90d86 = (workspaceId, roleId)=>`${$8ec0a062f944bbea$var$getCmdbConfigUrl(workspaceId)}/role/${roleId}`;
const $8ec0a062f944bbea$export$9c1d73050da32aae = (workspaceId, objectSchemaId)=>`${$8ec0a062f944bbea$var$getCmdbConfigUrl(workspaceId)}/role/objectschema/${objectSchemaId}`;
const $8ec0a062f944bbea$export$6583ed007df50d2b = (workspaceId, objectTypeId)=>`${$8ec0a062f944bbea$var$getCmdbConfigUrl(workspaceId)}/role/objecttype/${objectTypeId}`;
const $8ec0a062f944bbea$export$a635e2e9382b1621 = (workspaceId)=>`${$8ec0a062f944bbea$var$getCmdbConfigUrl(workspaceId)}/perms/principal`;
const $8ec0a062f944bbea$export$b3cb4590859563b0 = (workspaceId)=>`${$8ec0a062f944bbea$var$getCmdbConfigUrl(workspaceId)}/perms/role-assignment`;
const $8ec0a062f944bbea$export$8ae00db5fd7218c5 = (workspaceId, token)=>`${$8ec0a062f944bbea$var$getCmdbConfigUrl(workspaceId)}/perms/token-status?token=${token}`;
const $8ec0a062f944bbea$export$794aa3ae46133f30 = (workspaceId)=>`${$8ec0a062f944bbea$var$getCmdbConfigUrl(workspaceId)}/perms/my-roles`;

});


parcelRegister("kVrCm", function(module, exports) {

$parcel$export(module.exports, "createStatusType", () => $1ea57bc351743daa$export$8c874b16a69a1b9d);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $bBzuE = parcelRequire("bBzuE");
const $1ea57bc351743daa$export$8c874b16a69a1b9d = (data)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                createLoading: true
            }
        });
        try {
            const response = await (0, $lRmyA.performPostRequest)((0, $bBzuE.getCmdbConfigStatusTypeUrl)(workspaceId), {
                body: JSON.stringify(data)
            });
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    createLoading: false,
                    data: [
                        ...state.statusTypes.data ?? [],
                        response
                    ]
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                source: 'insightGlobalConfigStatuses',
                action: 'created',
                actionSubject: 'insightGlobalConfigStatuses'
            }), 'insightGlobalConfigStatuses created');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    createLoading: false,
                    createError: error
                }
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'createStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("lHKef", function(module, exports) {

$parcel$export(module.exports, "deleteIcon", () => $06bbeacf93a5444c$export$12d45ee5c2161b75);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $jYhNy = parcelRequire("jYhNy");
const $06bbeacf93a5444c$export$12d45ee5c2161b75 = (icon)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                deleteLoading: true
            }
        });
        try {
            await (0, $lRmyA.performDeleteRequest)((0, $jYhNy.getCmdbIconByIdUrl)(workspaceId, icon.id));
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    deleteLoading: false,
                    data: state.icons.data ? state.icons.data.filter(({ id: id })=>id !== icon.id) : undefined
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteIcon succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'deleteIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("bKKjD", function(module, exports) {

$parcel$export(module.exports, "deleteReferenceType", () => $0fac74dfcde7ad27$export$432ee1f3819316e5);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $bBzuE = parcelRequire("bBzuE");
const $0fac74dfcde7ad27$export$432ee1f3819316e5 = (referenceType)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                deleteLoading: true
            }
        });
        try {
            await (0, $lRmyA.performDeleteRequest)((0, $bBzuE.getCmdbConfigReferenceTypeByIdUrl)(workspaceId, referenceType.id));
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    deleteLoading: false,
                    data: state.referenceTypes.data ? state.referenceTypes.data.filter(({ id: id })=>id !== referenceType.id) : undefined
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteReferenceType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'deleteReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("gQ1QW", function(module, exports) {

$parcel$export(module.exports, "deleteStatusType", () => $f5bb9fb5af1dad1b$export$812423dc05f0fc3d);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $bBzuE = parcelRequire("bBzuE");
const $f5bb9fb5af1dad1b$export$812423dc05f0fc3d = (statusType)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                deleteLoading: true
            }
        });
        try {
            await (0, $lRmyA.performDeleteRequest)((0, $bBzuE.getCmdbConfigStatusTypeByIdUrl)(workspaceId, statusType.id));
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    deleteLoading: false,
                    data: state.statusTypes.data ? state.statusTypes.data.filter(({ id: id })=>id !== statusType.id) : undefined
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteStatusType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'deleteStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("elM5U", function(module, exports) {

$parcel$export(module.exports, "fetchGlobalConfig", () => $eddcab4064590007$export$14c75ba3f0e48e21);

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $fb5pE = parcelRequire("fb5pE");

var $jlfMg = parcelRequire("jlfMg");

const $eddcab4064590007$export$14c75ba3f0e48e21 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().loading || !shouldRefetch && getState().config) return;
        setState({
            loading: true,
            error: undefined
        });
        try {
            const response = await (0, $lRmyA.performGetRequest)((0, $jlfMg.getCmdbGlobalConfigUrl)(workspaceId));
            let dataManagerGAFeatureFlagResponse = false;
            if ((0, $1ybV0.ff)('jsm-cmdb-airtrack-call-feature-gate-backend_rdd53')) try {
                dataManagerGAFeatureFlagResponse = await (0, $lRmyA.performGetRequest)((0, $fb5pE.getDataManagerFeatureFlagStatusByName)(workspaceId, (0, $1a426604eb5f44c6$export$2f383dcad349f1af)));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'fetchDataManagerGAFeatureFlag',
                        packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                        teamName: 'falcons'
                    },
                    error: error
                });
            }
            const iconListWithServiceOTEntriesRemoved = response ? response.icons.filter((item)=>item.name !== 'Applications' && item.name !== 'Business Services' && item.name !== 'Capabilities' && item.name !== 'Software Services') : undefined;
            setState({
                loading: false,
                config: {
                    ...response,
                    restrictedObjectSchemaIds: response?.restrictedObjectSchemaIds ?? [],
                    icons: iconListWithServiceOTEntriesRemoved || []
                },
                referenceTypes: {
                    ...getState().referenceTypes,
                    data: response ? response.referenceTypes : undefined
                },
                statusTypes: {
                    ...getState().statusTypes,
                    data: response ? response.statusTypes : undefined
                },
                icons: {
                    ...getState().icons,
                    data: iconListWithServiceOTEntriesRemoved
                },
                dataManager: {
                    ...getState().dataManager,
                    featureFlags: {
                        ...getState().dataManager.featureFlags,
                        [(0, $1a426604eb5f44c6$export$2f383dcad349f1af)]: dataManagerGAFeatureFlagResponse
                    }
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchInsightGlobalConfig succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchInsightGlobalConfig',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("fb5pE", function(module, exports) {

$parcel$export(module.exports, "getDataManagerGenerateContainerTokenUrl", () => $d0e3942bcc670c3c$export$5f42b4e80a66d7c);
$parcel$export(module.exports, "delDataManagerContainerTokenUrl", () => $d0e3942bcc670c3c$export$ddc5a4cb751fae27);
$parcel$export(module.exports, "getDataManagerFetchContainerTokenUrl", () => $d0e3942bcc670c3c$export$591d877d695dbd95);
$parcel$export(module.exports, "getDataManagerProvisioningStatusUrl", () => $d0e3942bcc670c3c$export$1dd01c50c7948938);
$parcel$export(module.exports, "getDataManagerFeatureFlagStatusByName", () => $d0e3942bcc670c3c$export$29064f12afd3bee);

var $cPk3F = parcelRequire("cPk3F");
const $d0e3942bcc670c3c$export$5f42b4e80a66d7c = (workspaceId, label, type, duration)=>`${(0, $cPk3F.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token/${type}?label=${label}&duration=${duration}`;
const $d0e3942bcc670c3c$export$ddc5a4cb751fae27 = (workspaceId, tokenID)=>`${(0, $cPk3F.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token/${tokenID}`;
const $d0e3942bcc670c3c$export$591d877d695dbd95 = (workspaceId)=>`${(0, $cPk3F.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token`;
const $d0e3942bcc670c3c$export$1dd01c50c7948938 = (workspaceId)=>`${$d0e3942bcc670c3c$var$getAirtrackAppRestBaseUrl(workspaceId)}/config/sync/provisioningstatus`;
const $d0e3942bcc670c3c$export$29064f12afd3bee = (workspaceId, featureFlagName)=>`${$d0e3942bcc670c3c$var$getAirtrackAppRestBaseUrl(workspaceId)}/config/featuregate/${featureFlagName}`;
const $d0e3942bcc670c3c$var$getAirtrackAppRestBaseUrl = (workspaceId)=>`/gateway/api/jsm/data-manager/workspace/${workspaceId}/app`;

});

parcelRegister("jlfMg", function(module, exports) {

$parcel$export(module.exports, "getCmdbGlobalConfigUrl", () => $269a79357acf4f3e$export$50437136a9a5e2d3);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectUrl", () => $269a79357acf4f3e$export$73e58b72a1074528);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectSchemaByIdUrl", () => $269a79357acf4f3e$export$e2019224257efde3);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectSchemaByIdPropertyUrl", () => $269a79357acf4f3e$export$d1b25f8feb06db8a);

var $53ciZ = parcelRequire("53ciZ");

var $cPk3F = parcelRequire("cPk3F");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/global
 */ const $269a79357acf4f3e$var$getCmdbGlobalUrl = (workspaceId)=>`${(0, $cPk3F.getCmdbRestBaseUrl)(workspaceId)}/global`;
const $269a79357acf4f3e$export$50437136a9a5e2d3 = (workspaceId)=>`${$269a79357acf4f3e$var$getCmdbGlobalUrl(workspaceId)}/config`;
const $269a79357acf4f3e$export$73e58b72a1074528 = (workspaceId, queryParams)=>`${$269a79357acf4f3e$var$getCmdbGlobalUrl(workspaceId)}/config/object?${(0, $53ciZ.stringify)(queryParams)}`;
const $269a79357acf4f3e$export$e2019224257efde3 = (workspaceId, objectSchemaId)=>`${$269a79357acf4f3e$var$getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}`;
const $269a79357acf4f3e$export$d1b25f8feb06db8a = (workspaceId, objectSchemaId)=>`${$269a79357acf4f3e$var$getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}/property`;

});

const $1a426604eb5f44c6$export$2f383dcad349f1af = 'airtrack_provisioning_for_ga';


parcelRegister("gFwZd", function(module, exports) {

$parcel$export(module.exports, "fetchMyDataManagerRoles", () => $3581fa1115c315a4$export$2211f294ebd95b92);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $bBzuE = parcelRequire("bBzuE");
const $3581fa1115c315a4$export$2211f294ebd95b92 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().dataManager.myRolesLoading || !shouldRefetch && getState().dataManager.myRoles) return;
        setState({
            dataManager: {
                ...getState().dataManager,
                myRolesLoading: true,
                myRolesError: undefined
            }
        });
        try {
            const myRoles = await (0, $lRmyA.performGetRequest)((0, $bBzuE.getMyDataManagerRolesUrl)(workspaceId));
            setState({
                dataManager: {
                    ...getState().dataManager,
                    myRoles: myRoles.results,
                    myRolesLoading: false
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchMyDataManagerRoles succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                dataManager: {
                    ...getState().dataManager,
                    myRolesLoading: false,
                    myRolesError: error
                }
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchMyDataManagerRoles',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("3G3H1", function(module, exports) {

$parcel$export(module.exports, "fetchPrincipalsForRoles", () => $674b314aaf9c2aab$export$9c5110cfdcb72b5);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $bBzuE = parcelRequire("bBzuE");
const $674b314aaf9c2aab$export$9c5110cfdcb72b5 = (roleIds)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.rolesLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                rolesLoading: true
            }
        });
        try {
            const requestBody = {
                roleIds: roleIds,
                resourceId: `ari:cloud:cmdb::workspace/${workspaceId}`
            };
            const principalIdsForRoles = await (0, $lRmyA.performPostRequest)((0, $bBzuE.getCmdbPermsPrincipalUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            setState({
                dataManager: {
                    ...state.dataManager,
                    rolesData: principalIdsForRoles.results,
                    rolesLoading: false
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchPrincipalsForRoles succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesLoading: false,
                    rolesError: error
                }
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchPrincipalsForRoles',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("e0su3", function(module, exports) {

$parcel$export(module.exports, "fetchProvisioningStatus", () => $1af28ae2ed3c6b5e$export$aa3ea988cce42be1);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $fb5pE = parcelRequire("fb5pE");
const $1af28ae2ed3c6b5e$export$aa3ea988cce42be1 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().dataManager.provisioningLoading || !shouldRefetch && // isProvisioned is a boolean so needs to specifically check undefined
        getState().dataManager.isProvisioned !== undefined) return;
        setState({
            dataManager: {
                ...getState().dataManager,
                provisioningLoading: true,
                provisioningError: undefined
            }
        });
        try {
            const result = await (0, $lRmyA.performGetRequest)((0, $fb5pE.getDataManagerProvisioningStatusUrl)(workspaceId));
            setState({
                dataManager: {
                    ...getState().dataManager,
                    isProvisioned: $1af28ae2ed3c6b5e$var$isProvisioned(result.enabled),
                    provisioningLoading: false
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchProvisioningStatus succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                dataManager: {
                    ...getState().dataManager,
                    provisioningLoading: false,
                    provisioningError: error
                }
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchProvisioningStatus',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };
const $1af28ae2ed3c6b5e$var$isProvisioned = (status)=>status === 'ON';

});

parcelRegister("eNd91", function(module, exports) {

$parcel$export(module.exports, "fetchDataManagerTokens", () => $192851d61e24f951$export$c6b3de84befa4259);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $fb5pE = parcelRequire("fb5pE");
const $192851d61e24f951$export$c6b3de84befa4259 = ()=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.tokensLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                tokensLoading: true
            }
        });
        try {
            const tokenDetails = await (0, $lRmyA.performGetRequest)((0, $fb5pE.getDataManagerFetchContainerTokenUrl)(workspaceId));
            setState({
                dataManager: {
                    ...state.dataManager,
                    tokensData: tokenDetails.tokens,
                    tokensLoading: false
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchDataManagerTokens succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    tokensLoading: false,
                    tokensError: error
                }
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchDataManagerTokens',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("kxMnp", function(module, exports) {

$parcel$export(module.exports, "updateDataManagerRole", () => $0ce2b8ab79f19cc9$export$314337b594e79a51);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $bBzuE = parcelRequire("bBzuE");
const $0ce2b8ab79f19cc9$export$93aad6482f82f57d = 5000;
const $0ce2b8ab79f19cc9$export$214f23982cabf5f8 = 1000;
const $0ce2b8ab79f19cc9$export$314337b594e79a51 = ({ principalIds: principalIds, roleId: roleId })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.rolesUpdateLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                rolesUpdateLoading: true
            }
        });
        try {
            const requestBody = {
                principalIds: principalIds,
                roleId: roleId,
                resourceType: 'workspace'
            };
            const updateRolesResponse = await (0, $lRmyA.performPutRequest)((0, $bBzuE.getCmdbPermsRoleAssignmentUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            const pollTimeoutTime = new Date(Date.now() + $0ce2b8ab79f19cc9$export$93aad6482f82f57d).getTime();
            // poll the checking of the token status for 5 seconds as updating of
            // Identity role assignments have eventually consistency
            const tryPollTokenStatus = async (resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
            reject)=>{
                if (Date.now() > pollTimeoutTime) {
                    reject(new Error('Some role assignments have failed or is still in progress'));
                    return;
                }
                try {
                    const url = (0, $bBzuE.getCmdbPermsTokenStatusUrl)(workspaceId, updateRolesResponse.tokens[updateRolesResponse.tokens.length - 1]);
                    const updateRoleAssignmentToken = await (0, $lRmyA.performGetRequest)(url);
                    if (updateRoleAssignmentToken.isSuccessful) {
                        resolve();
                        return;
                    }
                    setTimeout(()=>{
                        tryPollTokenStatus(resolve, reject);
                    }, $0ce2b8ab79f19cc9$export$214f23982cabf5f8);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    // Ignore unexpected network/server error and quickly retry
                    setTimeout(()=>{
                        tryPollTokenStatus(resolve, reject);
                    }, $0ce2b8ab79f19cc9$export$214f23982cabf5f8);
                }
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            await new Promise((res, rej)=>tryPollTokenStatus(res, rej));
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesUpdateLoading: false
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateDataManagerRole succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesUpdateLoading: false,
                    rolesUpdateError: error
                }
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'updateDataManagerRole',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("7I5Kf", function(module, exports) {

$parcel$export(module.exports, "setIcon", () => $92c131bc4e24978a$export$33914de34c28be6c);
$parcel$export(module.exports, "updateIcon", () => $92c131bc4e24978a$export$89ea7ff652eb14dd);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $jYhNy = parcelRequire("jYhNy");
const $92c131bc4e24978a$export$33914de34c28be6c = (updatedIcon)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.icons.data?.map((icon)=>icon.id === updatedIcon.id ? updatedIcon : icon);
        setState({
            ...state,
            icons: {
                ...state.icons,
                data: updatedData
            }
        });
    };
const $92c131bc4e24978a$export$89ea7ff652eb14dd = ({ iconId: iconId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $lRmyA.performPutRequest)((0, $jYhNy.getCmdbIconByIdUrl)(workspaceId, iconId), {
                body: JSON.stringify(updatedProperties)
            });
            const updatedState = getState();
            const updatedData = updatedState.icons.data?.map((icon)=>icon.id === response.id ? response : icon);
            setState({
                ...updatedState,
                icons: {
                    ...updatedState.icons,
                    updateLoading: false,
                    data: updatedData
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateIcon succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                icons: {
                    ...updatedState.icons,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'updateIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("1LS4F", function(module, exports) {

$parcel$export(module.exports, "updateProvisioningStatus", () => $e459a60daf24de18$export$ae3c5292a85a06f4);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $fb5pE = parcelRequire("fb5pE");
const $e459a60daf24de18$export$ae3c5292a85a06f4 = ({ isEnabled: isEnabled })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.provisioningUpdateLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                isProvisioned: isEnabled,
                provisioningUpdateLoading: true
            }
        });
        try {
            const requestBody = {
                enabled: isEnabled
            };
            await (0, $lRmyA.performPutRequest)((0, $fb5pE.getDataManagerProvisioningStatusUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            const result = await (0, $lRmyA.performGetRequest)((0, $fb5pE.getDataManagerProvisioningStatusUrl)(workspaceId));
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    isProvisioned: result.enabled === 'ON',
                    provisioningUpdateLoading: false
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateProvisioningStatus succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    provisioningUpdateLoading: false,
                    provisioningUpdateError: error
                }
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'updateProvisioningStatus',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("id6f8", function(module, exports) {

$parcel$export(module.exports, "setReferenceType", () => $bc93d8127bbce576$export$7c6efce0302318d);
$parcel$export(module.exports, "updateReferenceType", () => $bc93d8127bbce576$export$f9e29a0f21a33136);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $bBzuE = parcelRequire("bBzuE");
const $bc93d8127bbce576$export$7c6efce0302318d = (updatedReferenceType)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.referenceTypes.data?.map((referenceType)=>referenceType.id === updatedReferenceType.id ? updatedReferenceType : referenceType);
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                data: updatedData
            }
        });
    };
const $bc93d8127bbce576$export$f9e29a0f21a33136 = ({ referenceTypeId: referenceTypeId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $lRmyA.performPutRequest)((0, $bBzuE.getCmdbConfigReferenceTypeByIdUrl)(workspaceId, referenceTypeId), {
                body: JSON.stringify({
                    ...updatedProperties,
                    color: updatedProperties.color !== undefined ? updatedProperties.color.replace('#', '') : undefined
                })
            });
            const updatedState = getState();
            const updatedData = updatedState.referenceTypes.data?.map((referenceType)=>referenceType.id === response.id ? response : referenceType);
            setState({
                ...updatedState,
                referenceTypes: {
                    ...updatedState.referenceTypes,
                    updateLoading: false,
                    data: updatedData || undefined
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateReferenceType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                referenceTypes: {
                    ...updatedState.referenceTypes,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'updateReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("7bZq7", function(module, exports) {

$parcel$export(module.exports, "setStatusType", () => $07f4cc40799f402a$export$80a24939e43be67c);
$parcel$export(module.exports, "updateStatusType", () => $07f4cc40799f402a$export$2174575c3f57e8f8);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $bBzuE = parcelRequire("bBzuE");
const $07f4cc40799f402a$export$80a24939e43be67c = (updatedStatusType)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.statusTypes.data?.map((statusType)=>statusType.id === updatedStatusType.id ? updatedStatusType : statusType);
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                data: updatedData
            }
        });
    };
const $07f4cc40799f402a$export$2174575c3f57e8f8 = ({ statusTypeId: statusTypeId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $lRmyA.performPutRequest)((0, $bBzuE.getCmdbConfigStatusTypeByIdUrl)(workspaceId, statusTypeId), {
                body: JSON.stringify(updatedProperties)
            });
            const updatedState = getState();
            const updatedData = updatedState.statusTypes.data?.map((statusType)=>statusType.id === response.id ? response : statusType);
            setState({
                ...updatedState,
                statusTypes: {
                    ...updatedState.statusTypes,
                    updateLoading: false,
                    data: updatedData || undefined
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateStatusType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                statusTypes: {
                    ...updatedState.statusTypes,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'updateStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});


parcelRegister("gk6Gt", function(module, exports) {

$parcel$export(module.exports, "sortReferenceTypes", () => $a4c69c320e3ede45$export$7e55dd84e7cc0829);
$parcel$export(module.exports, "sortStatusTypes", () => $a4c69c320e3ede45$export$5f25bb3183b5823d);
const $a4c69c320e3ede45$export$7e55dd84e7cc0829 = (referenceTypes)=>referenceTypes.sort((a, b)=>a.name.localeCompare(b.name)).sort((a, b)=>{
        if (a.removable === b.removable) return 0;
        return a.removable ? 1 : -1;
    });
const $a4c69c320e3ede45$export$5f25bb3183b5823d = (statusTypes)=>statusTypes.sort((a, b)=>a.name.localeCompare(b.name));

});


parcelRegister("hqVAg", function(module, exports) {

$parcel$export(module.exports, "useLandingPageState", () => $d7270d5aea4adaf7$export$687b2bc7971fc6ba);
$parcel$export(module.exports, "InsightLandingPageContainer", () => $d7270d5aea4adaf7$export$45375f66f83e006e);

var $WBLbN = parcelRequire("WBLbN");

var $k2Lrl = parcelRequire("k2Lrl");
const $d7270d5aea4adaf7$var$initialState = {
    schemaState: {
        type: 'loading'
    },
    recentObjectState: {
        type: 'loading'
    }
};
const $d7270d5aea4adaf7$var$Store = (0, $WBLbN.createStore)({
    initialState: $d7270d5aea4adaf7$var$initialState,
    actions: $k2Lrl.actions
});
const $d7270d5aea4adaf7$export$687b2bc7971fc6ba = (0, $WBLbN.createHook)($d7270d5aea4adaf7$var$Store, {
    selector: (state)=>state
});
const $d7270d5aea4adaf7$export$fe0bccfd53a856df = ()=>async ({ dispatch: dispatch })=>{
        await Promise.all([
            dispatch((0, $k2Lrl.actions).fetchRecentObjects()),
            dispatch((0, $k2Lrl.actions).fetchSchemas())
        ]);
    };
const $d7270d5aea4adaf7$export$45375f66f83e006e = (0, $WBLbN.createContainer)($d7270d5aea4adaf7$var$Store, {
    onInit: $d7270d5aea4adaf7$export$fe0bccfd53a856df
});

});
parcelRegister("k2Lrl", function(module, exports) {

$parcel$export(module.exports, "actions", () => $37c1ae447d6966b2$export$e324594224ef24da);

var $6kNsH = parcelRequire("6kNsH");

var $hdDkH = parcelRequire("hdDkH");

var $ejvjy = parcelRequire("ejvjy");
const $37c1ae447d6966b2$export$e324594224ef24da = {
    fetchSchemas: $hdDkH.fetchSchemas,
    fetchRecentObjects: $6kNsH.fetchRecentObjects,
    insertCreatedSchema: $ejvjy.insertCreatedSchema
};

});
parcelRegister("6kNsH", function(module, exports) {

$parcel$export(module.exports, "fetchRecentObjects", () => $6aa8ceeb5a99b26e$export$e90246a6e71788c9);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $eEeZ0 = parcelRequire("eEeZ0");

var $3au1i = parcelRequire("3au1i");
const $6aa8ceeb5a99b26e$export$40097b1e4a3beaba = 20;
const $6aa8ceeb5a99b26e$export$e90246a6e71788c9 = ()=>async ({ setState: setState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        try {
            const response = await (0, $lRmyA.performGetRequest)((0, $eEeZ0.getCmdbObjectRecentUrl)(workspaceId, {
                maxResults: $6aa8ceeb5a99b26e$export$40097b1e4a3beaba
            }));
            setState({
                recentObjectState: {
                    type: 'success',
                    recentObjects: response.values
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchRecentObjects succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const typesafeError = (0, $3au1i.createTypesafeErrorForAnalytics)(error);
            setState({
                recentObjectState: {
                    type: 'error',
                    error: typesafeError.error
                }
            });
            (0, $guiFP.default)({
                error: typesafeError.isSafeForAnalytics ? typesafeError.error : undefined,
                meta: {
                    id: 'fetchRecentObjects',
                    packageName: 'jiraServicedeskInsightLandingPageStore',
                    teamName: 'falcons'
                }
            });
        }
    };

});
parcelRegister("3au1i", function(module, exports) {

$parcel$export(module.exports, "createTypesafeErrorForAnalytics", () => $dc340fc6cee0d534$export$219f044aaadd3095);
const $dc340fc6cee0d534$export$219f044aaadd3095 = (error)=>{
    let isSafeForAnalytics = false;
    const typesafeError = error instanceof Error ? error : new Error('Unknown error');
    try {
        JSON.parse(typesafeError.message);
        isSafeForAnalytics = true;
    } catch (e) {
        isSafeForAnalytics = false;
    }
    return {
        error: typesafeError,
        isSafeForAnalytics: isSafeForAnalytics
    };
};

});


parcelRegister("hdDkH", function(module, exports) {

$parcel$export(module.exports, "fetchSchemas", () => $68c1e7ffc8b5bd17$export$efff2a18d6c80f6e);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $f44FF = parcelRequire("f44FF");

var $3au1i = parcelRequire("3au1i");
const $68c1e7ffc8b5bd17$export$40097b1e4a3beaba = 1000;
const $68c1e7ffc8b5bd17$export$efff2a18d6c80f6e = ()=>async ({ setState: setState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        try {
            // Currently, Insight returns the list sorted alphabetically by default
            const response = await (0, $lRmyA.performGetRequest)((0, $f44FF.getCmdbObjectSchemaListUrl)(workspaceId, {
                maxResults: $68c1e7ffc8b5bd17$export$40097b1e4a3beaba
            }));
            setState({
                schemaState: {
                    type: 'success',
                    schemas: response.values
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchObjectSchemas succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const typesafeError = (0, $3au1i.createTypesafeErrorForAnalytics)(error);
            setState({
                schemaState: {
                    type: 'error',
                    error: typesafeError.error
                }
            });
            (0, $guiFP.default)({
                error: typesafeError.isSafeForAnalytics ? typesafeError.error : undefined,
                meta: {
                    id: 'fetchSchemas',
                    packageName: 'jiraServicedeskInsightLandingPageStore',
                    teamName: 'falcons'
                }
            });
        }
    };

});
parcelRegister("f44FF", function(module, exports) {

$parcel$export(module.exports, "getCmdbObjectSchemaByIdUrl", () => $8b74095526959e30$export$7a8f746315e81598);
$parcel$export(module.exports, "getCmdbObjectSchemaByIdObjectTypesUrl", () => $8b74095526959e30$export$40fed922a68615f0);
$parcel$export(module.exports, "getCmdbObjectSchemaByIdObjectTypesFlatUrl", () => $8b74095526959e30$export$ba2d9684559c6a7);
$parcel$export(module.exports, "getCmdbObjectSchemaAllObjectTypesFlatUrl", () => $8b74095526959e30$export$5feed0fbe07a00c4);
$parcel$export(module.exports, "getCmdbObjectSchemaCreateUrl", () => $8b74095526959e30$export$f3ba592db0974a77);
$parcel$export(module.exports, "getCmdbObjectSchemaListUrl", () => $8b74095526959e30$export$e92eb77a52cdaa41);
$parcel$export(module.exports, "getCmdbFindAllAttributesUrl", () => $8b74095526959e30$export$6ffa97ba17b941e9);

var $53ciZ = parcelRequire("53ciZ");

var $cPk3F = parcelRequire("cPk3F");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/objectschema
 */ const $8b74095526959e30$var$getCmdbObjectSchemaUrl = (workspaceId)=>`${(0, $cPk3F.getCmdbRestBaseUrl)(workspaceId)}/objectschema`;
const $8b74095526959e30$export$7a8f746315e81598 = (workspaceId, schemaId)=>`${$8b74095526959e30$var$getCmdbObjectSchemaUrl(workspaceId)}/${schemaId}`;
const $8b74095526959e30$export$40fed922a68615f0 = (workspaceId, schemaId, queryParams)=>`${$8b74095526959e30$export$7a8f746315e81598(workspaceId, schemaId)}/objecttypes?${(0, $53ciZ.stringify)(queryParams)}`;
const $8b74095526959e30$export$ba2d9684559c6a7 = (workspaceId, schemaId, queryParams)=>`${$8b74095526959e30$export$7a8f746315e81598(workspaceId, schemaId)}/objecttypes/flat${queryParams ? `?${(0, $53ciZ.stringify)(queryParams)}` : ''}`;
const $8b74095526959e30$export$5feed0fbe07a00c4 = (workspaceId, schemaId, queryParams)=>`${$8b74095526959e30$var$getCmdbObjectSchemaUrl(workspaceId)}/all/${schemaId}/objecttypes/flat?${(0, $53ciZ.stringify)(queryParams)}`;
const $8b74095526959e30$export$f3ba592db0974a77 = (workspaceId)=>`${$8b74095526959e30$var$getCmdbObjectSchemaUrl(workspaceId)}/create`;
const $8b74095526959e30$export$e92eb77a52cdaa41 = (workspaceId, queryParams)=>`${$8b74095526959e30$var$getCmdbObjectSchemaUrl(workspaceId)}/list?${(0, $53ciZ.stringify)(queryParams)}`;
const $8b74095526959e30$export$6ffa97ba17b941e9 = (workspaceId, schemaId)=>`${(0, $cPk3F.getCmdbRestBaseUrl)(workspaceId)}/objectschema/${schemaId}/attributes?${(0, $53ciZ.stringify)({
        extended: true
    })}`;

});


parcelRegister("ejvjy", function(module, exports) {

$parcel$export(module.exports, "insertCreatedSchema", () => $3c8dc6a34123cf9d$export$1f8e1e114cb40f07);

var $bfFNM = parcelRequire("bfFNM");

var $hdDkH = parcelRequire("hdDkH");
const $3c8dc6a34123cf9d$export$31e3f102b22b5018 = (objectSchemas)=>objectSchemas.sort((a, b)=>a.name.localeCompare(b.name));
const $3c8dc6a34123cf9d$var$clientSideUpdate = (createdSchema, { getState: getState, setState: setState })=>{
    const originalState = (0, $bfFNM.getSchemaStateOrThrow)(getState());
    const updatedSchemas = $3c8dc6a34123cf9d$export$31e3f102b22b5018(originalState.schemas.concat([
        createdSchema
    ]));
    setState({
        schemaState: {
            ...originalState,
            schemas: updatedSchemas
        }
    });
};
const $3c8dc6a34123cf9d$var$serverSideRefresh = ({ dispatch: dispatch })=>{
    dispatch((0, $hdDkH.fetchSchemas)());
};
const $3c8dc6a34123cf9d$export$1f8e1e114cb40f07 = (createdSchema)=>async (storeActionApi)=>{
        $3c8dc6a34123cf9d$var$clientSideUpdate(createdSchema, storeActionApi);
        $3c8dc6a34123cf9d$var$serverSideRefresh(storeActionApi);
    };

});
parcelRegister("bfFNM", function(module, exports) {

$parcel$export(module.exports, "getSchemaStateOrThrow", () => $c29f6da428e07aa4$export$ee89b40e85dd4154);
const $c29f6da428e07aa4$export$ee89b40e85dd4154 = (state)=>{
    const { schemaState: schemaState } = state;
    if (schemaState.type !== 'success') throw new Error(`Unexpected schemaState.type value: ${schemaState.type}`);
    else return schemaState;
};

});




parcelRegister("8FqXR", function(module, exports) {

$parcel$export(module.exports, "LandingPage", () => $ad6045528f40a6ad$export$355f3d6a1f8b250c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bm5l8 = parcelRequire("bm5l8");
var $asKFY = parcelRequire("asKFY");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $cf2Y4 = parcelRequire("cf2Y4");

var $3a8wJ = parcelRequire("3a8wJ");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $heNSb = parcelRequire("heNSb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7JTqr = parcelRequire("7JTqr");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $lB25E = parcelRequire("lB25E");

var $kRB9u = parcelRequire("kRB9u");

var $3yQCW = parcelRequire("3yQCW");

var $lMR3k = parcelRequire("lMR3k");

var $4XCmO = parcelRequire("4XCmO");

var $80nQh = parcelRequire("80nQh");


var $1CIRW = parcelRequire("1CIRW");

var $hqVAg = parcelRequire("hqVAg");

var $lHQ9F = parcelRequire("lHQ9F");

var $5jstg = parcelRequire("5jstg");

var $2AirB = parcelRequire("2AirB");

var $fD30B = parcelRequire("fD30B");

var $aSJew = parcelRequire("aSJew");

var $i35iP = parcelRequire("i35iP");

var $272oI = parcelRequire("272oI");

var $1R3n5 = parcelRequire("1R3n5");

var $cb764 = parcelRequire("cb764");

var $1BawU = parcelRequire("1BawU");

var $aFp4n = parcelRequire("aFp4n");

var $6xc55 = parcelRequire("6xc55");

var $eVv4l = parcelRequire("eVv4l");

var $buK2c = parcelRequire("buK2c");

var $aqMn6 = parcelRequire("aqMn6");
const $ad6045528f40a6ad$export$355f3d6a1f8b250c = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { workspaceId: workspaceId } = (0, $80nQh.useWorkspaceContext)();
    const [{ schemaState: schemaState }] = (0, $hqVAg.useLandingPageState)();
    const [{ config: globalConfigData }] = (0, $1CIRW.useInsightGlobalConfig)();
    const [{ isProvisioned: isProvisioned, provisioningLoading: provisioningLoading, myRoles: myRoles, myRolesLoading: myRolesLoading, provisioningError: provisioningError, myRolesError: myRolesError, featureFlags: featureFlags }, { fetchProvisioningStatus: fetchProvisioningStatus, fetchMyDataManagerRoles: fetchMyDataManagerRoles }] = (0, $1CIRW.useDataManager)();
    const { insightAdministrator: isAdmin, restrictedObjectSchemaIds: restrictedObjectSchemaIds, insightReporting: insightReporting, limitInfo: { objectCount: objectCount, objectLimit: objectLimit, billingCycle: billingCycle, limitState: limitState = 'disabled' } } = globalConfigData ?? {
        insightAdministrator: false,
        restrictedObjectSchemaIds: [],
        insightReporting: false,
        limitInfo: {
            objectCount: 0,
            objectLimit: Number.MAX_SAFE_INTEGER,
            billingCycle: 'monthly',
            limitState: 'disabled'
        }
    };
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const dataManagerLink = (0, $eUqFw.useMemo)(()=>(0, $272oI.getDataManagerUrl)(), []);
    const adaptersLink = (0, $eUqFw.useMemo)(()=>(0, $272oI.getDataManagerAdaptersUrl)(), []);
    const configLink = (0, $eUqFw.useMemo)(()=>(0, $272oI.getGlobalConfigUrl)(), []);
    const reportsLink = (0, $eUqFw.useMemo)(()=>(0, $272oI.getAssetsReportsUrl)(), []); // @ts-expect-error - TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
    const onClickConfigLink = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'servicedeskInsightGlobalConfigPageNavigation');
    }, []); // @ts-expect-error - TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
    const onClickReportsLink = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'servicedeskAssetsReportsPageNavigation');
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (featureFlags?.[0, $1a426604eb5f44c6$export$2f383dcad349f1af] && myRoles === undefined && myRolesLoading !== true && myRolesError === undefined) fetchMyDataManagerRoles();
    }, [
        fetchMyDataManagerRoles,
        myRoles,
        myRolesError,
        myRolesLoading,
        featureFlags
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (featureFlags?.[0, $1a426604eb5f44c6$export$2f383dcad349f1af] && isProvisioned === undefined && provisioningLoading !== true && provisioningError === undefined) fetchProvisioningStatus();
    }, [
        fetchProvisioningStatus,
        isProvisioned,
        provisioningError,
        provisioningLoading,
        featureFlags
    ]);
    if (!workspaceId) return null;
    const showDataManagerLink = ()=>{
        if (featureFlags?.[0, $1a426604eb5f44c6$export$2f383dcad349f1af] && isProvisioned && myRoles) {
            const hasDMRoles = myRoles.some((myRole)=>(0, $fD30B.DATA_MANAGER_ROLES).includes(myRole));
            const hasAdapterRoles = myRoles.some((myRole)=>(0, $fD30B.DATA_MANAGER_ADAPTERS_ROLES).includes(myRole));
            if (hasDMRoles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6xc55.DataManagerLink), {
                to: dataManagerLink,
                app: "data-manager"
            }, formatMessage((0, $eVv4l.messages).dataManagerLink));
            if (hasAdapterRoles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6xc55.DataManagerLink), {
                to: adaptersLink,
                app: "adapters"
            }, formatMessage((0, $eVv4l.messages).adaptersLink));
            return undefined;
        }
        return undefined;
    };
    const isInsightReportsEnabled = ()=>(0, $1ybV0.ff)('jsm-assets-reporting_seqk0') && (isSiteAdmin || isAdmin) && ((0, $1ybV0.ff)('jsm-assets-reports-hipaa-check') ? insightReporting : true);
    const documentTitle = (0, $eVv4l.messages).documentTitleCmdbAssets;
    const navRefreshTitle = (0, $eVv4l.messages).navRefreshAssetsSchemasTile;
    const renderLandingPageContent = ()=>(0, $7JTqr.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $ad6045528f40a6ad$var$overflowStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $ad6045528f40a6ad$var$breadCrumbsWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $asKFY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bm5l8.default), {
            testId: "servicedesk-insight-landing-page.ui.breadcrumbs-item-assets",
            href: (0, $272oI.getLandingPageUrl)(),
            text: formatMessage((0, $eVv4l.messages).assetsBreadcrumbs),
            component: (0, $lB25E.Link)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
            title: formatMessage(navRefreshTitle)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
            disableTitleStyles: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad6045528f40a6ad$var$PageHeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
            size: "large"
        }, formatMessage(navRefreshTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $ad6045528f40a6ad$var$dividerStyles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $ad6045528f40a6ad$var$navRefreshPageContainerStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRB9u.AsyncCmdbCompassChangeboarding), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            space: "space.500"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: [
                $ad6045528f40a6ad$var$leftColumnNavRefreshStyles,
                $ad6045528f40a6ad$var$minWidthStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad6045528f40a6ad$var$PageDescription, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i35iP.FormattedLinkMessage), {
            message: (0, $eVv4l.messages).descriptionCmdbAssets,
            linkProps: {
                target: '_blank',
                to: 'https://support.atlassian.com/jira-service-management-cloud/docs/get-to-know-asset-and-service-management-with-insight/'
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $ad6045528f40a6ad$var$rightColumnNavRefreshStyles
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad6045528f40a6ad$var$PageBodyContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            space: "space.500"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $ad6045528f40a6ad$var$leftColumnNavRefreshStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jstg.RapidSearchBar), {
            workspaceId: workspaceId,
            restrictedObjectSchemaIds: restrictedObjectSchemaIds.map((id)=>(0, $aSJew.toSchemaId)(String(id))),
            renderSearchTextfield: ({ searchTextfieldProps: searchTextfieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    id: "searchDescriptionLabel",
                    xcss: $ad6045528f40a6ad$var$screenReaderOnlyStyles
                }, formatMessage((0, $eVv4l.messages).searchPlaceholderAriaLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
                    id: "searchDescription",
                    testId: "servicedesk-insight-landing-page.ui.textfield",
                    placeholder: formatMessage((0, $eVv4l.messages).searchPlaceholder),
                    "aria-label": formatMessage((0, $eVv4l.messages).searchPlaceholder),
                    "aria-describedby": "searchDescriptionLabel",
                    ...searchTextfieldProps
                }))
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $ad6045528f40a6ad$var$rightColumnNavRefreshStyles
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad6045528f40a6ad$var$PageRowContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $ad6045528f40a6ad$var$leftColumnNavRefreshStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2AirB.SchemaContainer), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $ad6045528f40a6ad$var$rightColumnNavRefreshStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aqMn6.UsagePanel), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lHQ9F.ObjectContainer), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1BawU.AsyncInsightLandingPageChangeboarding), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cb764.DataManagerGAChangeBoardingModal), {
            isEnabledForGA: featureFlags?.[0, $1a426604eb5f44c6$export$2f383dcad349f1af]
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad6045528f40a6ad$var$PageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
            title: formatMessage(documentTitle)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
            disableTitleStyles: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad6045528f40a6ad$var$PageHeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
            size: "large"
        }, formatMessage(documentTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad6045528f40a6ad$var$LinksContainer, null, showDataManagerLink(), isAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aFp4n.ConfigLink), {
            to: configLink,
            onClick: onClickConfigLink
        }, formatMessage((0, $eVv4l.messages).configLink)), isInsightReportsEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $buK2c.AsyncInsightLandingPageReportsLink), {
            to: reportsLink,
            onClick: onClickReportsLink
        }, formatMessage((0, $eVv4l.messages).reportsLink))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRB9u.AsyncCmdbCompassChangeboarding), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cb764.DataManagerGAChangeBoardingModal), {
            isEnabledForGA: featureFlags?.[0, $1a426604eb5f44c6$export$2f383dcad349f1af]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad6045528f40a6ad$var$PageDescription, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i35iP.FormattedLinkMessage), {
            message: (0, $eVv4l.messages).descriptionCmdbAssets,
            linkProps: {
                target: '_blank',
                to: 'https://support.atlassian.com/jira-service-management-cloud/docs/get-to-know-asset-and-service-management-with-insight/'
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad6045528f40a6ad$var$PageBodyContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jstg.RapidSearchBar), {
            workspaceId: workspaceId,
            restrictedObjectSchemaIds: restrictedObjectSchemaIds.map((id)=>(0, $aSJew.toSchemaId)(String(id))),
            renderSearchTextfield: ({ searchTextfieldProps: searchTextfieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
                    testId: "servicedesk-insight-landing-page.ui.textfield",
                    placeholder: formatMessage((0, $eVv4l.messages).searchPlaceholder),
                    "aria-label": formatMessage((0, $eVv4l.messages).searchPlaceholder),
                    ...searchTextfieldProps
                })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad6045528f40a6ad$var$PageRowContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $ad6045528f40a6ad$var$leftColumnStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2AirB.SchemaContainer), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad6045528f40a6ad$var$RightColumn, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aqMn6.UsagePanel), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lHQ9F.ObjectContainer), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1BawU.AsyncInsightLandingPageChangeboarding), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "servicedeskInsightLandingPage",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            isSiteAdmin: isSiteAdmin
        }
    }, schemaState.type === 'success' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            numberOfSchemas: schemaState.schemas.length
        }
    }), (0, $eI5EY.fg)('jsm_cbp_pre-release_banner') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XCmO.PreReleaseBanner), {
        location: "assets"
    }), (0, $eI5EY.fg)('jsm_assets_cbp_limits_and_notifications') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMR3k.ObjectUsageProvider), {
        isJiraAdmin: isAdmin,
        objectCount: objectCount,
        objectLimit: objectLimit,
        billingPeriod: billingCycle === 'annual' ? 'annual' : 'monthly',
        limitState: limitState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3yQCW.LimitsBanner), {
        displayWithOffset: true
    }), renderLandingPageContent()) : renderLandingPageContent());
};
const $ad6045528f40a6ad$var$LEFT_COLUMN_MIN_WIDTH = 260;
const $ad6045528f40a6ad$var$LEFT_COLUMN_NAV_REFRESH_MIN_WIDTH = 376;
const $ad6045528f40a6ad$var$RIGHT_COLUMN_NAV_REFRESH_MIN_WIDTH = 240; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad6045528f40a6ad$var$PageHeaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bah1yb4 _2lx2vrvc _1n261g80 _1p57utpp _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad6045528f40a6ad$var$PageDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8ivgg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad6045528f40a6ad$var$PageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12fjxaq",
            __cmplp.className
        ])
    });
});
const $ad6045528f40a6ad$var$dividerStyles = (0, $1ZAYh.xcss)({
    border: 0.5,
    borderStyle: 'solid',
    borderColor: 'color.border',
    position: 'absolute',
    // not tokenize due to no space.negative.500, maximum 400.
    right: '-40px',
    left: '-40px'
});
const $ad6045528f40a6ad$var$navRefreshPageContainerStyle = (0, $1ZAYh.xcss)({
    margin: '0 auto',
    paddingTop: 'space.250',
    maxWidth: '1072px',
    minWidth: '656px'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad6045528f40a6ad$var$PageBodyContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _zulp1jfw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad6045528f40a6ad$var$PageRowContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulp1jfw",
            __cmplp.className
        ])
    });
});
const $ad6045528f40a6ad$var$leftColumnNavRefreshStyles = (0, $1ZAYh.xcss)({
    flex: 7,
    minWidth: `${$ad6045528f40a6ad$var$LEFT_COLUMN_NAV_REFRESH_MIN_WIDTH}px`
});
const $ad6045528f40a6ad$var$rightColumnNavRefreshStyles = (0, $1ZAYh.xcss)({
    flex: 3,
    minWidth: `${$ad6045528f40a6ad$var$RIGHT_COLUMN_NAV_REFRESH_MIN_WIDTH}px`
});
const $ad6045528f40a6ad$var$leftColumnStyles = (0, $1ZAYh.xcss)({
    flex: 3,
    minWidth: `${$ad6045528f40a6ad$var$LEFT_COLUMN_MIN_WIDTH}px`
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad6045528f40a6ad$var$RightColumn = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad6045528f40a6ad$var$LinksContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $ad6045528f40a6ad$var$screenReaderOnlyStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: 'space.negative.025',
    padding: 'space.0',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    border: 0
});
const $ad6045528f40a6ad$var$overflowStyle = (0, $1ZAYh.xcss)({
    overflowX: 'auto',
    overflowY: 'hidden',
    paddingLeft: 'space.050'
});
const $ad6045528f40a6ad$var$breadCrumbsWrapper = (0, $1ZAYh.xcss)({
    marginTop: 'space.250',
    marginBottom: 'space.negative.150'
});
const $ad6045528f40a6ad$var$minWidthStyles = (0, $1ZAYh.xcss)({
    minWidth: '656px'
});

});
parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';



parcelRegister("3a8wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992b0d4d3fe9569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hFGUl = parcelRequire("hFGUl");
const $2992b0d4d3fe9569$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2992b0d4d3fe9569$var$ActionsWrapper, null, actions) : null
    });
var $2992b0d4d3fe9569$export$2e2bcd8739ae039 = $2992b0d4d3fe9569$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2992b0d4d3fe9569$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hFGUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ce2fac4b2f156d$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $5ubTM = parcelRequire("5ubTM");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $f0ce2fac4b2f156d$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $f0ce2fac4b2f156d$export$2e2bcd8739ae039 = $f0ce2fac4b2f156d$var$PageHeader;

});
parcelRegister("5ubTM", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $fce98fdc5842132f$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $fce98fdc5842132f$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $fce98fdc5842132f$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $fce98fdc5842132f$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $fce98fdc5842132f$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $fce98fdc5842132f$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $fce98fdc5842132f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fce98fdc5842132f$var$truncateStyles = {
    name: "n3ut7m",
    styles: "overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $fce98fdc5842132f$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $fce98fdc5842132f$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $fce98fdc5842132f$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $fce98fdc5842132f$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $fce98fdc5842132f$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $fce98fdc5842132f$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $fce98fdc5842132f$var$bottomBarStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.200'
});
const $fce98fdc5842132f$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$outerStyles
    }, children);
};
const $fce98fdc5842132f$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $fce98fdc5842132f$var$titleStyles,
            truncateTitle && $fce98fdc5842132f$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $fce98fdc5842132f$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleWrapperStyles,
            truncateTitle && $fce98fdc5842132f$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleContainerStyles,
            truncateTitle && $fce98fdc5842132f$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$actionStyles
    }, children);
};
const $fce98fdc5842132f$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $fce98fdc5842132f$var$bottomBarStyles
    }, children);
};

});



parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

var $3fq1f = parcelRequire("3fq1f");
class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("kRB9u", function(module, exports) {

$parcel$export(module.exports, "AsyncCmdbCompassChangeboarding", () => $1fb0d6b78877b927$export$45d2e9afefbecd1d);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1fb0d6b78877b927$var$LazyCmdbCompassChangeboarding = (0, $7rh0R.lazy)(()=>(parcelRequire("irvsW")).then((module)=>module.CmdbCompassChangeboarding), {
    moduleId: "./src/packages/servicedesk/insight-common/cmdb-compass-changeboarding/src/ui/index.tsx"
});
const $1fb0d6b78877b927$export$45d2e9afefbecd1d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "cmdb-compass-changeboarding",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1fb0d6b78877b927$var$LazyCmdbCompassChangeboarding, null));

});
parcelRegister("irvsW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("aeiNC")
]).then(()=>parcelRequire('foqkv'));

});


parcelRegister("3yQCW", function(module, exports) {

$parcel$export(module.exports, "LimitsBanner", () => $a50c377bbc346973$export$276b2f7a0e2a1206);

var $eUqFw = parcelRequire("eUqFw");

var $2CgwC = parcelRequire("2CgwC");

var $j9fWg = parcelRequire("j9fWg");

var $fbOgz = parcelRequire("fbOgz");

var $cRF2H = parcelRequire("cRF2H");

var $4gf3G = parcelRequire("4gf3G");

var $5OdZ3 = parcelRequire("5OdZ3");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");


var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $272oI = parcelRequire("272oI");

var $lMR3k = parcelRequire("lMR3k");

var $1THT4 = parcelRequire("1THT4");
const $a50c377bbc346973$export$276b2f7a0e2a1206 = ({ displayWithOffset: displayWithOffset, isObjectView: isObjectView = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onDismiss = (0, $lMR3k.useObjectUsageDismiss)();
    const objectUsageInfo = (0, $lMR3k.useObjectUsageInfo)('limits-banner');
    if (objectUsageInfo.type === 'none') return null;
    let appearance = 'announcement';
    const { userRole: userRole, billingPeriod: billingPeriod, type: type } = objectUsageInfo;
    const isAdmin = userRole === 'admin';
    let content = null;
    const getFilteredMessageContent = (contentToFormat, url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...contentToFormat,
            values: {
                p: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, msg),
                a: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OdZ3.default), {
                        appearance: "subtle",
                        href: url
                    }, msg),
                b: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        weight: "bold"
                    }, msg)
            }
        });
    const increaseUsageUrl = (0, $272oI.getFeatureUsagePageUrl)({
        showChangeLimitModal: true
    });
    const getMonthlyContent = ()=>{
        switch(type){
            case '80-percent':
                content = isAdmin ? getFilteredMessageContent((0, $1THT4.messages).admin80PercentMonthly, increaseUsageUrl) : null;
                break;
            case '90-percent':
                appearance = 'warning';
                content = isAdmin ? getFilteredMessageContent((0, $1THT4.messages).admin90PercentMonthly, increaseUsageUrl) : getFilteredMessageContent((0, $1THT4.messages).agent90PercentMonthly, '');
                break;
            case 'limit-reached':
                appearance = 'error';
                content = isAdmin ? getFilteredMessageContent((0, $1THT4.messages).adminLimitReachedMonthly, increaseUsageUrl) : getFilteredMessageContent((0, $1THT4.messages).agentLimitReachedMonthly, '');
                break;
            default:
                return null;
        }
    };
    const getYearlyContent = ()=>{
        switch(type){
            case '80-percent':
                content = isAdmin ? getFilteredMessageContent((0, $1THT4.messages).admin80PercentYearly, increaseUsageUrl) : null;
                break;
            case '90-percent':
                appearance = 'warning';
                content = isAdmin ? getFilteredMessageContent((0, $1THT4.messages).admin90PercentYearly, increaseUsageUrl) : getFilteredMessageContent((0, $1THT4.messages).agent90PercentYearly, '');
                break;
            case 'limit-reached':
                appearance = 'error';
                content = isAdmin ? getFilteredMessageContent((0, $1THT4.messages).adminLimitReachedYearly, increaseUsageUrl) : getFilteredMessageContent((0, $1THT4.messages).agentLimitReachedYearly, '');
                break;
            default:
                return null;
        }
    };
    const getBannerIcon = ()=>{
        if (type === '90-percent') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4gf3G))), {
            color: "currentColor",
            LEGACY_secondaryColor: "inherit",
            label: formatMessage((0, $1THT4.messages).warningIcon)
        });
        if (type === 'limit-reached') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cRF2H))), {
            color: "currentColor",
            LEGACY_secondaryColor: "inherit",
            label: formatMessage((0, $1THT4.messages).errorIcon)
        });
        return undefined;
    };
    switch(billingPeriod){
        case 'monthly':
            getMonthlyContent();
            break;
        case 'annual':
            getYearlyContent();
            break;
        default:
            return null;
    }
    const getBannerContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $a50c377bbc346973$var$outerBannerWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2CgwC.default), {
            appearance: appearance,
            icon: getBannerIcon(),
            testId: "servicedesk-cmdb-object-usage-messaging.ui.limits-banner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $a50c377bbc346973$var$bannerContentWrapper
        }, content), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $a50c377bbc346973$var$bannerCloseWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
            appearance: "subtle",
            onClick: onDismiss,
            spacing: "compact",
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fbOgz))), {
                    ...iconProps,
                    LEGACY_size: "medium",
                    color: type === '90-percent' ? `var(--ds-text-warning-inverse, ${0, $73a5c9d720aa66e1$export$7d61b15e0da132af})` : `var(--ds-text-inverse, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`
                }),
            label: formatMessage((0, $1THT4.messages).dismissBanner)
        }))));
    if (isObjectView) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $a50c377bbc346973$var$objectViewOffsetWrapper,
        testId: "servicedesk-cmdb-object-usage-messaging.ui.limits-banner.limits-banner-object-view-offset-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $a50c377bbc346973$var$layoutOffsetInner
    }, getBannerContent()));
    return displayWithOffset ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $a50c377bbc346973$var$layoutOffsetWrapper,
        testId: "servicedesk-cmdb-object-usage-messaging.ui.limits-banner.limits-banner-layout-offset-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $a50c377bbc346973$var$layoutOffsetInner
    }, getBannerContent())) : getBannerContent();
};
const $a50c377bbc346973$var$bannerCloseWrapper = (0, $1ZAYh.xcss)({
    position: 'absolute',
    right: 'space.150',
    top: '50%',
    transform: 'translateY(-50%)'
});
const $a50c377bbc346973$var$outerBannerWrapper = (0, $1ZAYh.xcss)({
    position: 'relative'
});
const $a50c377bbc346973$var$bannerContentWrapper = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    paddingRight: 'space.400',
    [(0, $4Ywu9.media).above.sm]: {
        paddingRight: 'space.500'
    }
});
// nested wrappers due to no space.negative.500, maximum 400.
const $a50c377bbc346973$var$layoutOffsetWrapper = (0, $1ZAYh.xcss)({
    marginBottom: 'space.0',
    marginLeft: 'space.negative.400',
    marginRight: 'space.negative.400'
});
// nested wrappers due to no space.negative.500, maximum 400.
const $a50c377bbc346973$var$objectViewOffsetWrapper = (0, $1ZAYh.xcss)({
    marginTop: 'space.negative.200',
    marginLeft: 'space.negative.400',
    marginRight: 'space.negative.400',
    marginBottom: 'space.300'
});
const $a50c377bbc346973$var$layoutOffsetInner = (0, $1ZAYh.xcss)({
    marginLeft: 'space.negative.100',
    marginRight: 'space.negative.100'
});

});
parcelRegister("fbOgz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f4a9a14e2cbd991149ff35fe23cef8b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0eedfeb10f4bac1$var$_react = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b0eedfeb10f4bac1$var$_cross = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("adUQx")));

var $b0eedfeb10f4bac1$var$_close = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("je5kZ")));
function $b0eedfeb10f4bac1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0eedfeb10f4bac1$var$CrossIcon = (props)=>/*#__PURE__*/ $b0eedfeb10f4bac1$var$_react.default.createElement($b0eedfeb10f4bac1$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $b0eedfeb10f4bac1$var$_close.default
    }, props));
$b0eedfeb10f4bac1$var$CrossIcon.Name = 'CrossIconMigration';
var $b0eedfeb10f4bac1$var$_default = module.exports.default = $b0eedfeb10f4bac1$var$CrossIcon;

});
parcelRegister("adUQx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7dfdc599c601af5ad9de21c16ca28508>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $771736c5909ba4b4$var$_react = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $771736c5909ba4b4$var$_UNSAFE_baseNew = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $771736c5909ba4b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $771736c5909ba4b4$var$CrossIcon = (props)=>/*#__PURE__*/ $771736c5909ba4b4$var$_react.default.createElement($771736c5909ba4b4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$771736c5909ba4b4$var$CrossIcon.displayName = 'CrossIcon';
var $771736c5909ba4b4$var$_default = module.exports.default = $771736c5909ba4b4$var$CrossIcon;

});

parcelRegister("je5kZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff3771012ed2785$var$_react = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $dff3771012ed2785$var$_close = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("02Sz7")));
function $dff3771012ed2785$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $dff3771012ed2785$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $dff3771012ed2785$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $dff3771012ed2785$var$_close.default
    }));
$dff3771012ed2785$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $dff3771012ed2785$var$_default = module.exports.default = $dff3771012ed2785$var$EditorCloseIcon;

});


parcelRegister("cRF2H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b5353aefb8b927c75a9255a7f4f860a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95da457782830ad9$var$_react = $95da457782830ad9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $95da457782830ad9$var$_error = $95da457782830ad9$var$_interopRequireDefault((parcelRequire("3y3FU")));

var $95da457782830ad9$var$_error2 = $95da457782830ad9$var$_interopRequireDefault((parcelRequire("96IgR")));
function $95da457782830ad9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $95da457782830ad9$var$ErrorIcon = (props)=>/*#__PURE__*/ $95da457782830ad9$var$_react.default.createElement($95da457782830ad9$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $95da457782830ad9$var$_error2.default
    }, props));
$95da457782830ad9$var$ErrorIcon.Name = 'ErrorIconMigration';
var $95da457782830ad9$var$_default = module.exports.default = $95da457782830ad9$var$ErrorIcon;

});
parcelRegister("3y3FU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7a8a196ba35a1e44ea89ac2740db6231>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $295765d1df1715f9$var$_react = $295765d1df1715f9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $295765d1df1715f9$var$_UNSAFE_baseNew = $295765d1df1715f9$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $295765d1df1715f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Error".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $295765d1df1715f9$var$ErrorIcon = (props)=>/*#__PURE__*/ $295765d1df1715f9$var$_react.default.createElement($295765d1df1715f9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$295765d1df1715f9$var$ErrorIcon.displayName = 'ErrorIcon';
var $295765d1df1715f9$var$_default = module.exports.default = $295765d1df1715f9$var$ErrorIcon;

});


parcelRegister("4gf3G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::145bf8b9f0c92296e11988c2fb40d4b0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $31a45653e3d63f8f$var$_react = $31a45653e3d63f8f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $31a45653e3d63f8f$var$_warning = $31a45653e3d63f8f$var$_interopRequireDefault((parcelRequire("gVRsf")));

var $31a45653e3d63f8f$var$_warning2 = $31a45653e3d63f8f$var$_interopRequireDefault((parcelRequire("5YsMl")));
function $31a45653e3d63f8f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $31a45653e3d63f8f$var$WarningIcon = (props)=>/*#__PURE__*/ $31a45653e3d63f8f$var$_react.default.createElement($31a45653e3d63f8f$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $31a45653e3d63f8f$var$_warning2.default
    }, props));
$31a45653e3d63f8f$var$WarningIcon.Name = 'WarningIconMigration';
var $31a45653e3d63f8f$var$_default = module.exports.default = $31a45653e3d63f8f$var$WarningIcon;

});

parcelRegister("272oI", function(module, exports) {

$parcel$export(module.exports, "isInsightRoute", () => $1ee561ab017acd59$export$296d80f3ce129968);
$parcel$export(module.exports, "getCreateServiceUrl", () => $1ee561ab017acd59$export$1f9b8b558a361aaf);
$parcel$export(module.exports, "getRootPath", () => $1ee561ab017acd59$export$5413f45d031c7806);
$parcel$export(module.exports, "getLandingPageUrl", () => $1ee561ab017acd59$export$9366da5a373815e5);
$parcel$export(module.exports, "getGlobalConfigUrl", () => $1ee561ab017acd59$export$20fd4a0aec335970);
$parcel$export(module.exports, "getDataManagerUrl", () => $1ee561ab017acd59$export$c9b27b0d2e19d52f);
$parcel$export(module.exports, "getDataManagerAdaptersUrl", () => $1ee561ab017acd59$export$cd6b35373ba077a);
$parcel$export(module.exports, "getAssetsReportsUrl", () => $1ee561ab017acd59$export$c1909404b7ea317f);
$parcel$export(module.exports, "createObjectSchemasUrl", () => $1ee561ab017acd59$export$c48ea1282c74411e);
$parcel$export(module.exports, "createObjectSchemaUrl", () => $1ee561ab017acd59$export$3a0332e980fe56cf);
$parcel$export(module.exports, "createObjectTypeUrl", () => $1ee561ab017acd59$export$cfefb90cfb86b528);
$parcel$export(module.exports, "createObjectSchemaConfigUrl", () => $1ee561ab017acd59$export$f02479149ce3cac7);
$parcel$export(module.exports, "createObjectDetailUrl", () => $1ee561ab017acd59$export$51e4229f2c7d3866);
$parcel$export(module.exports, "createObjectTypeSettingsUrl", () => $1ee561ab017acd59$export$4b4b7d2c3df4fa58);
$parcel$export(module.exports, "createObjectTypeListWithObjectSelectedUrl", () => $1ee561ab017acd59$export$c1790fa8f0d8e89a);
$parcel$export(module.exports, "getFeatureUsagePageUrl", () => $1ee561ab017acd59$export$5ba89eed0cf60033);
$parcel$export(module.exports, "getFeatureUsageVirtualAgentPageUrl", () => $1ee561ab017acd59$export$415502b49e27270d);

var $7lEPK = parcelRequire("7lEPK");
const $1ee561ab017acd59$export$ee637ecb2dfa4f6a = '/jira/servicedesk/service-modal';
const $1ee561ab017acd59$export$c90f45511b7ccc85 = '/jira/servicedesk/assets';
const $1ee561ab017acd59$export$6d7574dbda22cf7 = '/jira/servicedesk/insight';
const $1ee561ab017acd59$export$296d80f3ce129968 = (pathname)=>pathname.includes($1ee561ab017acd59$export$6d7574dbda22cf7);
const $1ee561ab017acd59$export$1f9b8b558a361aaf = ()=>$1ee561ab017acd59$export$ee637ecb2dfa4f6a;
const $1ee561ab017acd59$export$5413f45d031c7806 = ()=>$1ee561ab017acd59$export$c90f45511b7ccc85;
const $1ee561ab017acd59$export$9366da5a373815e5 = ()=>$1ee561ab017acd59$export$5413f45d031c7806();
const $1ee561ab017acd59$export$20fd4a0aec335970 = ()=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/configure/global`;
const $1ee561ab017acd59$export$c9b27b0d2e19d52f = ()=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/data-manager/`;
const $1ee561ab017acd59$export$cd6b35373ba077a = ()=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/data-manager/adapters/`;
const $1ee561ab017acd59$export$c1909404b7ea317f = ()=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/reports`;
const $1ee561ab017acd59$export$c48ea1282c74411e = ()=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/object-schemas`;
const $1ee561ab017acd59$export$3a0332e980fe56cf = (objectSchemaId)=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/object-schema/${objectSchemaId}`;
const $1ee561ab017acd59$export$cfefb90cfb86b528 = (objectSchemaId, objectTypeId)=>`${$1ee561ab017acd59$export$3a0332e980fe56cf(objectSchemaId)}?${(0, $7lEPK.SCHEMA_PAGE_QUERY_PARAMS).objectTypeId}=${objectTypeId}`;
const $1ee561ab017acd59$export$f02479149ce3cac7 = (objectSchemaId)=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/configure/object-schema/${objectSchemaId}`;
const $1ee561ab017acd59$export$51e4229f2c7d3866 = (objectId)=>`${$1ee561ab017acd59$export$c90f45511b7ccc85}/object/${objectId}`;
const $1ee561ab017acd59$export$4b4b7d2c3df4fa58 = (objectTypeId)=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/configure/object-type/${objectTypeId}`;
const $1ee561ab017acd59$export$c1790fa8f0d8e89a = (objectSchemaId, objectTypeId, objectId)=>`${$1ee561ab017acd59$export$cfefb90cfb86b528(objectSchemaId, objectTypeId)}&view=list&objectId=${objectId}`;
const $1ee561ab017acd59$export$5ba89eed0cf60033 = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=assets${showChangeLimitModal ? '&changeLimit=true' : ''}`;
const $1ee561ab017acd59$export$415502b49e27270d = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=virtual-agent${showChangeLimitModal ? '&changeLimit=true' : ''}`;

});
parcelRegister("7lEPK", function(module, exports) {

$parcel$export(module.exports, "SCHEMA_PAGE_QUERY_PARAMS", () => $77a5b92f13f64b9e$export$a73deb42718b5c4);
$parcel$export(module.exports, "useUpdateQueryParams", () => $77a5b92f13f64b9e$export$e66acc5f4583ce1c);
$parcel$export(module.exports, "useObjectTypeIdQueryParam", () => $77a5b92f13f64b9e$export$f5a33d51dd6de08);
$parcel$export(module.exports, "useObjectIdQueryParam", () => $77a5b92f13f64b9e$export$a6e3187c87554a1e);
$parcel$export(module.exports, "useSchemaViewModeQueryParam", () => $77a5b92f13f64b9e$export$6abda0ad26022eff);
$parcel$export(module.exports, "useObjectViewModeQueryParam", () => $77a5b92f13f64b9e$export$1927b50f7d074492);

var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $lB25E = parcelRequire("lB25E");

var $aSJew = parcelRequire("aSJew");
const $77a5b92f13f64b9e$export$a73deb42718b5c4 = {
    // Values are 'object' or 'attribute'
    schemaMode: 'mode',
    // Values are 'list' or undefined
    objectViewMode: 'view',
    // Both of these params are supported to set the object type ID. 'typeId' is preferred and is the one that is updated.
    // 'objecttypeid' is only used on initial load to support customers who have bookmarked this URL.
    objectTypeId: 'typeId',
    fallbackObjectTypeId: 'objecttypeid',
    objectId: 'objectId'
};
const $77a5b92f13f64b9e$export$e66acc5f4583ce1c = ()=>{
    const { push: push } = (0, $lB25E.useRouterActions)();
    const [{ location: location }] = (0, $lB25E.useRouter)();
    const updateQueryParams = (0, $eUqFw.useCallback)((queryParams = {})=>{
        const { pathname: pathname, search: search } = location;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedQueryParams = {};
        Object.keys(queryParams).forEach((key)=>{
            updatedQueryParams[key] = queryParams[key] ?? undefined;
        });
        return `${pathname}?${(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
            ...(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(search),
            ...updatedQueryParams
        })}`;
    }, [
        location
    ]);
    const pushRouterAction = (0, $eUqFw.useCallback)((path)=>{
        push(path);
    }, [
        push
    ]);
    return [
        {
            updateQueryParams: updateQueryParams,
            pushRouterAction: pushRouterAction
        }
    ];
};
const $77a5b92f13f64b9e$export$f5a33d51dd6de08 = ()=>{
    const [objectTypeId, setObjectTypeId] = (0, $lB25E.useQueryParam)($77a5b92f13f64b9e$export$a73deb42718b5c4.objectTypeId);
    const [fallbackObjectTypeId, setFallbackObjectTypeId] = (0, $lB25E.useQueryParam)($77a5b92f13f64b9e$export$a73deb42718b5c4.fallbackObjectTypeId);
    (0, $eUqFw.useEffect)(()=>{
        if (fallbackObjectTypeId !== undefined) {
            setObjectTypeId((0, $aSJew.toCmdbObjectTypeId)(fallbackObjectTypeId), 'replace');
            setFallbackObjectTypeId(undefined, 'replace');
        }
    }, [
        fallbackObjectTypeId,
        setObjectTypeId,
        setFallbackObjectTypeId
    ]);
    const nullableMain = objectTypeId !== undefined ? (0, $aSJew.toCmdbObjectTypeId)(objectTypeId) : null;
    const nullableFallback = fallbackObjectTypeId !== undefined ? (0, $aSJew.toCmdbObjectTypeId)(fallbackObjectTypeId) : null;
    const setter = (newObjectTypeId, updateType)=>{
        setObjectTypeId(newObjectTypeId !== null ? newObjectTypeId : undefined, updateType);
    };
    return [
        nullableMain !== null ? nullableMain : nullableFallback,
        setter
    ];
};
const $77a5b92f13f64b9e$export$a6e3187c87554a1e = ()=>{
    const [objectId, setObjectId] = (0, $lB25E.useQueryParam)($77a5b92f13f64b9e$export$a73deb42718b5c4.objectId);
    const nullableObjectId = objectId !== undefined ? (0, $aSJew.toCmdbObjectId)(objectId) : null;
    const setter = (newObjectId, updateType)=>{
        setObjectId(newObjectId !== null ? newObjectId : undefined, updateType);
    };
    return [
        nullableObjectId,
        setter
    ];
};
const $77a5b92f13f64b9e$export$6abda0ad26022eff = ()=>{
    const [rawParamValue, setSchemaMode] = (0, $lB25E.useQueryParam)($77a5b92f13f64b9e$export$a73deb42718b5c4.schemaMode);
    const schemaMode = rawParamValue === 'attribute' ? 'attribute' : 'object';
    return [
        schemaMode,
        setSchemaMode
    ];
};
const $77a5b92f13f64b9e$export$1927b50f7d074492 = ()=>{
    const [rawParamValue, setObjectViewMode] = (0, $lB25E.useQueryParam)($77a5b92f13f64b9e$export$a73deb42718b5c4.objectViewMode);
    const objectViewMode = rawParamValue === 'list' ? 'list' : 'details';
    const setter = (newValue, updateMode)=>{
        setObjectViewMode(newValue === 'list' ? 'list' : undefined, updateMode);
    };
    return [
        objectViewMode,
        setter
    ];
};

});


parcelRegister("lMR3k", function(module, exports) {

$parcel$export(module.exports, "useObjectUsageDismiss", () => $90154c0d9c8bbb09$export$488ff4bad70ebd64);
$parcel$export(module.exports, "useObjectUsageRefreshObjectCount", () => $90154c0d9c8bbb09$export$555b8f9a7e864563);
$parcel$export(module.exports, "useObjectUsageInfo", () => $90154c0d9c8bbb09$export$4adfcc0459dd98ca);
$parcel$export(module.exports, "useBillingPeriod", () => $90154c0d9c8bbb09$export$65fa1dba3c6d4da1);
$parcel$export(module.exports, "useLimitState", () => $90154c0d9c8bbb09$export$c52f3408141b34f0);
$parcel$export(module.exports, "ObjectUsageProvider", () => $90154c0d9c8bbb09$export$dcd40a00452817a6);

var $eUqFw = parcelRequire("eUqFw");

var $80nQh = parcelRequire("80nQh");

var $WBLbN = parcelRequire("WBLbN");

var $eW3Uf = parcelRequire("eW3Uf");

var $ed1x7 = parcelRequire("ed1x7");

var $etmS8 = parcelRequire("etmS8");
const $90154c0d9c8bbb09$var$Store = (0, $WBLbN.createStore)({
    initialState: $eW3Uf.initialState,
    actions: $ed1x7.actions
});
const $90154c0d9c8bbb09$var$useActions = (0, $WBLbN.createActionsHook)($90154c0d9c8bbb09$var$Store);
const $90154c0d9c8bbb09$export$488ff4bad70ebd64 = ()=>{
    const { dismissMessage: dismissMessage } = $90154c0d9c8bbb09$var$useActions();
    return dismissMessage;
};
const $90154c0d9c8bbb09$export$555b8f9a7e864563 = ()=>{
    const { refreshObjectCount: refreshObjectCount } = $90154c0d9c8bbb09$var$useActions();
    return (createAnalyticsEvent)=>refreshObjectCount(createAnalyticsEvent);
};
const $90154c0d9c8bbb09$export$4adfcc0459dd98ca = (0, $WBLbN.createStateHook)($90154c0d9c8bbb09$var$Store, {
    selector: (0, $etmS8.getObjectUsageInfo)
});
const $90154c0d9c8bbb09$export$65fa1dba3c6d4da1 = (0, $WBLbN.createStateHook)($90154c0d9c8bbb09$var$Store, {
    selector: ({ billingPeriod: billingPeriod })=>billingPeriod
});
const $90154c0d9c8bbb09$export$c52f3408141b34f0 = (0, $WBLbN.createStateHook)($90154c0d9c8bbb09$var$Store, {
    selector: ({ limitState: limitState })=>limitState
});
const $90154c0d9c8bbb09$var$dispatchInitialState = ()=>({ dispatch: dispatch }, { isJiraAdmin: isJiraAdmin, objectCount: objectCount, objectLimit: objectLimit, billingPeriod: billingPeriod, limitState: limitState, workspaceId: workspaceId })=>{
        dispatch((0, $ed1x7.actions).setInitialData({
            isJiraAdmin: isJiraAdmin,
            objectCount: objectCount,
            objectLimit: objectLimit,
            billingPeriod: billingPeriod,
            limitState: limitState,
            workspaceId: workspaceId
        }));
    };
const $90154c0d9c8bbb09$var$ObjectUsageStoreContainer = (0, $WBLbN.createContainer)($90154c0d9c8bbb09$var$Store, {
    onInit: $90154c0d9c8bbb09$var$dispatchInitialState,
    onUpdate: $90154c0d9c8bbb09$var$dispatchInitialState,
    displayName: 'JsmCmdbObjectUsageStoreContainer'
});
const $90154c0d9c8bbb09$export$dcd40a00452817a6 = ({ children: children, isJiraAdmin: isJiraAdmin, objectCount: objectCount, objectLimit: objectLimit, billingPeriod: billingPeriod, limitState: limitState })=>{
    const { workspaceId: workspaceId } = (0, $80nQh.useWorkspaceContext)();
    if (!workspaceId) throw new Error('workspaceId not defined');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($90154c0d9c8bbb09$var$ObjectUsageStoreContainer, {
        isJiraAdmin: isJiraAdmin,
        objectCount: objectCount,
        objectLimit: objectLimit,
        billingPeriod: billingPeriod,
        limitState: limitState,
        workspaceId: workspaceId,
        isGlobal: true
    }, children);
};

});
parcelRegister("80nQh", function(module, exports) {

$parcel$export(module.exports, "useWorkspaceContext", () => $5089ebfd51edd178$export$827d903316fc333c);
$parcel$export(module.exports, "useInsightVisibility", () => $5089ebfd51edd178$export$74ebc9a49f60d38a);

var $eUqFw = parcelRequire("eUqFw");

var $h5RgW = parcelRequire("h5RgW");

var $8PehF = parcelRequire("8PehF");

var $gd0Sp = parcelRequire("gd0Sp");

var $cV47S = parcelRequire("cV47S");

var $aeCba = parcelRequire("aeCba");
const $5089ebfd51edd178$export$a0002067fa97246a = '/rest/servicedesk/cmdb/latest/workspace';
const $5089ebfd51edd178$export$122fccf0bbbc9acc = 30000;
const $5089ebfd51edd178$export$827d903316fc333c = ()=>{
    const { data: data, loading: loading, error: error, refresh: fetchWorkspaceId } = (0, $h5RgW.useResource)((0, $cV47S.workspaceResource));
    const workspaceId = data ?? undefined;
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null | undefined'.
        error,
        workspaceId: workspaceId,
        fetchWorkspaceId: fetchWorkspaceId
    };
};
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
const $5089ebfd51edd178$var$useInterval = (callback, delay)=>{
    const savedCallback = (0, $eUqFw.useRef)(callback);
    // Remember the latest callback.
    (0, $eUqFw.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0, $eUqFw.useEffect)(()=>{
        const tick = ()=>{
            savedCallback.current();
        };
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
        return undefined;
    }, [
        delay
    ]);
};
const $5089ebfd51edd178$export$74ebc9a49f60d38a = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { workspaceId: workspaceId, fetchWorkspaceId: fetchWorkspaceId, loading: loading } = $5089ebfd51edd178$export$827d903316fc333c();
    // Optimistically set this true if user is premium and CMDB is enabled in environment - which will prevent a flash for the majority of users
    const [isVisible, setIsVisible] = (0, $eUqFw.useState)((0, $8PehF.isCMDBEnabledInEnvironment)() && (0, $aeCba.isLicensedPremiumUser)(tenantContext));
    const [shouldPollForWorkspaceId, setShouldPollForWorkspaceId] = (0, $eUqFw.useState)(false);
    const [hasFetchedWorkspaceId, setHasFetchedWorkspaceId] = (0, $eUqFw.useState)(false);
    // Can't test this component without a rerender on each poll — so am just increment a counter with each poll
    const [, setPollCount] = (0, $eUqFw.useState)(0);
    // Run an initial fetch of the workspaceId if the resource wasn't already fetched as
    // part of the route definition (like for the Insight menu in the global nav)
    (0, $eUqFw.useEffect)(()=>{
        if (!workspaceId && (0, $aeCba.isLicensedPremiumUser)(tenantContext) && (0, $8PehF.isCMDBEnabledInEnvironment)()) {
            fetchWorkspaceId();
            setHasFetchedWorkspaceId(true);
        }
    }, [
        fetchWorkspaceId,
        tenantContext,
        workspaceId
    ]);
    // Starts/stops the polling of workspaceId
    $5089ebfd51edd178$var$useInterval(()=>{
        fetchWorkspaceId();
        setPollCount((a)=>a + 1);
    }, shouldPollForWorkspaceId ? $5089ebfd51edd178$export$122fccf0bbbc9acc : null);
    // Main check to see if insight should be visible
    // If user has premium subscription but no workspace ID, we begin polling for the
    // workspace ID as it means their Insight instance hasn’t completed provisioning yet
    (0, $eUqFw.useEffect)(()=>{
        if (hasFetchedWorkspaceId && !loading) {
            if ((0, $aeCba.isLicensedPremiumUser)(tenantContext)) {
                if (workspaceId !== undefined) {
                    setIsVisible(true);
                    setShouldPollForWorkspaceId(false);
                } else {
                    setIsVisible(false);
                    setShouldPollForWorkspaceId(true);
                }
            } else {
                setIsVisible(false);
                setShouldPollForWorkspaceId(false);
            }
        }
    }, [
        tenantContext,
        workspaceId,
        loading,
        hasFetchedWorkspaceId
    ]);
    return isVisible;
};

});

parcelRegister("eW3Uf", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE", () => $b708b64505b92b54$export$c6a7366241a86d6d);
$parcel$export(module.exports, "DISMISSED_FOR_THRESHOLD_TYPE_KEY", () => $b708b64505b92b54$export$98e7ecfcc5c7cd3e);
$parcel$export(module.exports, "NONE", () => $b708b64505b92b54$export$c53d0f541b41b88e);
$parcel$export(module.exports, "initialState", () => $b708b64505b92b54$export$d4c72bab9d6cc13a);

var $aZaPn = parcelRequire("aZaPn");
const $b708b64505b92b54$export$c6a7366241a86d6d = (0, $aZaPn.createLocalStorageProvider)('jsm-assets-object-usage-info');
const $b708b64505b92b54$export$98e7ecfcc5c7cd3e = 'dismissed';
const $b708b64505b92b54$export$c53d0f541b41b88e = {
    type: 'none'
};
const $b708b64505b92b54$export$d4c72bab9d6cc13a = {
    userRole: 'agent',
    billingPeriod: 'monthly',
    objectCount: 0,
    objectLimit: Number.MAX_SAFE_INTEGER,
    isDismissed: false,
    limitState: 'disabled',
    workspaceId: ''
};

});

parcelRegister("ed1x7", function(module, exports) {

$parcel$export(module.exports, "actions", () => $ddc3a3d857330bf8$export$e324594224ef24da);

var $ekNOr = parcelRequire("ekNOr");

var $7dVb0 = parcelRequire("7dVb0");

var $lN170 = parcelRequire("lN170");
const $ddc3a3d857330bf8$export$e324594224ef24da = {
    setInitialData: $lN170.setInitialData,
    dismissMessage: $ekNOr.dismissMessage,
    refreshObjectCount: $7dVb0.refreshObjectCount
};

});
parcelRegister("ekNOr", function(module, exports) {

$parcel$export(module.exports, "dismissMessage", () => $c718a686afe108dd$export$ce591ff86214e2a8);

var $eW3Uf = parcelRequire("eW3Uf");

var $l0XeL = parcelRequire("l0XeL");
const $c718a686afe108dd$export$ce591ff86214e2a8 = ()=>async ({ setState: setState, getState: getState }, { objectCount: objectCount, objectLimit: objectLimit })=>{
        const threshold = (0, $l0XeL.determineThreshold)({
            objectCount: objectCount,
            objectLimit: objectLimit
        });
        const isDismissed = (0, $eW3Uf.LOCAL_STORAGE).get((0, $eW3Uf.DISMISSED_FOR_THRESHOLD_TYPE_KEY)) === threshold;
        if (!isDismissed) {
            (0, $eW3Uf.LOCAL_STORAGE).set((0, $eW3Uf.DISMISSED_FOR_THRESHOLD_TYPE_KEY), threshold);
            setState({
                ...getState(),
                isDismissed: true
            });
        }
    };

});
parcelRegister("l0XeL", function(module, exports) {

$parcel$export(module.exports, "determineThreshold", () => $deb255df66b98677$export$d2c1acdb7ab100ba);
$parcel$export(module.exports, "determineObjectUsageInfo", () => $deb255df66b98677$export$6fe2fd277c274d8);

var $eI5EY = parcelRequire("eI5EY");

var $eW3Uf = parcelRequire("eW3Uf");
const $deb255df66b98677$export$d2c1acdb7ab100ba = ({ objectCount: objectCount, objectLimit: objectLimit })=>{
    if (objectCount >= objectLimit) return 'limit-reached';
    if (objectCount >= objectLimit * 0.9) return '90-percent';
    if (objectCount >= objectLimit * 0.8) return '80-percent';
    return 'none';
};
const $deb255df66b98677$export$6fe2fd277c274d8 = ({ isJiraAdmin: isJiraAdmin, objectCount: objectCount, objectLimit: objectLimit, billingPeriod: billingPeriod, location: location, limitState: limitState })=>{
    if (!(0, $eI5EY.fg)('jsm_assets_cbp_limits_and_notifications')) return 0, $eW3Uf.NONE;
    const userRole = isJiraAdmin ? 'admin' : 'agent';
    const objectsRemaining = Math.max(objectLimit - objectCount, 0);
    switch($deb255df66b98677$export$d2c1acdb7ab100ba({
        objectCount: objectCount,
        objectLimit: objectLimit
    })){
        case 'limit-reached':
            if (location === 'create-object' && limitState === 'notify-only') return 0, $eW3Uf.NONE;
            return {
                type: 'limit-reached',
                userRole: userRole,
                billingPeriod: billingPeriod,
                objectsRemaining: objectsRemaining
            };
        case '90-percent':
            return {
                type: '90-percent',
                userRole: userRole,
                billingPeriod: billingPeriod,
                objectsRemaining: objectsRemaining
            };
        case '80-percent':
            switch(location){
                case 'assets-feature-usage-dashboard':
                case 'limits-banner':
                case 'create-object':
                    if (userRole === 'agent') // 80% not shown for agents in object create + limits-banner
                    return 0, $eW3Uf.NONE;
                    return {
                        type: '80-percent',
                        userRole: userRole,
                        billingPeriod: billingPeriod,
                        objectsRemaining: objectsRemaining
                    };
                case 'import-data-modal':
                    // 80% not shown for any userRole in import data modal
                    return 0, $eW3Uf.NONE;
                default:
                    return 0, $eW3Uf.NONE;
            }
        case 'none':
            return 0, $eW3Uf.NONE;
        default:
            return 0, $eW3Uf.NONE;
    }
};

});


parcelRegister("7dVb0", function(module, exports) {

$parcel$export(module.exports, "refreshObjectCount", () => $ba4df1edfa39dab9$export$457582db067330de);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $jlfMg = parcelRequire("jlfMg");
const $ba4df1edfa39dab9$export$457582db067330de = ({ createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState })=>{
        try {
            const currentState = getState();
            const { workspaceId: workspaceId } = currentState;
            const response = await (0, $lRmyA.performGetRequest)((0, $jlfMg.getCmdbGlobalConfigUrl)(workspaceId));
            const { limitInfo: limitInfo } = response;
            const { limitState: limitState = 'disabled', objectCount: objectCount, objectLimit: objectLimit } = limitInfo;
            setState({
                ...currentState,
                limitState: limitState,
                objectCount: objectCount,
                objectLimit: objectLimit
            });
            if (createAnalyticsEvent) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'refreshObjectCount succeeded');
        } catch (untypedError) {
            const error = untypedError instanceof Error ? untypedError : undefined;
            (0, $guiFP.default)({
                meta: {
                    id: 'refreshObjectCount',
                    packageName: 'jiraServicedeskCmdbObjectUsageMessaging',
                    teamName: 'krispy-krew'
                },
                error: error
            });
        }
    };

});

parcelRegister("lN170", function(module, exports) {

$parcel$export(module.exports, "setInitialData", () => $ee475ca00d561388$export$e493baf433de729b);

var $eW3Uf = parcelRequire("eW3Uf");

var $l0XeL = parcelRequire("l0XeL");
const $ee475ca00d561388$export$e493baf433de729b = ({ isJiraAdmin: isJiraAdmin, objectCount: objectCount, objectLimit: objectLimit, billingPeriod: billingPeriod, limitState: limitState, workspaceId: workspaceId })=>async ({ setState: setState })=>{
        const threshold = (0, $l0XeL.determineThreshold)({
            objectCount: objectCount,
            objectLimit: objectLimit
        });
        const dismissState = (0, $eW3Uf.LOCAL_STORAGE).get((0, $eW3Uf.DISMISSED_FOR_THRESHOLD_TYPE_KEY));
        const userRole = isJiraAdmin ? 'admin' : 'agent';
        if (dismissState && dismissState !== threshold && threshold !== 'none' && limitState !== 'disabled') (0, $eW3Uf.LOCAL_STORAGE).remove((0, $eW3Uf.DISMISSED_FOR_THRESHOLD_TYPE_KEY));
        setState({
            userRole: userRole,
            billingPeriod: billingPeriod,
            objectCount: objectCount,
            objectLimit: objectLimit,
            isDismissed: dismissState === threshold,
            limitState: limitState,
            workspaceId: workspaceId
        });
    };

});


parcelRegister("etmS8", function(module, exports) {

$parcel$export(module.exports, "getObjectUsageInfo", () => $ab551a2852a014e6$export$deea34ac3e790cc5);

var $eW3Uf = parcelRequire("eW3Uf");

var $l0XeL = parcelRequire("l0XeL");
const $ab551a2852a014e6$export$deea34ac3e790cc5 = (state, location)=>{
    const { objectCount: objectCount, objectLimit: objectLimit, limitState: limitState, userRole: userRole, billingPeriod: billingPeriod, isDismissed: isDismissed } = state;
    if (limitState === 'disabled') return 0, $eW3Uf.NONE;
    if (isDismissed && location !== 'import-data-modal') return 0, $eW3Uf.NONE;
    return (0, $l0XeL.determineObjectUsageInfo)({
        isJiraAdmin: userRole === 'admin',
        objectCount: objectCount,
        objectLimit: objectLimit,
        billingPeriod: billingPeriod,
        location: location,
        limitState: limitState
    });
};

});


parcelRegister("1THT4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5b6aae76f1b053c1$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $5b6aae76f1b053c1$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    admin80PercentMonthly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.admin-80-percent-monthly",
        "defaultMessage": "<b>You're running out of available Assets objects (< 20%).</b> Delete objects or <a>increase usage limit</a>."
    },
    admin90PercentMonthly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.admin-90-percent-monthly",
        "defaultMessage": "<b>You're nearly out of available Assets objects (< 10%).</b> Delete objects or <a>increase usage limit</a>."
    },
    adminLimitReachedMonthly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.admin-limit-reached-monthly",
        "defaultMessage": "<b>You're out of available Assets objects.</b> Delete objects or <a>increase usage limit</a> to add more objects."
    },
    admin80PercentYearly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.admin-80-percent-yearly",
        "defaultMessage": "<b>You're running out of available Assets objects (< 20%).</b> Delete objects or <a>get extra objects</a>."
    },
    admin90PercentYearly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.admin-90-percent-yearly",
        "defaultMessage": "<b>You\u2019re nearly out of available Assets objects (< 10%).</b> Delete objects or <a>get extra objects</a>."
    },
    adminLimitReachedYearly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.admin-limit-reached-yearly",
        "defaultMessage": "<b>You\u2019re out of available Assets objects.</b> Delete objects or <a>get extra objects</a> to add more objects."
    },
    agent90PercentMonthly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.agent-90-percent-monthly",
        "defaultMessage": "<b>You\u2019re nearly out of available Assets objects (< 10%).</b> Contact your admin to increase the usage limit."
    },
    agentLimitReachedMonthly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.agent-limit-reached-monthly",
        "defaultMessage": "<b>You\u2019re out of available Assets objects.</b> Contact your admin to increase the usage limit."
    },
    agent90PercentYearly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.agent-90-percent-yearly",
        "defaultMessage": "<b>You\u2019re nearly out of available Assets objects (< 10%).</b> Contact your admin to increase the usage limit."
    },
    agentLimitReachedYearly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.agent-limit-reached-yearly",
        "defaultMessage": "<b>You\u2019re out of available Assets objects.</b> Contact your admin to increase the usage limit."
    },
    warningIcon: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.warning-icon",
        "defaultMessage": "Warning icon"
    },
    errorIcon: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.error-icon",
        "defaultMessage": "Error icon"
    },
    dismissBanner: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.dismiss-banner",
        "defaultMessage": "Dismiss banner"
    }
});

});


parcelRegister("4XCmO", function(module, exports) {

$parcel$export(module.exports, "PreReleaseBanner", () => $0246a5c8c0934d35$export$7995d7f5d5b98c14);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $8xkEh = parcelRequire("8xkEh");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4kMup = parcelRequire("4kMup");

var $aZaPn = parcelRequire("aZaPn");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9wr2w = parcelRequire("9wr2w");
const $0246a5c8c0934d35$var$LOCAL_STORAGE = (0, $aZaPn.createLocalStorageProvider)('jsm-cbp-pre-release');
const $0246a5c8c0934d35$var$DISMISSED_KEY = 'dismissed';
const $0246a5c8c0934d35$export$7995d7f5d5b98c14 = ({ location: location })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isDismissed, setIsDismissed] = (0, $eUqFw.useState)($0246a5c8c0934d35$var$LOCAL_STORAGE.get($0246a5c8c0934d35$var$DISMISSED_KEY) != null);
    const onDismiss = ()=>{
        $0246a5c8c0934d35$var$LOCAL_STORAGE.set($0246a5c8c0934d35$var$DISMISSED_KEY, 'true');
        setIsDismissed(true);
    };
    if (isDismissed) return null;
    // Implementation to match Atlaskit banner, because AK banner wraps the content with multiple elements without full
    // width, so it's not possible to place the dismiss button at the end.
    const banner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        role: "alert",
        xcss: $0246a5c8c0934d35$var$containerStyles,
        backgroundColor: "color.background.neutral.bold",
        padding: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0246a5c8c0934d35$var$textStyles,
        as: "span"
    }, formatMessage((0, $9wr2w.messages).info), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        href: "https://www.atlassian.com/blog/announcements/jsm-cloud-pricing-packaging-update",
        target: "_blank",
        rel: "noopener",
        xcss: $0246a5c8c0934d35$var$linkStyles
    }, formatMessage((0, $9wr2w.messages).whatThisMeans))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8xkEh))), {
                ...iconProps,
                spacing: "none",
                color: "var(--ds-icon-inverse)"
            }),
        label: formatMessage((0, $9wr2w.messages).dismiss),
        onClick: onDismiss
    }));
    if (location === 'assets') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0246a5c8c0934d35$var$negateMarginStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0246a5c8c0934d35$var$negateMarginInnerStyles
    }, banner));
    // Add any custom wrapper styles for location === 'virtual-agent' if required
    return banner;
};
const $0246a5c8c0934d35$var$containerStyles = (0, $1ZAYh.xcss)({
    height: '3rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
});
const $0246a5c8c0934d35$var$textStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.inverse',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $0246a5c8c0934d35$var$linkStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.inverse',
    textDecoration: 'underline',
    ':hover': {
        color: 'color.text.inverse'
    },
    ':focus': {
        color: 'color.text.inverse'
    },
    ':active': {
        color: 'color.text.inverse'
    }
});
// nested wrappers due to no space.negative.500, maximum 400.
const $0246a5c8c0934d35$var$negateMarginStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.0',
    marginLeft: 'space.negative.400',
    marginRight: 'space.negative.400'
});
const $0246a5c8c0934d35$var$negateMarginInnerStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.negative.100',
    marginRight: 'space.negative.100'
});

});
parcelRegister("9wr2w", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0511151879f24531$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $0511151879f24531$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    info: {
        "id": "servicedesk-feature-usage-common.pre-release-banner.info",
        "defaultMessage": "Assets and the virtual agent are moving to consumption-based pricing."
    },
    whatThisMeans: {
        "id": "servicedesk-feature-usage-common.pre-release-banner.what-this-means",
        "defaultMessage": "What this means for your site."
    },
    dismiss: {
        "id": "servicedesk-feature-usage-common.pre-release-banner.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("lHQ9F", function(module, exports) {

$parcel$export(module.exports, "ObjectContainer", () => $adf6cfa5b4baa69f$export$58ea959b0b68b9ee);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7UYh2 = parcelRequire("7UYh2");

var $hqVAg = parcelRequire("hqVAg");

var $ixjcP = parcelRequire("ixjcP");

var $7dk6A = parcelRequire("7dk6A");

var $2IAbP = parcelRequire("2IAbP");
const $adf6cfa5b4baa69f$var$ObjectList = (props)=>{
    const { referencedObjects: referencedObjects } = props;
    const { numberOfObjectsDisplayed: numberOfObjectsDisplayed } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onRecentObjectClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'insightRecentObjectLozenge');
    }, [
        createAnalyticsEvent
    ]);
    if (referencedObjects.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($adf6cfa5b4baa69f$var$NoObjectsText, null, formatMessage((0, $2IAbP.messages).noObjectsToShow));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, referencedObjects.slice(0, numberOfObjectsDisplayed).map((object)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7UYh2.ReferencedObjectReadView), {
            key: object.id,
            id: object.id,
            objectKey: object.objectKey,
            label: object.label,
            avatar: object.avatar,
            onClick: onRecentObjectClick
        })));
};
const $adf6cfa5b4baa69f$export$58ea959b0b68b9ee = ()=>{
    const [numberOfObjectsDisplayed, setNumberOfObjectsDisplayed] = (0, $eUqFw.useState)(5);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ recentObjectState: recentObjectState }] = (0, $hqVAg.useLandingPageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onViewMoreClick = (0, $eUqFw.useCallback)(()=>{
        setNumberOfObjectsDisplayed(numberOfObjectsDisplayed + 5);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'insightRecentObjectsViewMore');
    }, [
        numberOfObjectsDisplayed,
        createAnalyticsEvent
    ]);
    const displayFooter = recentObjectState.type === 'success' && recentObjectState.recentObjects.length > numberOfObjectsDisplayed;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, recentObjectState.type === 'loading' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ixjcP.InsightRecentObjectContainerSkeleton), null), recentObjectState.type === 'error' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7dk6A.ErrorContent), null), recentObjectState.type === 'success' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $adf6cfa5b4baa69f$var$listHeaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $2IAbP.messages).objectSchemas))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($adf6cfa5b4baa69f$var$ListWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($adf6cfa5b4baa69f$var$ObjectList, {
        referencedObjects: recentObjectState.recentObjects,
        numberOfObjectsDisplayed: numberOfObjectsDisplayed
    }))), displayFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $adf6cfa5b4baa69f$var$listFooterStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        spacing: "none",
        onClick: onViewMoreClick
    }, formatMessage((0, $2IAbP.messages).viewMore))));
};
const $adf6cfa5b4baa69f$var$listHeaderStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $adf6cfa5b4baa69f$var$ListWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1p57u2gc _1e0c1txw _2lx21bp4 _4cvr1y6m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $adf6cfa5b4baa69f$var$NoObjectsText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1n3s _1wyb1crf _1p57idpf",
            __cmplp.className
        ])
    });
});
const $adf6cfa5b4baa69f$var$listFooterStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.150'
});

});
parcelRegister("7UYh2", function(module, exports) {

$parcel$export(module.exports, "ReferencedObjectCreateView", () => $cf17ddbe7f762323$export$ea78f3bd97835b9f);
$parcel$export(module.exports, "ReferencedObjectReadView", () => $cf17ddbe7f762323$export$ae3e6ca9eba42ca);
$parcel$export(module.exports, "ReferencedObjectsReadView", () => $cf17ddbe7f762323$export$a03416ddf396563c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $jG2Eu = parcelRequire("jG2Eu");


var $8cU5f = parcelRequire("8cU5f");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $kw5JY = parcelRequire("kw5JY");

var $hoasw = parcelRequire("hoasw");

var $272oI = parcelRequire("272oI");

var $9diuQ = parcelRequire("9diuQ");

var $l7ZPk = parcelRequire("l7ZPk");
const $cf17ddbe7f762323$var$TooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf17ddbe7f762323$var$StyledTooltipTag, {
        ref: ref,
        ...props
    }));
const $cf17ddbe7f762323$export$25bd2ea9110ffe38 = ({ label: label, avatar: avatar, icon: icon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hoasw.UnstyledInsightIcon), {
        iconUrl: (0, $kw5JY.getUniqueIconUrl)(icon),
        size: "xsmall",
        label: label
    }), avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hoasw.UnstyledInsightIcon), {
        mediaClientConfig: avatar.mediaClientConfig,
        iconUrl: avatar.url48,
        size: "xsmall",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label,
        tag: $cf17ddbe7f762323$var$TooltipTag,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf17ddbe7f762323$var$ReferencedObjectLabel, null, label)));
const $cf17ddbe7f762323$export$ea78f3bd97835b9f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf17ddbe7f762323$var$PlainText, {
        forceMaxWidth: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf17ddbe7f762323$export$25bd2ea9110ffe38, {
        label: props.label,
        icon: props.icon
    }));
const $cf17ddbe7f762323$var$DEFAULT_APPEARANCE = 'card';
const $cf17ddbe7f762323$export$ae3e6ca9eba42ca = ({ appearance: appearance = $cf17ddbe7f762323$var$DEFAULT_APPEARANCE, includeLink: includeLink = true, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), forceMaxWidth: forceMaxWidth = true, ...referencedObject })=>{
    const { id: id, label: label, avatar: avatar } = referencedObject;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf17ddbe7f762323$export$25bd2ea9110ffe38, {
        label: label,
        avatar: avatar
    });
    if (appearance === 'card') return includeLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf17ddbe7f762323$var$LozengeLink, {
        to: (0, $272oI.createObjectDetailUrl)(id),
        onClick: onClick,
        forceMaxWidth: forceMaxWidth
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf17ddbe7f762323$var$LozengeText, {
        forceMaxWidth: forceMaxWidth
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf17ddbe7f762323$var$PlainText, {
        forceMaxWidth: forceMaxWidth
    }, content);
};
const $cf17ddbe7f762323$export$a03416ddf396563c = ({ referencedObjects: referencedObjects, appearance: appearance = $cf17ddbe7f762323$var$DEFAULT_APPEARANCE, includeLink: includeLink = true, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const hasValues = referencedObjects.length > 0;
    const placeholderText = showPlaceholderIfEmpty ? formatMessage((0, $9diuQ.default).placeholderNoneSelected) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l7ZPk.ReadViewContainer), {
        isPlaceholder: !hasValues
    }, hasValues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf17ddbe7f762323$var$ReferencedObjectsContainer, null, referencedObjects.map((referencedObject)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf17ddbe7f762323$export$ae3e6ca9eba42ca // This needs to be ID because when creating a new object the key is a blank string breaking the map
        , {
            key: referencedObject.id,
            ...referencedObject,
            includeLink: includeLink,
            appearance: appearance
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l7ZPk.PlaceholderSpacer), null, placeholderText));
};
const $cf17ddbe7f762323$var$ReferencedObjectsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1n261g80 _zulp1b66 _p12f1osq",
            __cmplp.className
        ])
    });
});
const $cf17ddbe7f762323$var$ellipsesTruncation = /*#__PURE__*/ (0, $kwce8.css)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $cf17ddbe7f762323$var$maxWidth = /*#__PURE__*/ (0, $kwce8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $c9TLT.gridSize) * 19}px`
});
const $cf17ddbe7f762323$var$lozengeStyles = /*#__PURE__*/ (0, $kwce8.css)({
    display: 'inline-flex',
    alignItems: 'center',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-100, 8px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-surface-raised, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$exports).N800})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $c9TLT.borderRadius)}px`,
    marginRight: "var(--ds-space-050, 4px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.forceMaxWidth ? $cf17ddbe7f762323$var$maxWidth : null, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$cf17ddbe7f762323$var$ellipsesTruncation, {
    boxShadow: "var(--ds-shadow-raised, 0 1px 1px rgba(9,30,66,0.25),0 0 1px 1px rgba(9,30,66,0.13))"
}); // FIXME: type error passing result of `css` to `styled`
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf17ddbe7f762323$var$LozengeText = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "gcmv2o-0"
})`${$cf17ddbe7f762323$var$lozengeStyles};`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf17ddbe7f762323$var$ReferencedObjectLabel = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "gcmv2o-1"
})({
    marginLeft: "var(--ds-space-050, 4px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$cf17ddbe7f762323$var$ellipsesTruncation); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf17ddbe7f762323$var$PlainText = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "gcmv2o-2"
})({
    display: 'flex',
    alignItems: 'center',
    padding: `${"var(--ds-space-025, 2px)"} 0`,
    marginRight: "var(--ds-space-050, 4px)",
    backgroundColor: 'inherit',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$exports).N800})`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.forceMaxWidth ? $cf17ddbe7f762323$var$maxWidth : null);
const $cf17ddbe7f762323$var$LozengeLink = /*#__PURE__*/ (0, $kwce8.default)((0, $lB25E.Link)).withConfig({
    componentId: "gcmv2o-3"
})`${$cf17ddbe7f762323$var$lozengeStyles};&:focus,&:hover{background-color:${`var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$exports).N20})`};color:${`var(--ds-text, ${(0, $73a5c9d720aa66e1$exports).N800})`};text-decoration:none;}&:active{background-color:${`var(--ds-background-neutral-subtle-pressed, ${(0, $73a5c9d720aa66e1$exports).N30})`};}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf17ddbe7f762323$var$StyledTooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1ul9idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kw5JY", function(module, exports) {

$parcel$export(module.exports, "getUniqueIconUrl", () => $8040c064ed47967e$export$85a1f43e7ff44c3f);

var $guiFP = parcelRequire("guiFP");
const $8040c064ed47967e$export$85a1f43e7ff44c3f = (icon, options = {
    size: '48'
})=>{
    const sizeUrl = options.size === '48' ? icon.url48 : icon.url16;
    try {
        const url = new URL(sizeUrl);
        // Give each icon a unique URL by appending the iconId query param
        url.searchParams.append('iconId', icon.id);
        return url.toString();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getUniqueIconUrl',
                packageName: 'jiraServicedeskInsightIcon',
                teamName: 'falcons'
            }
        });
        return sizeUrl;
    }
};

});

parcelRegister("hoasw", function(module, exports) {

$parcel$export(module.exports, "InsightIcon", () => $92badab1baa94ec2$export$4f72cced31fa9b94);
$parcel$export(module.exports, "MemoizedInsightIcon", () => $92badab1baa94ec2$export$55641517b59933d7);
$parcel$export(module.exports, "UnstyledInsightIcon", () => $92badab1baa94ec2$export$30c7947f25987be2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eri7S = parcelRequire("eri7S");
var $iJlfe = parcelRequire("iJlfe");
var $aWAMO = parcelRequire("aWAMO");

var $b8FLL = parcelRequire("b8FLL");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");
const $92badab1baa94ec2$export$cc575ace31787a4e = (mediaClientConfig)=>Boolean(mediaClientConfig.mediaBaseUrl) && Boolean(mediaClientConfig.mediaJwtToken) && Boolean(mediaClientConfig.issuer) && Boolean(mediaClientConfig.fileId);
const $92badab1baa94ec2$export$d80733771196ad02 = (mediaClientConfig)=>Boolean(mediaClientConfig.mediaBaseUrl) && Boolean(mediaClientConfig.mediaJwtToken) && Boolean(mediaClientConfig.clientId) && Boolean(mediaClientConfig.fileId);
const $92badab1baa94ec2$var$DefaultIcon = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "square",
        size: size,
        name: label
    });
const $92badab1baa94ec2$export$a39db5532f57c7c2 = (clientAuth)=>Promise.resolve({
        clientId: clientAuth.clientId,
        token: clientAuth.mediaJwtToken,
        baseUrl: clientAuth.mediaBaseUrl
    });
const $92badab1baa94ec2$export$a5f760203816608a = (asapAuth)=>Promise.resolve({
        asapIssuer: asapAuth.issuer,
        token: asapAuth.mediaJwtToken,
        baseUrl: asapAuth.mediaBaseUrl
    });
const $92badab1baa94ec2$export$4f72cced31fa9b94 = (props)=>{
    const { iconUrl: iconUrl, size: size, label: label, mediaClientConfig: mediaClientConfig } = props;
    if ((0, $eI5EY.fg)('assets_rearch_media_client_auth')) {
        if (!mediaClientConfig || $92badab1baa94ec2$export$d80733771196ad02(mediaClientConfig) === false) {
            if (iconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                src: iconUrl,
                appearance: "square",
                size: size,
                name: label
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92badab1baa94ec2$var$DefaultIcon, {
                size: size,
                label: label
            });
        }
    } else if (!mediaClientConfig || $92badab1baa94ec2$export$cc575ace31787a4e(mediaClientConfig) === false) {
        if (iconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            src: iconUrl,
            appearance: "square",
            size: size,
            name: label
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92badab1baa94ec2$var$DefaultIcon, {
            size: size,
            label: label
        });
    }
    const fileIdentifier = {
        id: mediaClientConfig.fileId,
        mediaItemType: 'file'
    };
    const imageSize = {
        width: (0, $eri7S.AVATAR_SIZES)[size],
        height: (0, $eri7S.AVATAR_SIZES)[size]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b8FLL.MediaImageWithErrorBoundary), {
        identifier: fileIdentifier,
        mediaClientConfig: {
            authProvider: ()=>(0, $eI5EY.fg)('assets_rearch_media_client_auth') ? $92badab1baa94ec2$export$a39db5532f57c7c2(mediaClientConfig) : $92badab1baa94ec2$export$a5f760203816608a(mediaClientConfig)
        },
        apiConfig: imageSize
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aWAMO.default), {
            appearance: "square",
            size: size
        });
        if (error) {
            (0, $guiFP.default)({
                error: // @ts-expect-error - TS2322 - Type 'true' is not assignable to type 'Error | undefined'.
                error,
                meta: {
                    id: 'insightIcon',
                    packageName: 'jiraServicedeskInsightIcon',
                    teamName: 'falcons'
                }
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92badab1baa94ec2$var$DefaultIcon, {
                size: size,
                label: label
            });
        }
        if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92badab1baa94ec2$var$DefaultIcon, {
            size: size,
            label: label
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            src: data.src,
            appearance: "square",
            size: size,
            name: label
        });
    });
};
const $92badab1baa94ec2$export$55641517b59933d7 = /*#__PURE__*/ (0, $eUqFw.memo)($92badab1baa94ec2$export$4f72cced31fa9b94);
const $92badab1baa94ec2$export$30c7947f25987be2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92badab1baa94ec2$var$UnstyledInsightIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92badab1baa94ec2$export$55641517b59933d7, props));
/**
 * The reason for calling !important on display block is to ovveride the inherited
 * CSS from Avatar atlaskit component in order to centre the icon within the reference
 * object container.
 */ // Double check the shadow !
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $92badab1baa94ec2$var$UnstyledInsightIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81i6y _p7r1tcjq _1ugpglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aWAMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $77d4bbf842392835$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");
function $77d4bbf842392835$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $77d4bbf842392835$var$skeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $eri7S.CSS_VAR_AVATAR_BGCOLOR)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    border: `${(0, $eri7S.BORDER_WIDTH)}px solid transparent`
});
const $77d4bbf842392835$var$sizeStyles = Object.entries((0, $eri7S.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $byn9U.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${size}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${size}px`
        })
    };
}, {});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $77d4bbf842392835$var$radiusStyles = Object.entries((0, $eri7S.AVATAR_RADIUS)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $byn9U.css)({
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderRadius: `${size}px`
        })
    };
}, {});
const $77d4bbf842392835$var$defaultRadiusStyles = {
    name: "1by8p7f",
    styles: "border-radius:var(--ds-border-radius-circle, 50%)"
};
const $77d4bbf842392835$var$strongOpacityStyles = {
    name: "19sqbed",
    styles: "opacity:0.3"
};
const $77d4bbf842392835$var$defaultOpacityStyles = {
    name: "1rz7oiv",
    styles: "opacity:0.15"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $77d4bbf842392835$var$Skeleton = ({ size: size, appearance: appearance, color: color, weight: weight })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $77d4bbf842392835$var$skeletonStyles,
            $77d4bbf842392835$var$sizeStyles[size ?? 'medium'],
            appearance === 'square' ? $77d4bbf842392835$var$radiusStyles[size ?? 'medium'] : $77d4bbf842392835$var$defaultRadiusStyles,
            weight === 'strong' ? $77d4bbf842392835$var$strongOpacityStyles : $77d4bbf842392835$var$defaultOpacityStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $eri7S.CSS_VAR_AVATAR_BGCOLOR)]: color ?? 'currentColor'
        }
    });
var $77d4bbf842392835$export$2e2bcd8739ae039 = $77d4bbf842392835$var$Skeleton;

});

parcelRegister("b8FLL", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithErrorBoundary", () => $57e59fb61c90cfb2$export$758a2fef95a29ad0);

var $eUqFw = parcelRequire("eUqFw");

var $jb3WS = parcelRequire("jb3WS");

var $3qKWD = parcelRequire("3qKWD");
const $57e59fb61c90cfb2$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jb3WS.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children({
            loading: false,
            error: true
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3qKWD.MediaImageWithMediaClient), props));

});
parcelRegister("jb3WS", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("eUqFw")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("3qKWD", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithMediaClient", () => $bb0b784caf1f45fa$export$8acd7eecc88dfeb5);

var $eUqFw = parcelRequire("eUqFw");

var $mtjJr = parcelRequire("mtjJr");

var $1xvoH = parcelRequire("1xvoH");
const $bb0b784caf1f45fa$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, getSsrScriptProps: getSsrScriptProps } = (0, $1xvoH.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children({
        loading: status === 'loading',
        error: status === 'error',
        data: status === 'succeeded' ? {
            status: status,
            src: preview?.dataURI
        } : undefined
    }), getSsrScriptProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("script", getSsrScriptProps()));
};
const $bb0b784caf1f45fa$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $eUqFw.useMemo)(()=>(0, $mtjJr.withMediaClient)($bb0b784caf1f45fa$var$MediaImageBase), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MediaImageComponent, props);
};

});
parcelRegister("mtjJr", function(module, exports) {

$parcel$export(module.exports, "withMediaClient", () => $9c77d1cdc83d45af$export$9f7977d4a2561bee);

var $eUqFw = parcelRequire("eUqFw");

var $kJ7yF = parcelRequire("kJ7yF");
const $9c77d1cdc83d45af$export$9f7977d4a2561bee = (Component)=>({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJ7yF.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                ...otherProps,
                mediaClient: value
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJ7yF.MediaClientProvider), {
                clientConfig: mediaClientConfig
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJ7yF.MediaClientContext).Consumer, null, (client)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                    ...otherProps,
                    mediaClient: client
                }))));

});
parcelRegister("kJ7yF", function(module, exports) {

$parcel$export(module.exports, "MediaClientContext", () => $2a63c6834b952386$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "getMediaClient", () => $2a63c6834b952386$export$c9ecbc1b719fd417);
$parcel$export(module.exports, "MediaClientProvider", () => $2a63c6834b952386$export$5bff351c86f56d97);
$parcel$export(module.exports, "useMediaClient", () => $2a63c6834b952386$export$8b3e87ea56c3a345);

var $eUqFw = parcelRequire("eUqFw");

var $go0co = parcelRequire("go0co");
const $2a63c6834b952386$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(undefined);
const $2a63c6834b952386$export$f92e83e86b03c398 = new Map();
const $2a63c6834b952386$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $go0co.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $2a63c6834b952386$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $go0co.MediaClient)(mediaClientConfig);
        $2a63c6834b952386$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};
const $2a63c6834b952386$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $eUqFw.useMemo)(()=>$2a63c6834b952386$export$c9ecbc1b719fd417(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a63c6834b952386$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient
    }, children);
};
const $2a63c6834b952386$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($2a63c6834b952386$export$ba5d7212f2b4619f);
    if (!mediaClient) throw new Error('No MediaClient set, use MediaClientProvider to set one');
    return mediaClient;
};

});
parcelRegister("go0co", function(module, exports) {

$parcel$export(module.exports, "MediaClient", () => $53af8e7882f0f992$export$fba8b4ca6d386aec);

var $4FH8r = parcelRequire("4FH8r");
parcelRequire("2q7Xj");
var $fmEc3 = parcelRequire("fmEc3");

var $EEZOU = parcelRequire("EEZOU");

var $3ixzU = parcelRequire("3ixzU");

var $eJAUz = parcelRequire("eJAUz");
parcelRequire("gHZqD");
var $exlxT = parcelRequire("exlxT");

class $53af8e7882f0f992$export$fba8b4ca6d386aec {
    constructor(mediaClientConfig, store = (0, $exlxT.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi ?? new (0, $EEZOU.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: mediaClientConfig.useSha256ForUploads ? (0, $fmEc3.ChunkHashAlgorithm).Sha256 : (0, $fmEc3.ChunkHashAlgorithm).Sha1
        });
        this.config = mediaClientConfig;
        this.file = new (0, $3ixzU.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $4FH8r.EventEmitter2)();
        this.stargate = new (0, $eJAUz.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
	 * @internal
	 */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params) {
        return this.mediaStore.getFileImageURLSync(id, params);
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("6o5wg"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("4FH8r", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $2fFJv !== 'undefined' && $2fFJv.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $2fFJv.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("2q7Xj", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => (parcelRequire("iE8r2")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("jrFS0")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("jrFS0")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("fmEc3")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $iE8r2 = parcelRequire("iE8r2");

var $jrFS0 = parcelRequire("jrFS0");

var $fmEc3 = parcelRequire("fmEc3");

});
parcelRegister("iE8r2", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => $4cdeb32efb36e469$export$8cef61637918b288);

var $4FH8r = parcelRequire("4FH8r");

var $6roQF = parcelRequire("6roQF");
const $4cdeb32efb36e469$export$8cef61637918b288 = {
    streams: new (0, $6roQF.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $4FH8r.EventEmitter2)()
};

});
parcelRegister("6roQF", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("jrFS0", function(module, exports) {

$parcel$export(module.exports, "isClientBasedAuth", () => $a5c9edcfc78df537$export$6ba49fcac9c46e54);
$parcel$export(module.exports, "authToOwner", () => $a5c9edcfc78df537$export$17f6055767a8d96a);
function $a5c9edcfc78df537$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $a5c9edcfc78df537$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
const $a5c9edcfc78df537$export$17f6055767a8d96a = (auth)=>{
    if ($a5c9edcfc78df537$export$af1ab14f2246ef72(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});

parcelRegister("fmEc3", function(module, exports) {

$parcel$export(module.exports, "ChunkHashAlgorithm", () => $2714010903136296$export$d3e73a50cc549c2e);
var $2714010903136296$export$d3e73a50cc549c2e;
(function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha1"] = "sha1";
    ChunkHashAlgorithm["Sha256"] = "sha256";
})($2714010903136296$export$d3e73a50cc549c2e || ($2714010903136296$export$d3e73a50cc549c2e = {}));

});


parcelRegister("EEZOU", function(module, exports) {

$parcel$export(module.exports, "MediaStore", () => $1e7feef2970a1c0d$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $1e7feef2970a1c0d$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $1e7feef2970a1c0d$export$20f9315304dd6726);
parcelRequire("2q7Xj");
var $fmEc3 = parcelRequire("fmEc3");
var $jrFS0 = parcelRequire("jrFS0");

var $5Cq8b = parcelRequire("5Cq8b");

var $aFsdc = parcelRequire("aFsdc");

var $4M5UY = parcelRequire("4M5UY");

var $5AvHR = parcelRequire("5AvHR");

var $2WGjX = parcelRequire("2WGjX");

var $gNTpJ = parcelRequire("gNTpJ");

var $bvZYv = parcelRequire("bvZYv");

var $XHGTv = parcelRequire("XHGTv");

var $6daei = parcelRequire("6daei");
const $1e7feef2970a1c0d$var$MEDIA_API_REGION = 'media-api-region';
const $1e7feef2970a1c0d$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $1e7feef2970a1c0d$var$extendImageParams = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': params?.['max-age'] ?? (0, $aFsdc.FILE_CACHE_MAX_AGE),
        allowAnimated: params?.allowAnimated ?? true,
        mode: params?.mode ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $aFsdc.MAX_RESOLUTION),
            height: (0, $aFsdc.MAX_RESOLUTION)
        } : {}
    };
};
const $1e7feef2970a1c0d$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
class $1e7feef2970a1c0d$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.resolveAuth = (authContext)=>(0, $bvZYv.resolveAuth)(this.config.authProvider, authContext);
        this.resolveInitialAuth = ()=>(0, $bvZYv.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $fmEc3.ChunkHashAlgorithm).Sha1;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const options = {
            params: $1e7feef2970a1c0d$var$extendImageParams(params),
            auth: auth
        };
        const imageEndpoint = !(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery') ? 'image/cdn' : 'image';
        return (0, $gNTpJ.mapToMediaCdnUrl)((0, $2WGjX.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options));
    }
    async getFileBinary(id, collectionName, maxAge = (0, $aFsdc.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = !(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery') ? 'binary/cdn' : 'binary';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, undefined, true).then((0, $2WGjX.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $aFsdc.FILE_CACHE_MAX_AGE)) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const binaryEndpoint = !(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery') ? 'binary/cdn' : 'binary';
        return (0, $gNTpJ.mapToMediaCdnUrl)((0, $2WGjX.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options));
    }
    async getArtifactURL(artifacts, artifactName, collectionName) {
        const artifactUrl = (0, $4M5UY.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': (0, $aFsdc.FILE_CACHE_MAX_AGE)
            },
            auth: auth
        };
        return (0, $2WGjX.createUrl)(artifactUrl, options);
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = !(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery') ? 'image/cdn' : 'image';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: $1e7feef2970a1c0d$var$extendImageParams(params, fetchMaxRes),
            headers: headers,
            traceContext: traceContext,
            addMediaClientParam: (0, $XHGTv.fg)('platform.media-card-performance-observer_a803k') && true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $2WGjX.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, options);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam } = options;
        const auth = await this.resolveAuth(authContext);
        const clientId = (0, $jrFS0.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = traceContext ? {
            ...traceContext,
            spanId: traceContext?.spanId || (0, $5Cq8b.getRandomHex)(8)
        } : undefined;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $gNTpJ.mapToMediaCdnUrl)(url);
        const response = await (0, $5AvHR.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: addMediaClientParam ? {
                ...params,
                clientId: clientId
            } : params,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $1e7feef2970a1c0d$var$setKeyValueInSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $1e7feef2970a1c0d$var$setKeyValueInSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}
const $1e7feef2970a1c0d$var$getValueFromSessionStorage = (key)=>{
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $1e7feef2970a1c0d$var$setKeyValueInSessionStorage = (key, value)=>{
    if (!value || !(window && window.sessionStorage)) return;
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
const $1e7feef2970a1c0d$export$c8b741e18397852a = ()=>{
    return $1e7feef2970a1c0d$var$getValueFromSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_ENVIRONMENT);
};
const $1e7feef2970a1c0d$export$20f9315304dd6726 = ()=>{
    return $1e7feef2970a1c0d$var$getValueFromSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_REGION);
};

});
parcelRegister("5Cq8b", function(module, exports) {

$parcel$export(module.exports, "isUndefined", () => $b1f5fb9992743b46$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $b1f5fb9992743b46$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $b1f5fb9992743b46$export$456b25e3a9b4a843);
const $b1f5fb9992743b46$export$fce6876652108ab = (value)=>value === undefined;
const $b1f5fb9992743b46$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $b1f5fb9992743b46$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $b1f5fb9992743b46$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $b1f5fb9992743b46$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $b1f5fb9992743b46$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $b1f5fb9992743b46$export$456b25e3a9b4a843(byte) {
    let randomHex;
    if (window?.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $b1f5fb9992743b46$var$getRandomHexValues(byte);
    }
    else randomHex = $b1f5fb9992743b46$var$getRandomHexValues(byte);
    return randomHex;
}

});

parcelRegister("aFsdc", function(module, exports) {

$parcel$export(module.exports, "RECENTS_COLLECTION", () => $8452033603633a1a$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $8452033603633a1a$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $8452033603633a1a$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $8452033603633a1a$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $8452033603633a1a$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $8452033603633a1a$export$f14f521f3d306044);

var $bYwuj = parcelRequire("bYwuj");
const $8452033603633a1a$export$860a16125e30000b = 'recents';
const $8452033603633a1a$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $8452033603633a1a$export$6e70f30e392bc53f = 4096;
const $8452033603633a1a$export$c1abb8bab1e615cd = 5 * (0, $bYwuj.DATA_UNIT).MB;
const $8452033603633a1a$export$3d5157f0def70e54 = 1000;
const $8452033603633a1a$export$f14f521f3d306044 = 2 * (0, $bYwuj.DATA_UNIT).TB;

});
parcelRegister("bYwuj", function(module, exports) {

$parcel$export(module.exports, "DATA_UNIT", () => $e9c15b08e9162a33$export$76cfea4c354af843);
const $e9c15b08e9162a33$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
var $e9c15b08e9162a33$export$76cfea4c354af843;
(function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
})($e9c15b08e9162a33$export$76cfea4c354af843 || ($e9c15b08e9162a33$export$76cfea4c354af843 = {}));

});


parcelRegister("4M5UY", function(module, exports) {

$parcel$export(module.exports, "getArtifactUrl", () => $d9f7ddb4d1f162b2$export$1cc24defa44e7f84);

var $XHGTv = parcelRequire("XHGTv");

var $gNTpJ = parcelRequire("gNTpJ");

var $6daei = parcelRequire("6daei");
const $d9f7ddb4d1f162b2$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    if (!(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery')) return (0, $gNTpJ.mapToMediaCdnUrl)(`${artifacts[prop]?.url}/cdn`);
    return artifacts[prop]?.url;
};

});
parcelRegister("gNTpJ", function(module, exports) {

$parcel$export(module.exports, "mapToMediaCdnUrl", () => $5aace4118a232dd4$export$fb88a576cf28364d);

var $XHGTv = parcelRequire("XHGTv");

var $6daei = parcelRequire("6daei");
const $5aace4118a232dd4$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
function $5aace4118a232dd4$export$fb88a576cf28364d(url) {
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if (!(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery') && (0, $XHGTv.fg)('platform.media-cdn-single-host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = $5aace4118a232dd4$export$8a9b6ab3569a543a[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});
parcelRegister("6daei", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $954ab823235da1ff$export$64d6499adf9b2e51);
const $954ab823235da1ff$var$FEDRAMP_MODERATE = 'fedramp-moderate';
function $954ab823235da1ff$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $954ab823235da1ff$var$FEDRAMP_MODERATE;
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});



parcelRegister("5AvHR", function(module, exports) {

$parcel$export(module.exports, "request", () => $4a84a560f69f3535$export$b5fe3f66a567bec0);

var $7aQon = parcelRequire("7aQon");

var $2WGjX = parcelRequire("2WGjX");
async function $4a84a560f69f3535$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $2WGjX.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $2WGjX.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $2WGjX.createProcessFetchResponse)(metadata));
    return (0, $2WGjX.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("7aQon", function(module, exports) {

$parcel$export(module.exports, "RequestError", () => $9c115d8974651e85$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $9c115d8974651e85$export$3717b1ffef4428ea);

var $6bBrC = parcelRequire("6bBrC");
class $9c115d8974651e85$export$43ee7d0e4f429743 extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason);
        this.reason = reason;
        this.metadata = metadata;
        this.innerError = innerError;
    }
    get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            innerError: innerError
        };
    }
}
function $9c115d8974651e85$export$3717b1ffef4428ea(err) {
    return err instanceof $9c115d8974651e85$export$43ee7d0e4f429743;
}

});
parcelRegister("6bBrC", function(module, exports) {

$parcel$export(module.exports, "BaseMediaClientError", () => $acff2c6dc8396dfc$export$2b0aca14d61c3190);

var $eKK8L = parcelRequire("eKK8L");
class $acff2c6dc8396dfc$export$2b0aca14d61c3190 extends Error {
    constructor(message){
        super(message);
        this.message = message;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}

});
parcelRegister("eKK8L", function(module, exports) {

$parcel$export(module.exports, "isMediaClientError", () => $11f35e187e1f2fdf$export$2491e0bbdb59256e);
$parcel$export(module.exports, "getMediaClientErrorReason", () => $11f35e187e1f2fdf$export$c15d72765ee2baa4);
function $11f35e187e1f2fdf$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $11f35e187e1f2fdf$export$c15d72765ee2baa4(err) {
    return $11f35e187e1f2fdf$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}

});



parcelRegister("2WGjX", function(module, exports) {

$parcel$export(module.exports, "isRateLimitedError", () => $6c6863351bba029c$export$bc96a6a479480590);
$parcel$export(module.exports, "createUrl", () => $6c6863351bba029c$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $6c6863351bba029c$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $6c6863351bba029c$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $6c6863351bba029c$export$5cc7b0795397da86);
$parcel$export(module.exports, "fetchRetry", () => $6c6863351bba029c$export$782df2acbe10b22c);
$parcel$export(module.exports, "createRequestErrorReason", () => $6c6863351bba029c$export$6397609af718d008);
$parcel$export(module.exports, "createProcessFetchResponse", () => $6c6863351bba029c$export$6e2e477edb7d6032);
parcelRequire("2q7Xj");
var $jrFS0 = parcelRequire("jrFS0");

var $hFyZ6 = parcelRequire("hFyZ6");

var $7aQon = parcelRequire("7aQon");
function $6c6863351bba029c$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $6c6863351bba029c$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $6c6863351bba029c$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $6c6863351bba029c$export$bc96a6a479480590(error) {
    return !!error && (0, $7aQon.isRequestError)(error) && error.attributes.statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $6c6863351bba029c$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $6c6863351bba029c$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$6c6863351bba029c$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$6c6863351bba029c$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $6c6863351bba029c$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $jrFS0.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $6c6863351bba029c$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth?.baseUrl);
    const authParams = auth && (0, $hFyZ6.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.append(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $6c6863351bba029c$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...$6c6863351bba029c$export$eaf4479116d2f925(auth),
        ...$6c6863351bba029c$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $6c6863351bba029c$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $7aQon.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$6c6863351bba029c$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $6c6863351bba029c$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $7aQon.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$6c6863351bba029c$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $6c6863351bba029c$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    maxAttempts: 5,
    factor: 2
};
function $6c6863351bba029c$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $7aQon.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $6c6863351bba029c$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$6c6863351bba029c$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $6c6863351bba029c$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($6c6863351bba029c$export$de0b576cf7ce4a53(err)) throw new (0, $7aQon.RequestError)('clientAbortedRequest', metadata, err);
        if (!$6c6863351bba029c$export$ad8c5cf7dd4c3caf(err) && !(0, $7aQon.isRequestError)(err) || (0, $7aQon.isRequestError)(err) && (!err.metadata || !err.metadata.statusCode || err.metadata.statusCode < 500)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $7aQon.isRequestError)(lastError)) throw $6c6863351bba029c$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $7aQon.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $6c6863351bba029c$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $6c6863351bba029c$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $6c6863351bba029c$export$6397609af718d008(statusCode);
    return new (0, $7aQon.RequestError)(reason, {
        ...metadata,
        ...$6c6863351bba029c$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $6c6863351bba029c$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $6c6863351bba029c$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $6c6863351bba029c$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("hFyZ6", function(module, exports) {

$parcel$export(module.exports, "mapAuthToQueryParameters", () => $032b1e5883aca6a7$export$6833b130611df767);
parcelRequire("2q7Xj");
var $jrFS0 = parcelRequire("jrFS0");
function $032b1e5883aca6a7$export$6833b130611df767(auth) {
    if ((0, $jrFS0.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});



parcelRegister("bvZYv", function(module, exports) {

$parcel$export(module.exports, "resolveAuth", () => $9dc00fbb50183c87$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $9dc00fbb50183c87$export$5211e1371264aec3);

var $89khs = parcelRequire("89khs");

var $aSVFn = parcelRequire("aSVFn");
const $9dc00fbb50183c87$export$560085fe411c0660 = 10000;
const $9dc00fbb50183c87$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $9dc00fbb50183c87$export$560085fe411c0660)=>{
    let auth;
    try {
        auth = await Promise.race([
            authProvider(authContext),
            (0, $aSVFn.rejectTimeout)(authProviderTimeout, new (0, $89khs.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        if (err instanceof (0, $89khs.MediaStoreError)) throw err;
        throw new (0, $89khs.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $89khs.MediaStoreError)('emptyAuth');
    /*
    We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
    Token expiration check in the frontend is a bad idea. Don't do it!
    More info:
    https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
    https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
  */ return auth;
};
const $9dc00fbb50183c87$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $89khs.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("89khs", function(module, exports) {

$parcel$export(module.exports, "MediaStoreError", () => $1f9b2d64052a14af$export$b78480bd311630bc);
$parcel$export(module.exports, "isMediaStoreError", () => $1f9b2d64052a14af$export$8d2a9b675b2ce37a);

var $6bBrC = parcelRequire("6bBrC");
class $1f9b2d64052a14af$export$b78480bd311630bc extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason);
        this.reason = reason;
        this.innerError = innerError;
    }
    get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}
function $1f9b2d64052a14af$export$8d2a9b675b2ce37a(err) {
    return err instanceof $1f9b2d64052a14af$export$b78480bd311630bc;
}

});

parcelRegister("aSVFn", function(module, exports) {

$parcel$export(module.exports, "rejectTimeout", () => $e63044c0dd9a5237$export$cf2d2a1124beacb2);
const $e63044c0dd9a5237$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $e63044c0dd9a5237$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});



parcelRegister("3ixzU", function(module, exports) {

$parcel$export(module.exports, "FileFetcherImpl", () => $f9763f928076fcdc$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("fIVY8")).FileFetcherError);

var $hIoOm = parcelRequire("hIoOm");

var $aynDk = parcelRequire("aynDk");

var $dFBS3 = parcelRequire("dFBS3");
parcelRequire("2q7Xj");
var $jrFS0 = parcelRequire("jrFS0");

var $8w4F1 = parcelRequire("8w4F1");

var $EEZOU = parcelRequire("EEZOU");

var $9x67R = parcelRequire("9x67R");

var $fIVY8 = parcelRequire("fIVY8");

var $eSb3E = parcelRequire("eSb3E");

var $1l4qL = parcelRequire("1l4qL");

var $59gZB = parcelRequire("59gZB");

var $aFsdc = parcelRequire("aFsdc");

var $bxYYu = parcelRequire("bxYYu");

var $bVMx4 = parcelRequire("bVMx4");

var $04AOJ = parcelRequire("04AOJ");

var $9sBfG = parcelRequire("9sBfG");

var $dpRAQ = parcelRequire("dpRAQ");

var $eqcfa = parcelRequire("eqcfa");
var $9BeXg = parcelRequire("9BeXg");

var $cfjUA = parcelRequire("cfjUA");

var $rMufQ = parcelRequire("rMufQ");

var $3izHV = parcelRequire("3izHV");

var $cILCr = parcelRequire("cILCr");

var $eqlnz = parcelRequire("eqlnz");

var $6wdWp = parcelRequire("6wdWp");
parcelRequire("gHZqD");
var $exlxT = parcelRequire("exlxT");
class $f9763f928076fcdc$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $exlxT.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.getErrorFileState = (error, id, occurrenceKey)=>typeof error === 'string' ? {
                status: 'error',
                id: id,
                reason: error,
                occurrenceKey: occurrenceKey,
                message: error
            } : {
                status: 'error',
                id: id,
                reason: error?.reason,
                details: error?.attributes,
                occurrenceKey: occurrenceKey,
                message: error?.message
            };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        this.createDownloadFileStream = (id, collectionName, occurrenceKey)=>{
            const subject = (0, $rMufQ.createMediaSubject)();
            const poll = new (0, $eqlnz.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName
                });
                if (!response) throw new (0, $fIVY8.FileFetcherError)('emptyItems', id, {
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                });
                if ((0, $6wdWp.isEmptyFile)(response)) throw new (0, $fIVY8.FileFetcherError)('zeroVersionFile', id, {
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                });
                const fileState = (0, $9x67R.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $dpRAQ.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $04AOJ.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.dataloader = (0, $bVMx4.createFileDataloader)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey } = options;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxYYu)))(id)) {
            const subject = (0, $rMufQ.createMediaSubject)();
            const err = new (0, $fIVY8.FileFetcherError)('invalidFileId', id, {
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = {
                status: 'error',
                id: id,
                reason: err?.reason,
                message: err?.message,
                occurrenceKey: occurrenceKey,
                details: err?.attributes
            };
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $eqcfa.fromObservable)(subject);
        }
        return (0, $eqcfa.fromObservable)((0, $1l4qL.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $9BeXg.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
    }
    touchFiles(descriptors, collection, traceContext) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext) {
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
        const occurrenceKey = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $rMufQ.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const name = url.split('/').pop() || '';
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: name,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $1l4qL.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $3izHV.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $cfjUA.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                mimeType: type,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $rMufQ.createMediaSubject)();
        (0, $1l4qL.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $hIoOm.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $aynDk.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $9sBfG.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $eSb3E.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller?.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $eqcfa.fromObservable)(subject);
    }
    async downloadBinary(id, name = 'download', collectionName) {
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
        (0, $8w4F1.downloadUrl)(url, {
            name: name
        });
        (0, $59gZB.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $aFsdc.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const mediaStore = destination.mediaStore || new (0, $EEZOU.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $jrFS0.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const cache = (0, $1l4qL.getFileStreamsCache)();
        let processingSubscription;
        try {
            const { data: copiedFile } = await mediaStore.copyFileWithToken(body, params, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $3izHV.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $9x67R.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $rMufQ.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $9x67R.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $9x67R.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $cILCr.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $9sBfG.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $9sBfG.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $9x67R.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $9x67R.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $9x67R.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $1l4qL.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $rMufQ.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("8w4F1", function(module, exports) {

$parcel$export(module.exports, "downloadUrl", () => $b20aaa7fa9049904$export$8a96edb1c96563f4);
const $b20aaa7fa9049904$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("9x67R", function(module, exports) {

$parcel$export(module.exports, "isUploadingFileState", () => $4ada6060c1d21d91$export$70eb3481b487c668);
$parcel$export(module.exports, "isProcessingFileState", () => $4ada6060c1d21d91$export$5c30e6dd75278e66);
$parcel$export(module.exports, "isProcessedFileState", () => $4ada6060c1d21d91$export$1d17291aafa5f231);
$parcel$export(module.exports, "isErrorFileState", () => $4ada6060c1d21d91$export$f863e1e09c8a926);
$parcel$export(module.exports, "isPreviewableFileState", () => $4ada6060c1d21d91$export$92dd692b31e42e64);
$parcel$export(module.exports, "isFinalFileState", () => $4ada6060c1d21d91$export$270b3fc27120edd0);
$parcel$export(module.exports, "isImageRepresentationReady", () => $4ada6060c1d21d91$export$4e33ccde53b4f0bf);
$parcel$export(module.exports, "mapMediaFileToFileState", () => $4ada6060c1d21d91$export$ddfd67d20657322f);
$parcel$export(module.exports, "mapMediaItemToFileState", () => $4ada6060c1d21d91$export$ea3730792e8bebfb);
const $4ada6060c1d21d91$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
const $4ada6060c1d21d91$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
const $4ada6060c1d21d91$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
const $4ada6060c1d21d91$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
const $4ada6060c1d21d91$export$92dd692b31e42e64 = (fileState)=>!$4ada6060c1d21d91$export$f863e1e09c8a926(fileState) && !!fileState.preview;
const $4ada6060c1d21d91$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
const $4ada6060c1d21d91$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
const $4ada6060c1d21d91$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        metadataTraceContext: metadataTraceContext
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing'
            };
    }
};
const $4ada6060c1d21d91$export$ea3730792e8bebfb = (id, item)=>{
    return $4ada6060c1d21d91$export$ddfd67d20657322f({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("fIVY8", function(module, exports) {

$parcel$export(module.exports, "FileFetcherError", () => $0af7ec264212be2b$export$e3e60f0dab8641de);

var $6bBrC = parcelRequire("6bBrC");
class $0af7ec264212be2b$export$e3e60f0dab8641de extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, id, metadata){
        super(reason);
        this.reason = reason;
        this.id = id;
        this.metadata = metadata;
    }
    get attributes() {
        const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey } = {} } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $0af7ec264212be2b$export$5c3435f75ce0ce70(err) {
    return err instanceof $0af7ec264212be2b$export$e3e60f0dab8641de;
}

});

parcelRegister("eSb3E", function(module, exports) {

$parcel$export(module.exports, "uploadFile", () => $46ff4c8ed9468aee$export$a5575dbeeffdad98);

var $2gF4Y = parcelRequire("2gF4Y");

var $jpkPA = parcelRequire("jpkPA");

var $eGPtZ = parcelRequire("eGPtZ");

var $fLD6W = parcelRequire("fLD6W");

var $1jayH = parcelRequire("1jayH");

var $aFsdc = parcelRequire("aFsdc");

var $eLiN6 = parcelRequire("eLiN6");
const $46ff4c8ed9468aee$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $fLD6W.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $46ff4c8ed9468aee$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $46ff4c8ed9468aee$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $46ff4c8ed9468aee$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext);
        offset += chunks.length;
    };
};
const $46ff4c8ed9468aee$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    const body = file.size ? {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    } : {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType
    };
    return store.createFileFromUpload(body, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext);
};
const $46ff4c8ed9468aee$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $aFsdc.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $eLiN6.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $eLiN6.fileSizeError)) callbacks?.onUploadFinish(new (0, $1jayH.UploaderError)(err.message, id, {
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks?.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $2gF4Y.chunkinator)(content, {
        hashingFunction: (blob)=>$46ff4c8ed9468aee$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $46ff4c8ed9468aee$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $aFsdc.PROCESSING_BATCH_SIZE),
        processingFunction: $46ff4c8ed9468aee$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $jpkPA.from)(deferredUploadId).pipe((0, $eGPtZ.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $eGPtZ.concatMap)(()=>(0, $jpkPA.from)($46ff4c8ed9468aee$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $46ff4c8ed9468aee$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("2gF4Y", function(module, exports) {

$parcel$export(module.exports, "chunkinator", () => $926a40091d882f6c$export$9ab6bef3838698f8);

var $dBQte = parcelRequire("dBQte");

var $eGPtZ = parcelRequire("eGPtZ");

var $4ZLqF = parcelRequire("4ZLqF");

var $8riMk = parcelRequire("8riMk");

var $fZ5s6 = parcelRequire("fZ5s6");

var $66iic = parcelRequire("66iic");

var $f28UZ = parcelRequire("f28UZ");

var $iYmB8 = parcelRequire("iYmB8");

var $7zy4k = parcelRequire("7zy4k");

var $jpkPA = parcelRequire("jpkPA");
const $926a40091d882f6c$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $8riMk.fromPromise)((0, $7zy4k.fetchBlob)(file)).pipe((0, $eGPtZ.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $fZ5s6.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $66iic.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $f28UZ.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $dBQte.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $iYmB8.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $eGPtZ.concatMap)((batchedChunks)=>{
            return (0, $jpkPA.from)(batchedChunks);
        }), (0, $4ZLqF.bufferCount)(totalChunks));
    }));
const $926a40091d882f6c$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return $926a40091d882f6c$export$88e80b3a0bb31f63(file, options, callbacks);
};

});
parcelRegister("fZ5s6", function(module, exports) {

$parcel$export(module.exports, "slicenator", () => $b09d6a25440d952b$export$5b92d769f2f57509);

var $3fnK6 = parcelRequire("3fnK6");

var $aynDk = parcelRequire("aynDk");
const $b09d6a25440d952b$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $3fnK6.range)(0, totalChunks).pipe((0, $aynDk.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});

parcelRegister("66iic", function(module, exports) {

$parcel$export(module.exports, "hashinator", () => $bba7ef0a5244bc3b$export$d5f5a550a38ec367);

var $7zy4k = parcelRequire("7zy4k");
const $bba7ef0a5244bc3b$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));
const $bba7ef0a5244bc3b$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $7zy4k.asyncMap)($bba7ef0a5244bc3b$export$28a452a485721473(hasher), concurrency)(blobs$);

});
parcelRegister("7zy4k", function(module, exports) {

$parcel$export(module.exports, "fetchBlob", () => $434114a42104e3d7$export$14e9cfd4a872cc1e);
$parcel$export(module.exports, "asyncMap", () => $434114a42104e3d7$export$707ee4c4c95d39e3);

var $3JafE = parcelRequire("3JafE");

var $b1qLQ = parcelRequire("b1qLQ");
async function $434114a42104e3d7$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}
const $434114a42104e3d7$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $434114a42104e3d7$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $3JafE.Observable)((sub)=>{
            notifiers.push($434114a42104e3d7$var$notify(project(value), sub, onReady));
        });
};
const $434114a42104e3d7$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $b1qLQ.mergeMap)($434114a42104e3d7$var$mapper(project), concurrent);

});


parcelRegister("f28UZ", function(module, exports) {

$parcel$export(module.exports, "uploadinator", () => $6a83285a61ef7586$export$94ce0f3fcf999415);

var $7zy4k = parcelRequire("7zy4k");
const $6a83285a61ef7586$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $7zy4k.asyncMap)(upload, options.concurrency));
};

});

parcelRegister("iYmB8", function(module, exports) {

$parcel$export(module.exports, "processinator", () => $38ace8e9a7e10729$export$2f21790600302ed);

var $4ZLqF = parcelRequire("4ZLqF");

var $eGPtZ = parcelRequire("eGPtZ");
const $38ace8e9a7e10729$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $4ZLqF.bufferCount)(options.batchSize)).pipe((0, $eGPtZ.concatMap)(process));
};

});


parcelRegister("fLD6W", function(module, exports) {

$parcel$export(module.exports, "createHasher", () => $80d9fc5820b1f0fe$export$14b114effbc08b6b);
parcelRequire("2q7Xj");
var $fmEc3 = parcelRequire("fmEc3");
let $80d9fc5820b1f0fe$var$hasher = null;
let $80d9fc5820b1f0fe$var$sha256Hasher = null;
const $80d9fc5820b1f0fe$export$b7d263e6bc26b29a = ()=>$80d9fc5820b1f0fe$var$hasher = null;



const $80d9fc5820b1f0fe$export$14b114effbc08b6b = async (algorithm)=>{
    const numWorkers = 3;
    if (algorithm === (0, $fmEc3.ChunkHashAlgorithm).Sha256) {
        if (!$80d9fc5820b1f0fe$var$sha256Hasher) {
            // TODO this needs to support worker sha256 hasher as well
            const { SimpleHasher: SimpleHasher } = await (parcelRequire("a1LbI"));
            $80d9fc5820b1f0fe$var$sha256Hasher = new SimpleHasher();
        }
        return $80d9fc5820b1f0fe$var$sha256Hasher;
    } else if (!$80d9fc5820b1f0fe$var$hasher) try {
        const { WorkerHasher: WorkerHasher } = await (parcelRequire("37sun"));
        $80d9fc5820b1f0fe$var$hasher = new WorkerHasher(numWorkers);
    } catch (error) {
        const { SimpleHasher: SimpleHasher } = await (parcelRequire("jYrgF"));
        $80d9fc5820b1f0fe$var$hasher = new SimpleHasher();
    }
    return $80d9fc5820b1f0fe$var$hasher;
};

});
parcelRegister("a1LbI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iw25e").then(()=>parcelRequire('4HVlI'));

});

parcelRegister("37sun", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("izugL")
]).then(()=>parcelRequire('kAV1m'));

});

parcelRegister("jYrgF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("lOaWi")
]).then(()=>parcelRequire('7ykMh'));

});


parcelRegister("1jayH", function(module, exports) {

$parcel$export(module.exports, "UploaderError", () => $93268a427390d3ba$export$515240c3f059c807);

var $6bBrC = parcelRequire("6bBrC");
class $93268a427390d3ba$export$515240c3f059c807 extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, id, metadata){
        super(reason);
        this.reason = reason;
        this.id = id;
        this.metadata = metadata;
    }
    get attributes() {
        const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey } = {} } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $93268a427390d3ba$export$80ee180172bc336(err) {
    return err instanceof $93268a427390d3ba$export$515240c3f059c807;
}

});

parcelRegister("eLiN6", function(module, exports) {

$parcel$export(module.exports, "fileSizeError", () => $1d73b7e36a95c49b$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $1d73b7e36a95c49b$export$71f452e02035c1e2);

var $bYwuj = parcelRequire("bYwuj");

var $aFsdc = parcelRequire("aFsdc");
const $1d73b7e36a95c49b$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $1d73b7e36a95c49b$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $aFsdc.MAX_UPLOAD_FILE_SIZE)) throw new Error($1d73b7e36a95c49b$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $bYwuj.DATA_UNIT).GB) return 5 * (0, $bYwuj.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $bYwuj.DATA_UNIT).GB && fileSize <= 50 * (0, $bYwuj.DATA_UNIT).GB) return 50 * (0, $bYwuj.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $bYwuj.DATA_UNIT).GB && fileSize <= 0.95 * (0, $bYwuj.DATA_UNIT).TB) return 100 * (0, $bYwuj.DATA_UNIT).MB;
    return 210 * (0, $bYwuj.DATA_UNIT).MB;
};

});


parcelRegister("1l4qL", function(module, exports) {

$parcel$export(module.exports, "getFileStreamsCache", () => $5b31f9f9111d0f01$export$f2f061938c1e6810);
class $5b31f9f9111d0f01$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}
let $5b31f9f9111d0f01$var$streamCache;

const $5b31f9f9111d0f01$export$f2f061938c1e6810 = ()=>{
    if (!$5b31f9f9111d0f01$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("iE8r2")).mediaState;
        $5b31f9f9111d0f01$var$streamCache = new $5b31f9f9111d0f01$export$4293896e79732236(mediaState.streams);
    }
    return $5b31f9f9111d0f01$var$streamCache;
};

});

parcelRegister("59gZB", function(module, exports) {

$parcel$export(module.exports, "globalMediaEventEmitter", () => $b6e693db8a3ca69e$export$68d003d3105952ad);
parcelRequire("2q7Xj");
var $iE8r2 = parcelRequire("iE8r2");
const $b6e693db8a3ca69e$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $iE8r2.mediaState).eventEmitter) (0, $iE8r2.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $iE8r2.mediaState).eventEmitter) (0, $iE8r2.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $iE8r2.mediaState).eventEmitter) return (0, $iE8r2.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});

parcelRegister("bxYYu", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $aul3P = parcelRequire("aul3P");
var $8682131465584b62$require$Buffer = $aul3P.Buffer;
var $8682131465584b62$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $8682131465584b62$var$_byteToHex = [];
for(var $8682131465584b62$var$i = 0; $8682131465584b62$var$i < 256; $8682131465584b62$var$i++)$8682131465584b62$var$_byteToHex[$8682131465584b62$var$i] = ($8682131465584b62$var$i + 0x100).toString(16).substr(1);
function $8682131465584b62$var$unparse(buf, offset) {
    var i = offset || 0, bth = $8682131465584b62$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($8682131465584b62$require$Buffer.isBuffer(uuid)) parsedUuid = $8682131465584b62$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$8682131465584b62$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $8682131465584b62$var$extractVersion(parsedUuid);
    else if ($8682131465584b62$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $8682131465584b62$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("bVMx4", function(module, exports) {

$parcel$export(module.exports, "createFileDataloader", () => $d49dc51366e1ddfa$export$ae188fee39529b82);

var $1l2Nv = parcelRequire("1l2Nv");

var $5Cq8b = parcelRequire("5Cq8b");
const $d49dc51366e1ddfa$export$b79d95ee17a87a = 100;
const $d49dc51366e1ddfa$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $d49dc51366e1ddfa$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $d49dc51366e1ddfa$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $d49dc51366e1ddfa$var$makeCacheKey(id, collection);
        prev[key] = $d49dc51366e1ddfa$var$isBatchLoadingErrorResult(fileItem) ? fileItem.error : {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $d49dc51366e1ddfa$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || null;
    });
};
function $d49dc51366e1ddfa$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $5Cq8b.getRandomHex)(8),
                spanId: (0, $5Cq8b.getRandomHex)(8)
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return $d49dc51366e1ddfa$export$71cd2e8f8162d47b(keys, items);
    };
}
function $d49dc51366e1ddfa$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($1l2Nv)))($d49dc51366e1ddfa$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $d49dc51366e1ddfa$export$b79d95ee17a87a
    });
}

});
parcelRegister("1l2Nv", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $0f99ec2102c35890$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $0f99ec2102c35890$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $0f99ec2102c35890$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $0f99ec2102c35890$var$getValidCacheKeyFn(options);
        this._cacheMap = $0f99ec2102c35890$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $0f99ec2102c35890$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $0f99ec2102c35890$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$0f99ec2102c35890$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $0f99ec2102c35890$var$enqueuePostPromiseJob = typeof $2fFJv === 'object' && typeof $2fFJv.nextTick === 'function' ? function(fn) {
    if (!$0f99ec2102c35890$var$resolvedPromise) $0f99ec2102c35890$var$resolvedPromise = Promise.resolve();
    $0f99ec2102c35890$var$resolvedPromise.then(function() {
        $2fFJv.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $0f99ec2102c35890$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $0f99ec2102c35890$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $0f99ec2102c35890$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $0f99ec2102c35890$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $0f99ec2102c35890$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $0f99ec2102c35890$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $0f99ec2102c35890$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$0f99ec2102c35890$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $0f99ec2102c35890$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $0f99ec2102c35890$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $0f99ec2102c35890$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $0f99ec2102c35890$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $0f99ec2102c35890$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $0f99ec2102c35890$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $0f99ec2102c35890$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $0f99ec2102c35890$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $0f99ec2102c35890$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $0f99ec2102c35890$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $0f99ec2102c35890$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $0f99ec2102c35890$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $0f99ec2102c35890$var$DataLoader;

});


parcelRegister("04AOJ", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $2d99bdcc193fb729$export$ac3214931ffd82af);

var $3izHV = parcelRequire("3izHV");
const $2d99bdcc193fb729$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $3izHV.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});
parcelRegister("3izHV", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $271e34cd6fe1cabd$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("br8gy")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("br8gy")).isVideoMimeTypeSupportedByBrowser);

var $hZoAg = parcelRequire("hZoAg");

var $br8gy = parcelRequire("br8gy");

var $5BRco = parcelRequire("5BRco");
const $271e34cd6fe1cabd$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $hZoAg.isArchive)(mimeType)) return 'archive';
    if ((0, $br8gy.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $br8gy.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $br8gy.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $br8gy.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("hZoAg", function(module, exports) {

$parcel$export(module.exports, "isArchive", () => $4c79e3ce7fc2a8d0$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $4c79e3ce7fc2a8d0$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("br8gy", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $7e5c6394ef188971$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $7e5c6394ef188971$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $7e5c6394ef188971$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $7e5c6394ef188971$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $7e5c6394ef188971$export$55ca6cdaf6093034 = (mimeType)=>$7e5c6394ef188971$export$74325e3c843a9555(mimeType) || $7e5c6394ef188971$export$c021f2623a75015f(mimeType) || $7e5c6394ef188971$export$ff36075ea755a717(mimeType) || $7e5c6394ef188971$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("5BRco", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $85f5842a210424b1$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $85f5842a210424b1$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $85f5842a210424b1$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $85f5842a210424b1$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $85f5842a210424b1$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $85f5842a210424b1$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$548d9148a80556a3 = (mimeType)=>$85f5842a210424b1$export$e9a065a80f76311e(mimeType) || $85f5842a210424b1$export$86baad7a89d908e9(mimeType) || $85f5842a210424b1$export$8cba23825d020bbb(mimeType) || $85f5842a210424b1$export$9c2b4de5fdca2ce3(mimeType) || $85f5842a210424b1$export$94e1479e01d2af53(mimeType);

});



parcelRegister("9sBfG", function(module, exports) {

$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $4579abe2682788f5$export$89097c0ec1e0dee1);

var $9x67R = parcelRequire("9x67R");
const $4579abe2682788f5$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $9x67R.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("dpRAQ", function(module, exports) {

$parcel$export(module.exports, "convertBase64ToBlob", () => $241808151c7df3d7$export$ed17558b11b88056);
const $241808151c7df3d7$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("eqcfa", function(module, exports) {

$parcel$export(module.exports, "fromObservable", () => $5370b0715ba587e9$export$4b2432e2d8723823);

var $rMufQ = parcelRequire("rMufQ");
function $5370b0715ba587e9$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $5370b0715ba587e9$export$8659d1f07d151381(item) {
    return $5370b0715ba587e9$export$4b2432e2d8723823((0, $rMufQ.createMediaSubject)(item));
}

});
parcelRegister("rMufQ", function(module, exports) {

$parcel$export(module.exports, "createMediaSubject", () => $b1945b205bb99a41$export$bc76d51553fa5e35);

var $lXGL9 = parcelRequire("lXGL9");
function $b1945b205bb99a41$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $lXGL9.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});


parcelRegister("9BeXg", function(module, exports) {

$parcel$export(module.exports, "toPromise", () => $41ac1ff94334ef1d$export$4dbaaf6c79705e6c);

var $hIoOm = parcelRequire("hIoOm");
const $41ac1ff94334ef1d$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $hIoOm.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("cfjUA", function(module, exports) {

$parcel$export(module.exports, "getDimensionsFromBlob", () => $e97c761e4a22f2e8$export$71797c284d89a3e1);

var $leGRQ = parcelRequire("leGRQ");

var $USL4H = parcelRequire("USL4H");
const $e97c761e4a22f2e8$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $leGRQ.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $USL4H.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("leGRQ", function(module, exports) {

$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $dc02c409650d12cb$export$a1c3205f28a20414);
const $dc02c409650d12cb$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("USL4H", function(module, exports) {

$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $8e2e403157239a69$export$62aabd5ff85d0451);
const $8e2e403157239a69$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("cILCr", function(module, exports) {

$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $5cccb92ec7f36e1d$export$2ccdd6f9a9eba6a);

var $br8gy = parcelRequire("br8gy");
var $5BRco = parcelRequire("5BRco");

var $USL4H = parcelRequire("USL4H");
async function $5cccb92ec7f36e1d$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $br8gy.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $5BRco.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $USL4H.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("eqlnz", function(module, exports) {

$parcel$export(module.exports, "PollingFunction", () => $f01979f4321e41b7$export$4c54d536f8e37dc2);

var $foadk = parcelRequire("foadk");
const $f01979f4321e41b7$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $f01979f4321e41b7$export$4c54d536f8e37dc2 {
    constructor(options){
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.timeoutId = 0;
        this.options = {
            ...$f01979f4321e41b7$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $foadk.PollingError)('pollingMaxAttemptsExceeded', this.attempt));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $foadk.PollingError)('pollingMaxAttemptsExceeded', this.attempt));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("foadk", function(module, exports) {

$parcel$export(module.exports, "PollingError", () => $830cdba99e9f23c2$export$c3748c310e92340a);
$parcel$export(module.exports, "isPollingError", () => $830cdba99e9f23c2$export$541e3e52eea6fece);

var $6bBrC = parcelRequire("6bBrC");
class $830cdba99e9f23c2$export$c3748c310e92340a extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, attempts){
        super(reason);
        this.reason = reason;
        this.attempts = attempts;
    }
    get attributes() {
        const { reason: reason, attempts: attempts } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}
function $830cdba99e9f23c2$export$541e3e52eea6fece(err) {
    return err instanceof $830cdba99e9f23c2$export$c3748c310e92340a;
}

});


parcelRegister("6wdWp", function(module, exports) {

$parcel$export(module.exports, "isEmptyFile", () => $8d001a32183537d3$export$728192ce8dd94659);
const $8d001a32183537d3$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $8d001a32183537d3$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $8d001a32183537d3$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("gHZqD", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => (parcelRequire("exlxT")).mediaStore);

var $exlxT = parcelRequire("exlxT");

});
parcelRegister("exlxT", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => $107a0f046eaf76d8$export$5785580dea19518d);

var $7dY5U = parcelRequire("7dY5U");

var $2Qvr5 = parcelRequire("2Qvr5");

var $gQVOz = parcelRequire("gQVOz");
const $107a0f046eaf76d8$var$mediaStoreWithoutDevtools = (0, $gQVOz.createStore)()((0, $7dY5U.subscribeWithSelector)((0, $2Qvr5.immer)(()=>({
        files: {}
    }))));
const $107a0f046eaf76d8$var$mediaStoreWithDevtools = (0, $gQVOz.createStore)()((0, $7dY5U.devtools)((0, $7dY5U.subscribeWithSelector)((0, $2Qvr5.immer)(()=>({
        files: {}
    })))));
const $107a0f046eaf76d8$export$5785580dea19518d = $107a0f046eaf76d8$var$mediaStoreWithoutDevtools;
const $107a0f046eaf76d8$export$503459913a0dc356 = (initialStore)=>{
    return (0, $gQVOz.createStore)()((0, $7dY5U.subscribeWithSelector)((0, $2Qvr5.immer)(()=>({
            files: {},
            ...initialStore
        }))));
};

});
parcelRegister("7dY5U", function(module, exports) {

$parcel$export(module.exports, "devtools", () => $45f0a2b2efc9d9f9$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $45f0a2b2efc9d9f9$export$5c593627aef9f076);
var $45f0a2b2efc9d9f9$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $45f0a2b2efc9d9f9$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $45f0a2b2efc9d9f9$export$4feba8a1bc8e9afd = $45f0a2b2efc9d9f9$var$reduxImpl;
const $45f0a2b2efc9d9f9$var$trackedConnections = /* @__PURE__ */ new Map();
const $45f0a2b2efc9d9f9$var$getTrackedConnectionState = (name)=>{
    const api = $45f0a2b2efc9d9f9$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $45f0a2b2efc9d9f9$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $45f0a2b2efc9d9f9$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $45f0a2b2efc9d9f9$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $45f0a2b2efc9d9f9$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) {
            if (($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $45f0a2b2efc9d9f9$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $45f0a2b2efc9d9f9$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $45f0a2b2efc9d9f9$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $45f0a2b2efc9d9f9$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $45f0a2b2efc9d9f9$export$6922d3b3a607469e = $45f0a2b2efc9d9f9$var$devtoolsImpl;
const $45f0a2b2efc9d9f9$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $45f0a2b2efc9d9f9$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $45f0a2b2efc9d9f9$export$5c593627aef9f076 = $45f0a2b2efc9d9f9$var$subscribeWithSelectorImpl;
const $45f0a2b2efc9d9f9$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $45f0a2b2efc9d9f9$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $45f0a2b2efc9d9f9$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $45f0a2b2efc9d9f9$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $45f0a2b2efc9d9f9$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $45f0a2b2efc9d9f9$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $45f0a2b2efc9d9f9$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $45f0a2b2efc9d9f9$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $45f0a2b2efc9d9f9$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $45f0a2b2efc9d9f9$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $45f0a2b2efc9d9f9$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $45f0a2b2efc9d9f9$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $45f0a2b2efc9d9f9$var$oldImpl(config, baseOptions);
    }
    return $45f0a2b2efc9d9f9$var$newImpl(config, baseOptions);
};
const $45f0a2b2efc9d9f9$export$9a6132153fba2e0 = $45f0a2b2efc9d9f9$var$persistImpl;

});

parcelRegister("2Qvr5", function(module, exports) {

$parcel$export(module.exports, "immer", () => $a3e9bebcfca14386$export$428de7ec69ac95c);

var $lbd4c = parcelRequire("lbd4c");
const $a3e9bebcfca14386$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $lbd4c.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $a3e9bebcfca14386$export$428de7ec69ac95c = $a3e9bebcfca14386$var$immerImpl;

});
parcelRegister("lbd4c", function(module, exports) {

$parcel$export(module.exports, "produce", () => fn);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $221c0e7836ac0785$export$2e2bcd8739ae039 = fn;

});


parcelRegister("gQVOz", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $14d460da377d9036$export$f51a9068ac82ea43);
var $14d460da377d9036$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $14d460da377d9036$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($14d460da377d9036$import_meta.env ? $14d460da377d9036$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $14d460da377d9036$export$f51a9068ac82ea43 = (createState)=>createState ? $14d460da377d9036$var$createStoreImpl(createState) : $14d460da377d9036$var$createStoreImpl;
var $14d460da377d9036$export$2e2bcd8739ae039 = (createState)=>{
    if (($14d460da377d9036$import_meta.env ? $14d460da377d9036$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $14d460da377d9036$export$f51a9068ac82ea43(createState);
};

});




parcelRegister("eJAUz", function(module, exports) {

$parcel$export(module.exports, "StargateClient", () => $aebd1b09d3f1d2ab$export$c66ca190f89caaac);
class $aebd1b09d3f1d2ab$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("6o5wg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kRysi").then(()=>parcelRequire('8gBya'));

});




parcelRegister("1xvoH", function(module, exports) {

$parcel$export(module.exports, "useFilePreview", () => $86ba7cfc6df4e172$export$4eaebdef02112fe4);

var $eUqFw = parcelRequire("eUqFw");

var $9x67R = parcelRequire("9x67R");

var $RBcRl = parcelRequire("RBcRl");
var $kJ7yF = parcelRequire("kJ7yF");

var $br8gy = parcelRequire("br8gy");

var $XHGTv = parcelRequire("XHGTv");

var $iP4HA = parcelRequire("iP4HA");

var $kj8oZ = parcelRequire("kj8oZ");

var $jvF4x = parcelRequire("jvF4x");
var $1eI0l = parcelRequire("1eI0l");
var $jyk7o = parcelRequire("jyk7o");

var $862c0 = parcelRequire("862c0");
var $6tTCR = parcelRequire("6tTCR");

var $2GnF5 = parcelRequire("2GnF5");
const $86ba7cfc6df4e172$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $kJ7yF.useMediaClient)();
    const [status, setStatus] = (0, $eUqFw.useState)('loading');
    const [error, setError] = (0, $eUqFw.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $eUqFw.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $eUqFw.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $eUqFw.useState)('not-resolved');
    const ssrReliabilityRef = (0, $eUqFw.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const requestDimensions = (0, $eUqFw.useMemo)(()=>dimensions ? (0, $2GnF5.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $2GnF5.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    if ((0, $XHGTv.fg)('platform.media-card-performance-observer_a803k')) imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $jyk7o.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $6tTCR.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $jvF4x.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $iP4HA.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $eUqFw.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $RBcRl.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const fileStatus = fileState?.status;
    const isBackendPreviewReady = !!fileState && (0, $9x67R.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $eUqFw.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileStatus === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileStatus === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $kj8oZ.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileStatus === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $kj8oZ.MediaFilePreviewError)('metadata-fetch', new Error(fileStateErrorMessage)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileStatus,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $2GnF5.useCurrentValueRef)(()=>{
        return (0, $jvF4x.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $eUqFw.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $2GnF5.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $2GnF5.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $eUqFw.useEffect)(()=>{
        const cachedPreview = (0, $jyk7o.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $2GnF5.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $1eI0l.isSupportedLocalPreview)(mediaType) && (0, $br8gy.isMimeTypeSupportedByBrowser)(mimeType || '')) // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
        // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
        // Then, local Preview NOT available
        (0, $jvF4x.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
            setIsBannedLocalPreview(true);
            // CXP-2723 TODO: We might have to wrap this error in MediaCardError
            setNonCriticalError(e);
        });
        else if (!error && !nonCriticalError && (!preview || (0, $2GnF5.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $jvF4x.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
            const wrappedError = (0, $kj8oZ.ensureMediaFilePreviewError)('preview-fetch', e);
            if (!preview) {
                setStatus('error');
                setError(wrappedError);
            } else // If there is already a preview, we consider it a non-critical error
            setNonCriticalError(wrappedError);
        });
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $eUqFw.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $jvF4x.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $iP4HA.createFailedSSRObject)(failedPreview, traceContext);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if ((0, $jvF4x.isSSRDataPreview)(failedPreview)) {
            ssrReliabilityRef.current.server = (0, $iP4HA.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $iP4HA.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $jvF4x.isLocalPreview)(failedPreview);
        const isRemote = (0, $jvF4x.isRemotePreview)(failedPreview);
        if (isLocal || isRemote) {
            const error = new (0, $kj8oZ.ImageLoadError)(failedPreview?.source);
            (0, $jyk7o.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $eUqFw.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $jvF4x.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $jvF4x.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $862c0.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps
    };
};

});
parcelRegister("RBcRl", function(module, exports) {

$parcel$export(module.exports, "useFileState", () => $d6b826f28e3bf18f$export$90ff537b0999afb);

var $eUqFw = parcelRequire("eUqFw");

var $kJ7yF = parcelRequire("kJ7yF");

var $eC7jK = parcelRequire("eC7jK");
function $d6b826f28e3bf18f$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false } = options;
    const mediaClient = (0, $kJ7yF.useMediaClient)();
    const fileState = (0, $eC7jK.useMediaStore)((state)=>state.files[id]);
    (0, $eUqFw.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("eC7jK", function(module, exports) {

$parcel$export(module.exports, "useMediaStore", () => $7ebccbb6e4a1c8db$export$8a9cc8c330400af8);

var $k4N4B = parcelRequire("k4N4B");

var $kJ7yF = parcelRequire("kJ7yF");
const $7ebccbb6e4a1c8db$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $k4N4B.useStore)(store, selector, equals);
function $7ebccbb6e4a1c8db$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $kJ7yF.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $7ebccbb6e4a1c8db$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("k4N4B", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $0605707b4ba00383$export$6ccbb43953eebf8);

var $gQVOz = parcelRequire("gQVOz");

var $eUqFw = parcelRequire("eUqFw");

var $d5G6h = parcelRequire("d5G6h");
var $0605707b4ba00383$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $0605707b4ba00383$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw)));
const { useSyncExternalStoreWithSelector: $0605707b4ba00383$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($d5G6h)));
let $0605707b4ba00383$var$didWarnAboutEqualityFn = false;
const $0605707b4ba00383$var$identity = (arg)=>arg;
function $0605707b4ba00383$export$6ccbb43953eebf8(api, selector = $0605707b4ba00383$var$identity, equalityFn) {
    if (($0605707b4ba00383$import_meta.env ? $0605707b4ba00383$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$0605707b4ba00383$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $0605707b4ba00383$var$didWarnAboutEqualityFn = true;
    }
    const slice = $0605707b4ba00383$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $0605707b4ba00383$var$useDebugValue(slice);
    return slice;
}
const $0605707b4ba00383$var$createImpl = (createState)=>{
    if (($0605707b4ba00383$import_meta.env ? $0605707b4ba00383$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $gQVOz.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$0605707b4ba00383$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $0605707b4ba00383$export$185802fd694ee1f5 = (createState)=>createState ? $0605707b4ba00383$var$createImpl(createState) : $0605707b4ba00383$var$createImpl;
var $0605707b4ba00383$export$2e2bcd8739ae039 = (createState)=>{
    if (($0605707b4ba00383$import_meta.env ? $0605707b4ba00383$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $0605707b4ba00383$export$185802fd694ee1f5(createState);
};

});
parcelRegister("d5G6h", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1ZzZb"));

});
parcelRegister("1ZzZb", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $173766f8d19e6ee9$export$bf730a2d8bf68b42, (v) => $173766f8d19e6ee9$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $173766f8d19e6ee9$export$bf730a2d8bf68b42;
'use strict';

var $eUqFw = parcelRequire("eUqFw");

var $7rCff = parcelRequire("7rCff");
function $173766f8d19e6ee9$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $173766f8d19e6ee9$var$q = "function" === typeof Object.is ? Object.is : $173766f8d19e6ee9$var$p, $173766f8d19e6ee9$var$r = $7rCff.useSyncExternalStore, $173766f8d19e6ee9$var$t = $eUqFw.useRef, $173766f8d19e6ee9$var$u = $eUqFw.useEffect, $173766f8d19e6ee9$var$v = $eUqFw.useMemo, $173766f8d19e6ee9$var$w = $eUqFw.useDebugValue;
$173766f8d19e6ee9$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $173766f8d19e6ee9$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $173766f8d19e6ee9$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($173766f8d19e6ee9$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $173766f8d19e6ee9$var$r(a, c[0], c[1]);
    $173766f8d19e6ee9$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $173766f8d19e6ee9$var$w(d);
    return d;
};

});
parcelRegister("7rCff", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ekNRM"));

});
parcelRegister("ekNRM", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $a6f99d656c9e333c$export$306c0aa65ff9ec16, (v) => $a6f99d656c9e333c$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a6f99d656c9e333c$export$306c0aa65ff9ec16;
'use strict';

var $eUqFw = parcelRequire("eUqFw");
function $a6f99d656c9e333c$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a6f99d656c9e333c$var$k = "function" === typeof Object.is ? Object.is : $a6f99d656c9e333c$var$h, $a6f99d656c9e333c$var$l = $eUqFw.useState, $a6f99d656c9e333c$var$m = $eUqFw.useEffect, $a6f99d656c9e333c$var$n = $eUqFw.useLayoutEffect, $a6f99d656c9e333c$var$p = $eUqFw.useDebugValue;
function $a6f99d656c9e333c$var$q(a, b) {
    var d = b(), f = $a6f99d656c9e333c$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $a6f99d656c9e333c$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $a6f99d656c9e333c$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $a6f99d656c9e333c$var$m(function() {
        $a6f99d656c9e333c$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $a6f99d656c9e333c$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $a6f99d656c9e333c$var$p(d);
    return d;
}
function $a6f99d656c9e333c$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$a6f99d656c9e333c$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $a6f99d656c9e333c$var$t(a, b) {
    return b();
}
var $a6f99d656c9e333c$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $a6f99d656c9e333c$var$t : $a6f99d656c9e333c$var$q;
$a6f99d656c9e333c$export$306c0aa65ff9ec16 = void 0 !== $eUqFw.useSyncExternalStore ? $eUqFw.useSyncExternalStore : $a6f99d656c9e333c$var$u;

});







parcelRegister("iP4HA", function(module, exports) {

$parcel$export(module.exports, "extractErrorInfo", () => $9e13c15b19442f5f$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $9e13c15b19442f5f$export$768c370ed0dbaeb3);

var $eKK8L = parcelRequire("eKK8L");
var $7aQon = parcelRequire("7aQon");

var $kj8oZ = parcelRequire("kj8oZ");
const $9e13c15b19442f5f$export$29aa614726672b2e = (error)=>{
    if ((0, $kj8oZ.isMediaFilePreviewError)(error) && !!error.secondaryError) {
        if ((0, $7aQon.isRequestError)(error.secondaryError)) return error.secondaryError.metadata?.traceContext;
        else if ((0, $kj8oZ.isMediaFileStateError)(error.secondaryError)) return error.secondaryError.details?.metadata?.traceContext;
    }
};
const $9e13c15b19442f5f$export$4af9d71992e89714 = (error)=>{
    if ((0, $kj8oZ.isMediaFilePreviewError)(error)) return error.primaryReason;
    else return 'nativeError';
};
const $9e13c15b19442f5f$export$88c61dcad53762da = (error)=>{
    if ((0, $kj8oZ.isMediaFilePreviewError)(error) && error.secondaryError) {
        const mediaClientReason = (0, $kj8oZ.isMediaFileStateError)(error.secondaryError) ? (0, $kj8oZ.getFileStateErrorReason)(error.secondaryError) : (0, $eKK8L.getMediaClientErrorReason)(error.secondaryError);
        if (mediaClientReason !== 'unknown') return mediaClientReason;
    }
    return 'nativeError';
};
const $9e13c15b19442f5f$export$9ccc5365d056da4b = (error)=>{
    if ((0, $kj8oZ.isMediaFilePreviewError)(error) && error.secondaryError) return error.secondaryError.message;
    else return error.message;
};
const $9e13c15b19442f5f$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $9e13c15b19442f5f$export$4af9d71992e89714(error),
        error: $9e13c15b19442f5f$export$88c61dcad53762da(error),
        errorDetail: $9e13c15b19442f5f$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $9e13c15b19442f5f$export$29aa614726672b2e(error)
    };
};
const $9e13c15b19442f5f$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$9e13c15b19442f5f$export$74aaf4784c2edb2c(new (0, $kj8oZ.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("kj8oZ", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreviewError", () => $ee0c6ebccdf3d6b2$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $ee0c6ebccdf3d6b2$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $ee0c6ebccdf3d6b2$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $ee0c6ebccdf3d6b2$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $ee0c6ebccdf3d6b2$export$d0a45ab59b4606b);
$parcel$export(module.exports, "isMediaFilePreviewError", () => $ee0c6ebccdf3d6b2$export$553696a6e769784c);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $ee0c6ebccdf3d6b2$export$7156ce7b78b49bd7);
$parcel$export(module.exports, "isMediaFileStateError", () => $ee0c6ebccdf3d6b2$export$166a250c03366459);
$parcel$export(module.exports, "getFileStateErrorReason", () => $ee0c6ebccdf3d6b2$export$2e87e6d20b09376d);

var $gqduQ = parcelRequire("gqduQ");
class $ee0c6ebccdf3d6b2$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $ee0c6ebccdf3d6b2$export$2c035820a31723e extends $ee0c6ebccdf3d6b2$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
    }
}
class $ee0c6ebccdf3d6b2$export$10ab445310d30114 extends $ee0c6ebccdf3d6b2$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
    }
}
class $ee0c6ebccdf3d6b2$export$18e89b7e50818288 extends $ee0c6ebccdf3d6b2$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
    }
}
const $ee0c6ebccdf3d6b2$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $ee0c6ebccdf3d6b2$export$d0a45ab59b4606b extends $ee0c6ebccdf3d6b2$export$96e559194c287cf4 {
    constructor(source){
        super($ee0c6ebccdf3d6b2$var$getImageLoadPrimaryReason(source));
    }
}
function $ee0c6ebccdf3d6b2$export$553696a6e769784c(err) {
    return err instanceof $ee0c6ebccdf3d6b2$export$96e559194c287cf4;
}
const $ee0c6ebccdf3d6b2$export$b380593ba3516c6f = (err)=>err instanceof $ee0c6ebccdf3d6b2$export$2c035820a31723e;
const $ee0c6ebccdf3d6b2$export$e1d87830b3784f94 = (err)=>err instanceof $ee0c6ebccdf3d6b2$export$10ab445310d30114;
const $ee0c6ebccdf3d6b2$export$443aeb298d35d79d = (err)=>$ee0c6ebccdf3d6b2$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $ee0c6ebccdf3d6b2$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($ee0c6ebccdf3d6b2$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $ee0c6ebccdf3d6b2$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $ee0c6ebccdf3d6b2$export$96e559194c287cf4(primaryReason, error);
};
function $ee0c6ebccdf3d6b2$export$166a250c03366459(err) {
    return err instanceof (0, $gqduQ.MediaFileStateError);
}
function $ee0c6ebccdf3d6b2$export$2e87e6d20b09376d(err) {
    return err.details?.reason ?? 'unknown';
}

});
parcelRegister("gqduQ", function(module, exports) {

$parcel$export(module.exports, "MediaFileStateError", () => $bbb89c3abac14beb$export$38242da09b559a);
class $bbb89c3abac14beb$export$38242da09b559a extends Error {
    constructor(id, reason, message = '', details){
        super(reason);
        this.id = id;
        this.reason = reason;
        this.message = message;
        this.details = details;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}

});



parcelRegister("jvF4x", function(module, exports) {

$parcel$export(module.exports, "getSSRPreview", () => $50ac7c582533743d$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $50ac7c582533743d$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $50ac7c582533743d$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $50ac7c582533743d$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $50ac7c582533743d$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $50ac7c582533743d$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $50ac7c582533743d$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $50ac7c582533743d$export$98e935d981c884d);

var $1p7md = parcelRequire("1p7md");

var $kj8oZ = parcelRequire("kj8oZ");

var $jyk7o = parcelRequire("jyk7o");

var $1eI0l = parcelRequire("1eI0l");
const $50ac7c582533743d$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $1p7md.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $jyk7o.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $50ac7c582533743d$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $1p7md.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $kj8oZ.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $50ac7c582533743d$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $50ac7c582533743d$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $50ac7c582533743d$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $50ac7c582533743d$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $50ac7c582533743d$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $50ac7c582533743d$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $1eI0l.getRemotePreview)(mediaClient, id, params, traceContext);
    return $50ac7c582533743d$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $50ac7c582533743d$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $1eI0l.getLocalPreview)(filePreview);
    return $50ac7c582533743d$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("1p7md", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $8948517ceba57403$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $8948517ceba57403$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $8948517ceba57403$export$e51a8146182600b8);
const $8948517ceba57403$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $8948517ceba57403$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$8948517ceba57403$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $8948517ceba57403$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $8948517ceba57403$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $8948517ceba57403$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $8948517ceba57403$var$getStringFromParams(params, 'collection'),
        alt: $8948517ceba57403$var$getStringFromParams(params, 'alt'),
        height: $8948517ceba57403$var$getNumberFromParams(params, 'height'),
        width: $8948517ceba57403$var$getNumberFromParams(params, 'width'),
        size: $8948517ceba57403$var$getNumberFromParams(params, 'size'),
        name: $8948517ceba57403$var$getStringFromParams(params, 'name'),
        mimeType: $8948517ceba57403$var$getStringFromParams(params, 'mimeType')
    };
};
const $8948517ceba57403$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $8948517ceba57403$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$8948517ceba57403$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $8948517ceba57403$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("jyk7o", function(module, exports) {

$parcel$export(module.exports, "mediaFilePreviewCache", () => $a222999f2a3917ca$export$b7e8ee3f7a41459);

var $fxEZn = parcelRequire("fxEZn");
const $a222999f2a3917ca$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $a222999f2a3917ca$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $a222999f2a3917ca$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $a222999f2a3917ca$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $a222999f2a3917ca$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $a222999f2a3917ca$export$b7e8ee3f7a41459 = new $a222999f2a3917ca$export$7b50526c091bb915((0, $fxEZn.createObjectURLCache)());

});
parcelRegister("fxEZn", function(module, exports) {

$parcel$export(module.exports, "createObjectURLCache", () => $3fcfa7c3b88343f6$export$ba71be67d5c32535);

var $4FH8r = parcelRequire("4FH8r");

var $6roQF = parcelRequire("6roQF");
const $3fcfa7c3b88343f6$export$36d0f9859761643d = 50;
class $3fcfa7c3b88343f6$var$ExtendedLRUCache extends (0, $6roQF.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $4FH8r.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $3fcfa7c3b88343f6$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $3fcfa7c3b88343f6$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $3fcfa7c3b88343f6$export$ba71be67d5c32535 = ()=>new $3fcfa7c3b88343f6$export$75d1c8c9ba1d0773($3fcfa7c3b88343f6$export$36d0f9859761643d);

});


parcelRegister("1eI0l", function(module, exports) {

$parcel$export(module.exports, "isSupportedLocalPreview", () => $3baf1546cf72426c$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3baf1546cf72426c$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3baf1546cf72426c$export$bfe20bd01db02b3);

var $3izHV = parcelRequire("3izHV");

var $dZWOK = parcelRequire("dZWOK");

var $kj8oZ = parcelRequire("kj8oZ");

var $3J2hq = parcelRequire("3J2hq");
const $3baf1546cf72426c$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3baf1546cf72426c$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $dZWOK.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $kj8oZ.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3baf1546cf72426c$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $3J2hq.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $kj8oZ.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3baf1546cf72426c$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $kj8oZ.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $3izHV.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3baf1546cf72426c$var$getImageLocalPreview(value);
            case 'video':
                return $3baf1546cf72426c$var$getVideoLocalPreview(value);
            default:
                throw new (0, $kj8oZ.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $kj8oZ.LocalPreviewError)('local-preview-unsupported');
};
const $3baf1546cf72426c$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $kj8oZ.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("dZWOK", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $20d9cb8065ed9c55$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $20d9cb8065ed9c55$export$67689507e8404821);

var $7Ks1a = parcelRequire("7Ks1a");

var $dcjbt = parcelRequire("dcjbt");

var $7R2PQ = parcelRequire("7R2PQ");

var $hTKdV = parcelRequire("hTKdV");
const { Orientation: $20d9cb8065ed9c55$var$Orientation, XResolution: $20d9cb8065ed9c55$var$XResolution } = (0, $7Ks1a.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $20d9cb8065ed9c55$var$DPI_WEB_BASELINE = 72;
async function $20d9cb8065ed9c55$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $20d9cb8065ed9c55$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $20d9cb8065ed9c55$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $20d9cb8065ed9c55$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $20d9cb8065ed9c55$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $20d9cb8065ed9c55$var$DPI_WEB_BASELINE;
        else return $20d9cb8065ed9c55$export$268f92356524130b(tags, $20d9cb8065ed9c55$var$XResolution, $20d9cb8065ed9c55$var$DPI_WEB_BASELINE) / $20d9cb8065ed9c55$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $20d9cb8065ed9c55$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$20d9cb8065ed9c55$var$Orientation]) {
        const tagValue = tags[$20d9cb8065ed9c55$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $7Ks1a.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $20d9cb8065ed9c55$export$67689507e8404821(file) {
    const tags = await (0, $dcjbt.readImageMetaTags)(file);
    return $20d9cb8065ed9c55$var$getOrientationFromTags(tags);
}
function $20d9cb8065ed9c55$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $20d9cb8065ed9c55$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $20d9cb8065ed9c55$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $dcjbt.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $20d9cb8065ed9c55$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $20d9cb8065ed9c55$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $7R2PQ.loadImage)(src);
        const { width: width, height: height } = (0, $7R2PQ.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("7Ks1a", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $3451dd865f26bcbe$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $3451dd865f26bcbe$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $3451dd865f26bcbe$export$f6ea0c89fd7d156);
var $3451dd865f26bcbe$export$48c85e6e32ef0825;
(function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
})($3451dd865f26bcbe$export$48c85e6e32ef0825 || ($3451dd865f26bcbe$export$48c85e6e32ef0825 = {}));
var $3451dd865f26bcbe$export$e369bb48cf33e564;
(function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
})($3451dd865f26bcbe$export$e369bb48cf33e564 || ($3451dd865f26bcbe$export$e369bb48cf33e564 = {}));
const $3451dd865f26bcbe$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("dcjbt", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $3968a72b4e3e5571$export$41982b5c7acb23c4);

var $7Ks1a = parcelRequire("7Ks1a");

var $90lR8 = parcelRequire("90lR8");

var $932a4 = parcelRequire("932a4");

var $g4zYY = parcelRequire("g4zYY");
async function $3968a72b4e3e5571$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $7Ks1a.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $932a4.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $g4zYY.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $7Ks1a.ImageType).JPEG) return await (0, $90lR8.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("90lR8", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $3cfacf7fa7775806$export$556b2ccec62d7f2a);

var $7Ks1a = parcelRequire("7Ks1a");
const { XResolution: $3cfacf7fa7775806$var$XResolution, YResolution: $3cfacf7fa7775806$var$YResolution } = (0, $7Ks1a.SupportedImageMetaTag);
let $3cfacf7fa7775806$var$loadImage;

function $3cfacf7fa7775806$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$3cfacf7fa7775806$var$loadImage) {
            const module = await (parcelRequire("al79X"));
            $3cfacf7fa7775806$var$loadImage = module.default || module;
        }
        $3cfacf7fa7775806$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $3cfacf7fa7775806$var$XResolution || key === $3cfacf7fa7775806$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("al79X", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4EQ6s").then(()=>parcelRequire('hB5r9'));

});


parcelRegister("932a4", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $d107ad611f184457$export$5fb37736440fca6f);

var $7R2PQ = parcelRequire("7R2PQ");
let $d107ad611f184457$var$pngChunksExtract;

async function $d107ad611f184457$export$5fb37736440fca6f(file) {
    if (!$d107ad611f184457$var$pngChunksExtract) {
        const module = await (parcelRequire("iz6F4"));
        $d107ad611f184457$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $7R2PQ.fileToArrayBuffer)(file);
    const chunks = $d107ad611f184457$var$pngChunksExtract(buffer);
    return await $d107ad611f184457$export$9185743fdd58ce45(chunks);
}
async function $d107ad611f184457$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("7R2PQ", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $762b6f6dab9d1b7f$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $762b6f6dab9d1b7f$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $762b6f6dab9d1b7f$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $762b6f6dab9d1b7f$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $762b6f6dab9d1b7f$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $762b6f6dab9d1b7f$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $762b6f6dab9d1b7f$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $762b6f6dab9d1b7f$export$61a1de0822e2820);

var $hdGyo = parcelRequire("hdGyo");

var $8LNkR = parcelRequire("8LNkR");

var $eCjZE = parcelRequire("eCjZE");

var $9x8bE = parcelRequire("9x8bE");

var $eKyyR = parcelRequire("eKyyR");

var $3WWqq = parcelRequire("3WWqq");

var $hq1pc = parcelRequire("hq1pc");

var $2qasA = parcelRequire("2qasA");

var $dMHxL = parcelRequire("dMHxL");

var $bMNrG = parcelRequire("bMNrG");

var $h7CpT = parcelRequire("h7CpT");

var $6Wxq8 = parcelRequire("6Wxq8");

var $h5uIF = parcelRequire("h5uIF");

var $3FCIk = parcelRequire("3FCIk");

var $3NApm = parcelRequire("3NApm");

var $1OdUR = parcelRequire("1OdUR");
function $762b6f6dab9d1b7f$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $762b6f6dab9d1b7f$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $762b6f6dab9d1b7f$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $762b6f6dab9d1b7f$export$849633012686f7ee(file)
    };
}
async function $762b6f6dab9d1b7f$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $762b6f6dab9d1b7f$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $762b6f6dab9d1b7f$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $762b6f6dab9d1b7f$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $762b6f6dab9d1b7f$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $762b6f6dab9d1b7f$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $762b6f6dab9d1b7f$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hdGyo)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dMHxL)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($h7CpT)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dMHxL)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bMNrG)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qasA)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9x8bE)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3FCIk)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eCjZE)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8LNkR)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($h5uIF)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6Wxq8)))
    }
];
function $762b6f6dab9d1b7f$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $762b6f6dab9d1b7f$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $1OdUR.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3NApm)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eKyyR)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3WWqq)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hq1pc)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("hdGyo", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c894a8df21fa5c84$var$_react = $c894a8df21fa5c84$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c894a8df21fa5c84$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c894a8df21fa5c84$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $c894a8df21fa5c84$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869v1.546zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665v3.715zM4.462 15.99h-1.08A.384.384 0 013 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 01-.383.384zm7.45 0h-2.24a.384.384 0 01-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506zm5.776 0h-1.08a.384.384 0 01-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 01-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 01-.383.384z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c894a8df21fa5c84$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $c894a8df21fa5c84$var$_default = $c894a8df21fa5c84$var$PdfDocument24Icon;
module.exports.default = $c894a8df21fa5c84$var$_default;

});

parcelRegister("8LNkR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6628fb7cf0e02b12$var$_react = $6628fb7cf0e02b12$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6628fb7cf0e02b12$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6628fb7cf0e02b12$var$Gif24Icon = (props)=>/*#__PURE__*/ $6628fb7cf0e02b12$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FFAB00" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm10.564 16.636h-1.93a.243.243 0 01-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 01-.243.243m3.79 0h-1.931a.243.243 0 01-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 01-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.241.241 0 01-.242.258H8.195a.243.243 0 01-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 01-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$6628fb7cf0e02b12$var$Gif24Icon.displayName = 'Gif24Icon';
var $6628fb7cf0e02b12$var$_default = $6628fb7cf0e02b12$var$Gif24Icon;
module.exports.default = $6628fb7cf0e02b12$var$_default;

});

parcelRegister("eCjZE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $aa441f8cde622841$var$_react = $aa441f8cde622841$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $aa441f8cde622841$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $aa441f8cde622841$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $aa441f8cde622841$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#CA5010" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1.376 6.013A.437.437 0 004 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 00.497-.434V4.868a.437.437 0 00-.499-.434L4.376 6.014zM17 7v10h2.5a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5H17zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.421-2.514 2.421H9.329V15.5H7.854V8.454zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231H9.33z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$aa441f8cde622841$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $aa441f8cde622841$var$_default = $aa441f8cde622841$var$PowerpointPresentation24Icon;
module.exports.default = $aa441f8cde622841$var$_default;

});

parcelRegister("9x8bE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6f0d8bdcc8cbb422$var$_react = $6f0d8bdcc8cbb422$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6f0d8bdcc8cbb422$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6f0d8bdcc8cbb422$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $6f0d8bdcc8cbb422$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1D7AFC" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1.376 6.013A.437.437 0 004 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 00.497-.434V4.868a.437.437 0 00-.499-.434L4.376 6.014zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663h-.078zM17 7v10h2.5a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5H17z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$6f0d8bdcc8cbb422$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $6f0d8bdcc8cbb422$var$_default = $6f0d8bdcc8cbb422$var$WordDocument24Icon;
module.exports.default = $6f0d8bdcc8cbb422$var$_default;

});

parcelRegister("eKyyR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $abd02bb672a51ffd$var$_react = $abd02bb672a51ffd$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $abd02bb672a51ffd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $abd02bb672a51ffd$var$Sketch24Icon = (props)=>/*#__PURE__*/ $abd02bb672a51ffd$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FF8B00" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm9.03 20h.001c.29-.001.562-.126.752-.343l6.971-8a1 1 0 00.095-1.185l-2.485-4a1.003 1.003 0 00-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 00.081 1.216l7.03 8c.188.216.462.34.75.34z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$abd02bb672a51ffd$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $abd02bb672a51ffd$var$_default = $abd02bb672a51ffd$var$Sketch24Icon;
module.exports.default = $abd02bb672a51ffd$var$_default;

});

parcelRegister("3WWqq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2e041bec93092120$var$_react = $2e041bec93092120$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2e041bec93092120$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2e041bec93092120$var$Figma24Icon = (props)=>/*#__PURE__*/ $2e041bec93092120$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.248 0A3.248 3.248 0 000 3.248v17.504A3.248 3.248 0 003.248 24h17.504A3.248 3.248 0 0024 20.752V3.248A3.248 3.248 0 0020.752 0H3.248zm8.755 17.012a2.506 2.506 0 01-2.505 2.507 2.506 2.506 0 010-5.013 2.506 2.506 0 010-5.012 2.506 2.506 0 010-5.013h5.009a2.506 2.506 0 010 5.013h-2.505v2.5a2.506 2.506 0 012.505-2.5 2.506 2.506 0 010 5.012 2.506 2.506 0 01-2.505-2.5v5.006z" fill="#8270DB"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2e041bec93092120$var$Figma24Icon.displayName = 'Figma24Icon';
var $2e041bec93092120$var$_default = $2e041bec93092120$var$Figma24Icon;
module.exports.default = $2e041bec93092120$var$_default;

});

parcelRegister("hq1pc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $cae5f47c2a571309$var$_react = $cae5f47c2a571309$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $cae5f47c2a571309$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $cae5f47c2a571309$var$Executable24Icon = (props)=>/*#__PURE__*/ $cae5f47c2a571309$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm2 13v5a1 1 0 001 1h12a1 1 0 001-1v-5H5zm1.883-8a1 1 0 00-.992.876L5 13h14l-.89-7.124A1 1 0 0017.116 5H6.883zM8 15h8a1 1 0 010 2H8a1 1 0 010-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$cae5f47c2a571309$var$Executable24Icon.displayName = 'Executable24Icon';
var $cae5f47c2a571309$var$_default = $cae5f47c2a571309$var$Executable24Icon;
module.exports.default = $cae5f47c2a571309$var$_default;

});

parcelRegister("2qasA", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1c361fa263fe065a$var$_react = $1c361fa263fe065a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $1c361fa263fe065a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1c361fa263fe065a$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $1c361fa263fe065a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196F3" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm12.049 5l-5.422.055 4.677 8.15 5.422-.055L15.049 5zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697L4 14.108zm6.646.141L7.982 19h9.354L20 14.249h-9.354z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1c361fa263fe065a$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $1c361fa263fe065a$var$_default = $1c361fa263fe065a$var$GoogleDoc24Icon;
module.exports.default = $1c361fa263fe065a$var$_default;

});

parcelRegister("dMHxL", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a09188e84ea7ab45$var$_react = $a09188e84ea7ab45$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a09188e84ea7ab45$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a09188e84ea7ab45$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $a09188e84ea7ab45$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270DB" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm12.049 5l-5.422.055 4.677 8.15 5.422-.055L15.049 5zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697L4 14.108zm6.646.141L7.982 19h9.354L20 14.249h-9.354z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$a09188e84ea7ab45$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $a09188e84ea7ab45$var$_default = $a09188e84ea7ab45$var$GoogleForm24Icon;
module.exports.default = $a09188e84ea7ab45$var$_default;

});

parcelRegister("bMNrG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $894a8844a9a1528d$var$_react = $894a8844a9a1528d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $894a8844a9a1528d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $894a8844a9a1528d$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $894a8844a9a1528d$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0A9D58" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm12.049 5l-5.422.055 4.677 8.15 5.422-.055L15.049 5zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697L4 14.108zm6.646.141L7.982 19h9.354L20 14.249h-9.354z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$894a8844a9a1528d$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $894a8844a9a1528d$var$_default = $894a8844a9a1528d$var$GoogleSheet24Icon;
module.exports.default = $894a8844a9a1528d$var$_default;

});

parcelRegister("h7CpT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c770e3deabcd313a$var$_react = $c770e3deabcd313a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c770e3deabcd313a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c770e3deabcd313a$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $c770e3deabcd313a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FFC107" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm12.049 5l-5.422.055 4.677 8.15 5.422-.055L15.049 5zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697L4 14.108zm6.646.141L7.982 19h9.354L20 14.249h-9.354z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c770e3deabcd313a$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $c770e3deabcd313a$var$_default = $c770e3deabcd313a$var$GoogleSlide24Icon;
module.exports.default = $c770e3deabcd313a$var$_default;

});

parcelRegister("6Wxq8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $50e215742d0d2558$var$_react = $50e215742d0d2558$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $50e215742d0d2558$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $50e215742d0d2558$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $50e215742d0d2558$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22A06B" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1.376 6.013A.437.437 0 004 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 00.497-.434V4.868a.437.437 0 00-.499-.434L4.376 6.014zM17 7v10h2.5a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5H17zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5H6.93z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$50e215742d0d2558$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $50e215742d0d2558$var$_default = $50e215742d0d2558$var$ExcelSpreadsheet24Icon;
module.exports.default = $50e215742d0d2558$var$_default;

});

parcelRegister("h5uIF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c70abb8afd54d479$var$_react = $c70abb8afd54d479$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c70abb8afd54d479$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c70abb8afd54d479$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $c70abb8afd54d479$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36B37E" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm2 5a1 1 0 100 2h3a1 1 0 100-2H5zm0 4a1 1 0 100 2h3a1 1 0 000-2H5zm0 4a1 1 0 000 2h3a1 1 0 000-2H5zm0 4a1 1 0 000 2h3a1 1 0 000-2H5zm7-12a1 1 0 000 2h7a1 1 0 000-2h-7zm0 4a1 1 0 000 2h7a1 1 0 000-2h-7zm0 4a1 1 0 000 2h7a1 1 0 000-2h-7zm0 4a1 1 0 000 2h7a1 1 0 000-2h-7z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c70abb8afd54d479$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $c70abb8afd54d479$var$_default = $c70abb8afd54d479$var$Spreadsheet24Icon;
module.exports.default = $c70abb8afd54d479$var$_default;

});

parcelRegister("3FCIk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2ac33b3cb49c77eb$var$_react = $2ac33b3cb49c77eb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2ac33b3cb49c77eb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2ac33b3cb49c77eb$var$Presentation24Icon = (props)=>/*#__PURE__*/ $2ac33b3cb49c77eb$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270DB" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm3 14a1 1 0 00-1 1v3a1 1 0 002 0v-3a1 1 0 00-1-1zm8-6a1 1 0 00-1 1v9a1 1 0 002 0V9a1 1 0 00-1-1zm-4 4a1 1 0 00-1 1v5a1 1 0 002 0v-5a1 1 0 00-1-1zm8-7a1 1 0 00-1 1v12a1 1 0 002 0V6a1 1 0 00-1-1z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2ac33b3cb49c77eb$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $2ac33b3cb49c77eb$var$_default = $2ac33b3cb49c77eb$var$Presentation24Icon;
module.exports.default = $2ac33b3cb49c77eb$var$_default;

});

parcelRegister("3NApm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2c42309754fc4881$var$_react = $2c42309754fc4881$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2c42309754fc4881$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2c42309754fc4881$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $2c42309754fc4881$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00B8D9" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm5.017 12.265l-2.58-2.501L8.236 7.05a.999.999 0 10-1.392-1.436l-3.54 3.432a1 1 0 000 1.436l3.32 3.219a1 1 0 101.393-1.436zm6.638-8.21a1 1 0 00-1.271.62l-4.83 14.046a1 1 0 001.892.65l4.829-14.045a1 1 0 00-.62-1.271zm6.081 9.776l-3.32-3.219a.999.999 0 10-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 101.392 1.436l3.54-3.432a1 1 0 000-1.436z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2c42309754fc4881$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $2c42309754fc4881$var$_default = $2c42309754fc4881$var$SourceCode24Icon;
module.exports.default = $2c42309754fc4881$var$_default;

});

parcelRegister("1OdUR", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $d49392d0af6b4c2e$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $d49392d0af6b4c2e$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $d49392d0af6b4c2e$export$ba4368c844580f9e);
function $d49392d0af6b4c2e$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $d49392d0af6b4c2e$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $d49392d0af6b4c2e$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $d49392d0af6b4c2e$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $d49392d0af6b4c2e$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $d49392d0af6b4c2e$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $d49392d0af6b4c2e$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("iz6F4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("f26P8").then(()=>parcelRequire('3TpCy'));

});


parcelRegister("g4zYY", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $75e912d905a332c2$export$55c3bc9841b19de2);
function $75e912d905a332c2$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("hTKdV", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $5ac62904b0493085$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $5ac62904b0493085$export$43142f95b8de7a91);
const $5ac62904b0493085$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $5ac62904b0493085$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $5ac62904b0493085$export$43142f95b8de7a91 = (orientation)=>{
    return $5ac62904b0493085$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("3J2hq", function(module, exports) {

$parcel$export(module.exports, "takeSnapshot", () => $34418b456963f386$export$4269d30173168e5c);
const $34418b456963f386$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("862c0", function(module, exports) {

$parcel$export(module.exports, "getMediaCardSSR", () => $635d7cc412152f53$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $635d7cc412152f53$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $635d7cc412152f53$export$de7c49925e44d75d);

var $7UQrl = parcelRequire("7UQrl");
const $635d7cc412152f53$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $635d7cc412152f53$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $635d7cc412152f53$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $635d7cc412152f53$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $635d7cc412152f53$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $635d7cc412152f53$var$dashed = (param)=>param ? `-${param}` : '';
const $635d7cc412152f53$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$635d7cc412152f53$var$dashed(collectionName)}${$635d7cc412152f53$var$dashed(occurrenceKey)}`;
const $635d7cc412152f53$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $635d7cc412152f53$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $635d7cc412152f53$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $7UQrl.printFunctionCall)($635d7cc412152f53$export$4310981e0aa4ce67, $635d7cc412152f53$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $7UQrl.printScript)([
        $635d7cc412152f53$export$ede93d4564eaa8da.toString(),
        $635d7cc412152f53$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $635d7cc412152f53$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $635d7cc412152f53$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("7UQrl", function(module, exports) {

$parcel$export(module.exports, "printFunctionCall", () => $9e4757ccfa33a587$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $9e4757ccfa33a587$export$8b902fb69a2f17c1);
const $9e4757ccfa33a587$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $9e4757ccfa33a587$var$printParams = (args)=>args.map((arg)=>$9e4757ccfa33a587$var$printParam(arg)).join(',');
const $9e4757ccfa33a587$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$9e4757ccfa33a587$var$printParams(args)});`;
const $9e4757ccfa33a587$export$8b902fb69a2f17c1 = (statements)=>`(function(){
  ${statements.join(';')}
})();
`;

});


parcelRegister("6tTCR", function(module, exports) {

$parcel$export(module.exports, "getSSRData", () => $88c51d281a1c15e7$export$d3a890b0f7844b6f);

var $862c0 = parcelRequire("862c0");
const $88c51d281a1c15e7$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $862c0.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $862c0.getKey)(identifier)];
};

});

parcelRegister("2GnF5", function(module, exports) {

$parcel$export(module.exports, "isBigger", () => $0956df2291cfa61d$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $0956df2291cfa61d$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $0956df2291cfa61d$export$b3e10e1f0fbb71db);

var $eUqFw = parcelRequire("eUqFw");
const $0956df2291cfa61d$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $0956df2291cfa61d$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $0956df2291cfa61d$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $0956df2291cfa61d$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $0956df2291cfa61d$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $eUqFw.useRef)(value);
    ref.current = value;
    return ref;
}

});





parcelRegister("9diuQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fc8e038c7f58db8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4fc8e038c7f58db8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholderNoneEntered: {
        "id": "servicedesk-insight-attribute-views.common.placeholder-none-entered",
        "defaultMessage": "None entered"
    },
    placeholderNoneSelected: {
        "id": "servicedesk-insight-attribute-views.common.placeholder-none-selected",
        "defaultMessage": "None selected"
    }
});

});

parcelRegister("l7ZPk", function(module, exports) {

$parcel$export(module.exports, "ObjectDetailsSpacer", () => $25d92313af6a2d2b$export$b8f1b5c1e5f43c5c);
$parcel$export(module.exports, "ReadViewContainer", () => $25d92313af6a2d2b$export$ebb3489b83262b26);
$parcel$export(module.exports, "RoleList", () => $25d92313af6a2d2b$export$f28593264fbf36da);
$parcel$export(module.exports, "RoleContainer", () => $25d92313af6a2d2b$export$e5989493d486ab26);
$parcel$export(module.exports, "RoleDisplayName", () => $25d92313af6a2d2b$export$a57fa052c6fb1799);
$parcel$export(module.exports, "AvatarWrapper", () => $25d92313af6a2d2b$export$f7513421c53ce141);
$parcel$export(module.exports, "PlaceholderSpacer", () => $25d92313af6a2d2b$export$e5d47ed31c76a9c0);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $c9TLT = parcelRequire("c9TLT");
const $25d92313af6a2d2b$export$b8f1b5c1e5f43c5c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt458a2",
            __cmplp.className
        ])
    });
});
const $25d92313af6a2d2b$var$readViewContainerStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    lineHeight: `${(0, $c9TLT.gridSize) * 2.5}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    minHeight: `${(0, $c9TLT.gridSize) * 2.25}px`,
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    flexFlow: 'wrap'
});
const $25d92313af6a2d2b$var$readViewContainerPlaceholderStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtlest',
    wordBreak: 'break-word',
    overflowWrap: 'break-word'
});
const $25d92313af6a2d2b$var$readViewContainerNonPlaceholderStyles = (0, $1ZAYh.xcss)({
    wordBreak: 'break-all'
});
const $25d92313af6a2d2b$export$ebb3489b83262b26 = ({ children: children, isPlaceholder: isPlaceholder })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        alignItems: "center",
        xcss: [
            $25d92313af6a2d2b$var$readViewContainerStyles,
            isPlaceholder ? $25d92313af6a2d2b$var$readViewContainerPlaceholderStyles : $25d92313af6a2d2b$var$readViewContainerNonPlaceholderStyles
        ]
    }, children);
const $25d92313af6a2d2b$export$f28593264fbf36da = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1n261g80 _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $25d92313af6a2d2b$export$e5989493d486ab26 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _bfhk1s4m _2rko7vkz _1yt4d9x7",
            __cmplp.className
        ])
    });
});
const $25d92313af6a2d2b$export$a57fa052c6fb1799 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
const $25d92313af6a2d2b$export$f7513421c53ce141 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0r5cr _1aayyfq0",
            __cmplp.className
        ])
    });
});
const $25d92313af6a2d2b$export$e5d47ed31c76a9c0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4x7n9",
            __cmplp.className
        ])
    });
});

});


parcelRegister("ixjcP", function(module, exports) {

$parcel$export(module.exports, "InsightSchemaContainerSkeleton", () => $75319464a4eaa879$export$b0724c56a3d557df);
$parcel$export(module.exports, "InsightRecentObjectContainerSkeleton", () => $75319464a4eaa879$export$da0d7917b3d96c87);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $jVzGk = parcelRequire("jVzGk");

var $kYu62 = parcelRequire("kYu62");
const $75319464a4eaa879$var$skeletonCssStyles = null;
const $75319464a4eaa879$export$b0724c56a3d557df = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kYu62))),
        containerStyles: {
            maxHeight: '30em'
        },
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    });
const $75319464a4eaa879$export$da0d7917b3d96c87 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jVzGk))),
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("jVzGk", function(module, exports) {
module.exports = new URL("insight-recent-object-container-skeleton.tpl.1a59f7d0.svg", import.meta.url).toString();

});

parcelRegister("kYu62", function(module, exports) {
module.exports = new URL("insight-schema-container-skeleton.tpl.33f9a64b.svg", import.meta.url).toString();

});


parcelRegister("7dk6A", function(module, exports) {

$parcel$export(module.exports, "ErrorContent", () => $bbdb0e5c7cf05fd0$export$a9f602ed820d9782);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $2BP1Y = parcelRequire("2BP1Y");

var $4Es8k = parcelRequire("4Es8k");

var $5JgJ2 = parcelRequire("5JgJ2");

var $84TLE = parcelRequire("84TLE");
const $bbdb0e5c7cf05fd0$export$a9f602ed820d9782 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const renderImage = ()=>(0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $2BP1Y.default))({
            imageWidth: 164,
            maxImageWidth: 164,
            maxImageHeight: 212
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        size: "wide",
        renderImage: renderImage,
        header: formatMessage((0, $84TLE.messages).errorTitle),
        description: formatMessage((0, $84TLE.messages).errorDescription)
    });
};

});
parcelRegister("2BP1Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $e497aeb1100a6e82$export$2e2bcd8739ae039);

var $9TZf5 = parcelRequire("9TZf5");

var $4mFwk = parcelRequire("4mFwk");
const $e497aeb1100a6e82$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4mFwk)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($4mFwk))
});
var $e497aeb1100a6e82$export$2e2bcd8739ae039 = $e497aeb1100a6e82$var$Illustration;
const $e497aeb1100a6e82$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    212
];

});
parcelRegister("4mFwk", function(module, exports) {
module.exports = new URL("error-white.e2723ea8.svg", import.meta.url).toString();

});


parcelRegister("84TLE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ba7147fb17426ba9$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ba7147fb17426ba9$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "servicedesk-insight-object-container.error.error-title",
        "defaultMessage": "There\u2019s been a problem loading the recent objects"
    },
    errorDescription: {
        "id": "servicedesk-insight-object-container.error.error-description",
        "defaultMessage": "Try refreshing the page."
    }
});

});


parcelRegister("2IAbP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5cb4d1e301c6bacf$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $5cb4d1e301c6bacf$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    objectSchemas: {
        "id": "servicedesk-insight-object-container.object-schemas",
        "defaultMessage": "Recent objects"
    },
    viewMore: {
        "id": "servicedesk-insight-object-container.view-more",
        "defaultMessage": "View more"
    },
    noObjectsToShow: {
        "id": "servicedesk-insight-object-container.no-objects-to-show",
        "defaultMessage": "No recent objects to show"
    }
});

});


parcelRegister("5jstg", function(module, exports) {

$parcel$export(module.exports, "RapidSearchBar", () => $3b9d51077c0e8c54$export$40bc8f1aee723991);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $bFzGY = parcelRequire("bFzGY");

var $lB25E = parcelRequire("lB25E");

var $9U2XD = parcelRequire("9U2XD");

var $aSJew = parcelRequire("aSJew");

var $272oI = parcelRequire("272oI");


var $ajJuu = parcelRequire("ajJuu");

var $8EkO0 = parcelRequire("8EkO0");

var $lQX4w = parcelRequire("lQX4w");

var $3aZFW = parcelRequire("3aZFW");
const $3b9d51077c0e8c54$var$isNotBlank = (value)=>value.trim().length > 0;
const $3b9d51077c0e8c54$export$40bc8f1aee723991 = ({ workspaceId: workspaceId, restrictedObjectSchemaIds: restrictedObjectSchemaIds, renderSearchTextfield: renderSearchTextfield })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [popupWidth, setPopupWidth] = (0, $eUqFw.useState)(400);
    const { query: query, setQuery: setQuery, searchState: searchState } = (0, $8EkO0.useRapidSearch)(workspaceId);
    const [selectedIndex, setSelectedIndex] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        // Clear selection after search changes
        setSelectedIndex(null);
    }, [
        searchState,
        setSelectedIndex
    ]);
    const onNavigateToResult = ()=>{
        setIsOpen(false);
        setQuery('');
        setSelectedIndex(null);
    };
    const onKeyDown = (event)=>{
        switch(event.key){
            case 'ArrowDown':
                if (searchState.type === 'success') {
                    const { objects: objects, objectTypes: objectTypes } = searchState.searchResult;
                    event.preventDefault();
                    if (selectedIndex !== null) setSelectedIndex(Math.min(selectedIndex + 1, objects.length + objectTypes.length - 1));
                    else setSelectedIndex(0);
                }
                break;
            case 'ArrowUp':
                event.preventDefault();
                if (selectedIndex !== null) setSelectedIndex(Math.max(0, selectedIndex - 1));
                else setSelectedIndex(0);
                break;
            case 'Enter':
                if (searchState.type === 'success' && selectedIndex !== null) {
                    const { objects: objects, objectTypes: objectTypes } = searchState.searchResult;
                    if (selectedIndex < objects.length) {
                        const object = objects[selectedIndex];
                        (0, $ajJuu.fireObjectClickedUiEvent)({
                            analyticsEvent: createAnalyticsEvent({}),
                            objectId: (0, $aSJew.toCmdbObjectId)(object.id),
                            schemaId: (0, $aSJew.toSchemaId)(object.objectSchemaId),
                            restrictedObjectSchemaIds: restrictedObjectSchemaIds
                        });
                        push((0, $272oI.createObjectDetailUrl)((0, $aSJew.toCmdbObjectId)(object.id)));
                        onNavigateToResult();
                    } else {
                        const objectType = objectTypes[selectedIndex - objects.length];
                        (0, $ajJuu.fireObjectTypeClickedUiEvent)({
                            analyticsEvent: createAnalyticsEvent({}),
                            objectTypeId: (0, $aSJew.toCmdbObjectTypeId)(objectType.id),
                            schemaId: (0, $aSJew.toSchemaId)(objectType.objectSchemaId),
                            restrictedObjectSchemaIds: restrictedObjectSchemaIds
                        });
                        push((0, $272oI.createObjectTypeUrl)((0, $aSJew.toSchemaId)(objectType.objectSchemaId), (0, $aSJew.toCmdbObjectTypeId)(objectType.id)));
                        onNavigateToResult();
                    }
                }
                break;
            case 'Esc':
            case 'Escape':
                setQuery('');
                setSelectedIndex(null);
                break;
            default:
        }
    };
    const onKeyUp = (event)=>{
        switch(event.key){
            case 'Esc':
            case 'Escape':
                // Prevents input from losing focus when hitting ESC to close the popup
                event.stopPropagation();
                event.nativeEvent.stopImmediatePropagation();
                break;
            default:
        }
    };
    const onChange = (event)=>{
        const userInput = event.target.value;
        if (userInput.trim().length >= (0, $19a37bc8e22978f7$export$16d80a8e6849f8af)) (0, $9U2XD.rapidSearchExperience).start();
        setIsOpen($3b9d51077c0e8c54$var$isNotBlank(userInput));
        setQuery(userInput);
        setSelectedIndex(null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        autoFocus: false,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: [
                    $3b9d51077c0e8c54$var$popupWrapperStyles,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                    (0, $1ZAYh.xcss)({
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                        width: `${popupWidth}px`
                    })
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lQX4w.PopupContent), {
                query: query,
                searchState: searchState,
                selectedIndex: selectedIndex,
                restrictedObjectSchemaIds: restrictedObjectSchemaIds,
                onResultClick: onNavigateToResult
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3aZFW.TextfieldTrigger), {
                ...triggerProps,
                isOpen: isOpen,
                onClick: ()=>setIsOpen($3b9d51077c0e8c54$var$isNotBlank(query)),
                onChange: onChange,
                onKeyDown: onKeyDown,
                onKeyUp: onKeyUp,
                value: query,
                setPopupWidth: setPopupWidth,
                renderSearchTextfield: renderSearchTextfield
            }),
        placement: "bottom-start",
        testId: "servicedesk-insight-rapid-search-bar.ui.popup"
    });
};
const $3b9d51077c0e8c54$var$popupWrapperStyles = (0, $1ZAYh.xcss)({
    overflow: 'auto'
});

});
parcelRegister("9U2XD", function(module, exports) {

$parcel$export(module.exports, "graphModalExperience", () => $8c84c39cbd5b3ad6$export$1b179afadba799dc);
$parcel$export(module.exports, "rapidSearchExperience", () => $8c84c39cbd5b3ad6$export$1a90deecc86e78f8);
$parcel$export(module.exports, "autocompleteInsightFieldExperience", () => $8c84c39cbd5b3ad6$export$94337fa170a193d2);
$parcel$export(module.exports, "fetchAffectedServicesExperience", () => $8c84c39cbd5b3ad6$export$ce8d2a860f4e0316);
$parcel$export(module.exports, "objectDetailsViewExperience", () => $8c84c39cbd5b3ad6$export$8e0a16d0fc0feba3);
$parcel$export(module.exports, "objectViewInlineEditSwitchFromReadToEditModeExperience", () => $8c84c39cbd5b3ad6$export$5ae0e1bbe443c52b);
$parcel$export(module.exports, "objectViewInlineEditSwitchFromEditToReadModeExperience", () => $8c84c39cbd5b3ad6$export$b9c9c5e92fa6a3a4);
$parcel$export(module.exports, "createObjectTypeExperience", () => $8c84c39cbd5b3ad6$export$15a29f6e079c9b3d);
$parcel$export(module.exports, "createObjectExperience", () => $8c84c39cbd5b3ad6$export$aaf507c87c29ab22);
$parcel$export(module.exports, "loadSchemaObjectListExperience", () => $8c84c39cbd5b3ad6$export$6f02ba4c2b1e3f5f);
$parcel$export(module.exports, "loadAttributesConfigurationExperience", () => $8c84c39cbd5b3ad6$export$8f63f06b0486e498);
$parcel$export(module.exports, "updateObjectFilterExperience", () => $8c84c39cbd5b3ad6$export$967859e6be8e6f4b);
$parcel$export(module.exports, "getUpdateGlobalConfigInlineEditExperience", () => $8c84c39cbd5b3ad6$export$e4deb66475dfa46b);
$parcel$export(module.exports, "loadObjectDetailExperience", () => $8c84c39cbd5b3ad6$export$3f1da23c065671d2);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $8c84c39cbd5b3ad6$export$1b179afadba799dc = new (0, $kDfSL.UFOExperience)('service-management.insight-cmdb.display-graph-modal', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    type: (0, $12kyE.ExperienceTypes).Experience
});
const $8c84c39cbd5b3ad6$export$1a90deecc86e78f8 = new (0, $kDfSL.UFOExperience)('service-management.insight-cmdb.display-rapid-search-results', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    type: (0, $12kyE.ExperienceTypes).Experience
});
const $8c84c39cbd5b3ad6$export$94337fa170a193d2 = new (0, $kDfSL.UFOExperience)('service-management.insight-cmdb.autocomplete-search-insight-field', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    type: (0, $12kyE.ExperienceTypes).Experience,
    featureFlags: [
        'jsm-insight-field-performance-improvements_fplgq'
    ]
});
const $8c84c39cbd5b3ad6$export$ce8d2a860f4e0316 = new (0, $kDfSL.UFOExperience)('service-management.insight-cmdb.fetch-affected-services', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    type: (0, $12kyE.ExperienceTypes).Experience
});
const $8c84c39cbd5b3ad6$export$8e0a16d0fc0feba3 = new (0, $kDfSL.UFOExperience)('jsm-cmdb-object-details-view', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $8c84c39cbd5b3ad6$export$5ae0e1bbe443c52b = new (0, $kDfSL.UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-read-to-edit-mode', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    type: (0, $12kyE.ExperienceTypes).Experience
});
const $8c84c39cbd5b3ad6$export$b9c9c5e92fa6a3a4 = new (0, $kDfSL.UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-edit-to-read-mode', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    type: (0, $12kyE.ExperienceTypes).Experience
});
const $8c84c39cbd5b3ad6$export$15a29f6e079c9b3d = new (0, $kDfSL.UFOExperience)('jsm-cmdb-create-object-type', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'created-on-server',
            endMark: 'object-type-created-on-server'
        }
    ]
});
const $8c84c39cbd5b3ad6$export$aaf507c87c29ab22 = new (0, $kDfSL.UFOExperience)('service-management.insight-cmdb.create-object', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    type: (0, $12kyE.ExperienceTypes).Experience
});
const $8c84c39cbd5b3ad6$export$6f02ba4c2b1e3f5f = new (0, $kDfSL.UFOExperience)('jsm-cmdb-load-object-list', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $8c84c39cbd5b3ad6$export$8f63f06b0486e498 = new (0, $kDfSL.UFOExperience)('jsm-cmdb-load-attributes-tab', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $8c84c39cbd5b3ad6$export$967859e6be8e6f4b = new (0, $kDfSL.UFOExperience)('jsm-cmdb-object-filter', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'response-received',
            endMark: 'server-response-received'
        },
        {
            key: 'object-table-rendered',
            endMark: 'object-table-rendered'
        },
        {
            key: 'object-list-rendered',
            endMark: 'object-list-rendered'
        },
        {
            key: 'no-filter-results-rendered',
            endMark: 'no-filter-results-rendered'
        }
    ]
});
const $8c84c39cbd5b3ad6$export$e4deb66475dfa46b = ()=>new (0, $kDfSL.UFOExperience)('service-management.insight-cmdb.global-config-inline-edit.update', {
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
        type: (0, $12kyE.ExperienceTypes).Experience
    });
const $8c84c39cbd5b3ad6$export$3f1da23c065671d2 = new (0, $kDfSL.UFOExperience)('service-management.insight-cmdb.embedded-object-details-view', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});

});

const $19a37bc8e22978f7$export$16d80a8e6849f8af = 2;

parcelRegister("ajJuu", function(module, exports) {

$parcel$export(module.exports, "fireObjectClickedUiEvent", () => $3652f3382742e561$export$8a87e5c0106fedb4);
$parcel$export(module.exports, "fireObjectTypeClickedUiEvent", () => $3652f3382742e561$export$8faac28956ce929a);

var $jMP2a = parcelRequire("jMP2a");

var $8apha = parcelRequire("8apha");
const $3652f3382742e561$export$8a87e5c0106fedb4 = ({ analyticsEvent: analyticsEvent, objectId: objectId, schemaId: schemaId, restrictedObjectSchemaIds: restrictedObjectSchemaIds })=>{
    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'link clicked', 'insightRapidSearchResult', {
        searchResultType: 'object',
        objectId: objectId,
        ...(0, $8apha.getCmdbAnalyticAttributesFromRestrictedSchemaIds)(restrictedObjectSchemaIds, schemaId)
    });
};
const $3652f3382742e561$export$8faac28956ce929a = ({ analyticsEvent: analyticsEvent, objectTypeId: objectTypeId, schemaId: schemaId, restrictedObjectSchemaIds: restrictedObjectSchemaIds })=>{
    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'link clicked', 'insightRapidSearchResult', {
        searchResultType: 'objectType',
        objectTypeId: objectTypeId,
        ...(0, $8apha.getCmdbAnalyticAttributesFromRestrictedSchemaIds)(restrictedObjectSchemaIds, schemaId)
    });
};

});
parcelRegister("8apha", function(module, exports) {

$parcel$export(module.exports, "getCmdbAnalyticAttributesFromRestrictedSchemaIds", () => $db24882efb60a482$export$cb3264f64bbc7ae7);
$parcel$export(module.exports, "getCmdbAnalyticAttributesFromSchema", () => $db24882efb60a482$export$9271034174e458dc);
const $db24882efb60a482$export$cb3264f64bbc7ae7 = (restrictedObjectSchemaIds, schemaId)=>({
        cmdbUiSource: restrictedObjectSchemaIds.includes(schemaId) ? 'service' : 'insight'
    });
const $db24882efb60a482$export$9271034174e458dc = (/** This is set to partial due to ObjectSchema from store and ObjectSchema from shared-types being incompatible */ schema)=>({
        cmdbUiSource: schema.isRestricted ? 'service' : 'insight',
        atlassianTemplateId: schema.atlassianTemplateId
    });

});


parcelRegister("8EkO0", function(module, exports) {

$parcel$export(module.exports, "useRapidSearch", () => $ae4b624271cb328c$export$3a0917c306e9b95b);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");


var $1AjgI = parcelRequire("1AjgI");
const $ae4b624271cb328c$var$EMPTY_SEARCH_RESULT = {
    objects: [],
    objectTypes: []
};
const $ae4b624271cb328c$var$DEBOUNCE_MILLIS = 300;
const $ae4b624271cb328c$var$queriesAreEquivalent = (firstQuery, secondQuery)=>firstQuery.trim() === secondQuery.trim();
const $ae4b624271cb328c$export$3a0917c306e9b95b = (workspaceId)=>{
    const [state, setState] = (0, $eUqFw.useState)({
        query: '',
        searchState: {
            type: 'loading'
        }
    });
    const search = (0, $eUqFw.useCallback)(async (newQuery)=>{
        const updateSearchState = (newSearchState)=>{
            setState((prevState)=>{
                if (!$ae4b624271cb328c$var$queriesAreEquivalent(prevState.query, newQuery)) // The query has changed since this search was kicked off, discard the current (stale) results
                return prevState;
                return {
                    query: prevState.query,
                    searchState: newSearchState
                };
            });
        };
        try {
            const objectsPromise = (0, $1AjgI.fetchRapidSearchObjects)({
                workspaceId: workspaceId,
                query: newQuery.trim()
            });
            const objectTypesPromise = (0, $1AjgI.fetchRapidSearchObjectTypes)({
                workspaceId: workspaceId,
                query: newQuery.trim()
            });
            const [objectsResponse, objectTypesResponse] = await Promise.all([
                objectsPromise,
                objectTypesPromise
            ]);
            const searchResult = {
                objects: objectsResponse.values,
                objectTypes: objectTypesResponse.values
            };
            updateSearchState({
                type: 'success',
                searchResult: searchResult
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            updateSearchState({
                type: 'error',
                error: error
            });
        }
    }, [
        workspaceId,
        setState
    ]);
    const debouncedSearch = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(search, $ae4b624271cb328c$var$DEBOUNCE_MILLIS), [
        search
    ]);
    const setQuery = (newQuery)=>{
        if (newQuery.trim().length < (0, $19a37bc8e22978f7$export$16d80a8e6849f8af)) {
            // Skip searching if query is too short
            setState({
                query: newQuery,
                searchState: {
                    type: 'success',
                    searchResult: $ae4b624271cb328c$var$EMPTY_SEARCH_RESULT
                }
            });
            return;
        }
        if ($ae4b624271cb328c$var$queriesAreEquivalent(state.query, newQuery)) {
            setState({
                query: newQuery,
                searchState: state.searchState
            });
            return;
        }
        setState({
            query: newQuery,
            searchState: {
                type: 'loading'
            }
        });
        debouncedSearch(newQuery);
    };
    return {
        query: state.query,
        setQuery: setQuery,
        searchState: state.searchState
    };
};

});
parcelRegister("1AjgI", function(module, exports) {

$parcel$export(module.exports, "fetchRapidSearchObjects", () => $b6af28e90e605a9a$export$3ded75e27074b785);
$parcel$export(module.exports, "fetchRapidSearchObjectTypes", () => $b6af28e90e605a9a$export$b1de10c4478ba28d);

var $lRmyA = parcelRequire("lRmyA");

var $g5GM7 = parcelRequire("g5GM7");
const $b6af28e90e605a9a$export$3ded75e27074b785 = async ({ workspaceId: workspaceId, query: query })=>(0, $lRmyA.performGetRequest)((0, $g5GM7.getCmdbRapidSearchObjectUrl)(workspaceId, {
        searchTerm: query
    }));
const $b6af28e90e605a9a$export$b1de10c4478ba28d = async ({ workspaceId: workspaceId, query: query })=>(0, $lRmyA.performGetRequest)((0, $g5GM7.getCmdbRapidSearchObjectTypeUrl)(workspaceId, {
        searchTerm: query
    }));

});
parcelRegister("g5GM7", function(module, exports) {

$parcel$export(module.exports, "getCmdbRapidSearchObjectUrl", () => $0d654b7ee9fa7633$export$67454f0a1a714bb4);
$parcel$export(module.exports, "getCmdbRapidSearchObjectTypeUrl", () => $0d654b7ee9fa7633$export$624b1a84b14ec612);

var $53ciZ = parcelRequire("53ciZ");

var $cPk3F = parcelRequire("cPk3F");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/rapidsearch
 */ const $0d654b7ee9fa7633$var$getCmdbRapidSearchUrl = (workspaceId)=>`${(0, $cPk3F.getCmdbRestBaseUrl)(workspaceId)}/rapidsearch`;
const $0d654b7ee9fa7633$export$67454f0a1a714bb4 = (workspaceId, queryParams)=>`${$0d654b7ee9fa7633$var$getCmdbRapidSearchUrl(workspaceId)}/object?${(0, $53ciZ.stringify)(queryParams)}`;
const $0d654b7ee9fa7633$export$624b1a84b14ec612 = (workspaceId, queryParams)=>`${$0d654b7ee9fa7633$var$getCmdbRapidSearchUrl(workspaceId)}/objecttype?${(0, $53ciZ.stringify)(queryParams)}`;

});



parcelRegister("lQX4w", function(module, exports) {

$parcel$export(module.exports, "PopupContent", () => $38a30b17c5e5bc42$export$2a2c7ba12d3231e3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $220ac = parcelRequire("220ac");

var $4Bees = parcelRequire("4Bees");

var $a3oUr = parcelRequire("a3oUr");

var $4Es8k = parcelRequire("4Es8k");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $9U2XD = parcelRequire("9U2XD");

var $272oI = parcelRequire("272oI");


var $ajJuu = parcelRequire("ajJuu");

var $9nk1E = parcelRequire("9nk1E");

var $2fT6O = parcelRequire("2fT6O");

var $6dXkO = parcelRequire("6dXkO");
const $38a30b17c5e5bc42$var$NoOptionsMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const renderImage = ()=>(0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $a3oUr.default))({
            imageWidth: 208,
            imageHeight: 190,
            maxImageWidth: 208,
            maxImageHeight: 190
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $6dXkO.default).noResultsFoundMessage),
        renderImage: renderImage,
        testId: "servicedesk-insight-rapid-search-bar.ui.popup-content.empty-state"
    });
};
const $38a30b17c5e5bc42$var$INITIAL_DISPLAYED_OBJECTS = 10;
const $38a30b17c5e5bc42$var$INITIAL_DISPLAYED_OBJECT_TYPES = 5;
const $38a30b17c5e5bc42$export$a6541fefb32bf661 = ({ selectedIndex: selectedIndex, numObjects: numObjects })=>{
    if (selectedIndex === null) return null;
    if (selectedIndex >= numObjects + $38a30b17c5e5bc42$var$INITIAL_DISPLAYED_OBJECT_TYPES) return 'object-types';
    if (selectedIndex >= $38a30b17c5e5bc42$var$INITIAL_DISPLAYED_OBJECTS && selectedIndex < numObjects) return 'objects';
    return null;
};
const $38a30b17c5e5bc42$export$70b3420806bcb550 = ({ searchResult: searchResult, selectedIndex: selectedIndex, restrictedObjectSchemaIds: restrictedObjectSchemaIds, onResultClick: onResultClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { objects: objects, objectTypes: objectTypes } = searchResult;
    const [displayAllObjects, setDisplayAllObjects] = (0, $eUqFw.useState)(objects.length <= $38a30b17c5e5bc42$var$INITIAL_DISPLAYED_OBJECTS);
    const [displayAllObjectTypes, setDisplayAllObjectTypes] = (0, $eUqFw.useState)(objectTypes.length <= $38a30b17c5e5bc42$var$INITIAL_DISPLAYED_OBJECT_TYPES);
    (0, $eUqFw.useEffect)(()=>{
        // Any time the selected index moves, potentially expand the objects or object types
        const listToExpand = $38a30b17c5e5bc42$export$a6541fefb32bf661({
            selectedIndex: selectedIndex,
            numObjects: objects.length
        });
        if (listToExpand === 'objects') setDisplayAllObjects(true);
        else if (listToExpand === 'object-types') setDisplayAllObjectTypes(true);
    }, [
        selectedIndex,
        objects.length,
        setDisplayAllObjects,
        setDisplayAllObjectTypes
    ]);
    const displayedObjects = displayAllObjects ? objects : objects.slice(0, $38a30b17c5e5bc42$var$INITIAL_DISPLAYED_OBJECTS);
    const displayedObjectTypes = displayAllObjectTypes ? objectTypes : objectTypes.slice(0, $38a30b17c5e5bc42$var$INITIAL_DISPLAYED_OBJECT_TYPES);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($38a30b17c5e5bc42$var$DropdownWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nk1E.DropdownContainer), {
        groupTitle: formatMessage((0, $6dXkO.default).objects),
        items: displayedObjects.map((object, index)=>{
            const { id: id, label: label, objectKey: objectKey, objectSchemaName: objectSchemaName, objectSchemaId: objectSchemaId } = object;
            const { url48: url48, mediaClientConfig: mediaClientConfig } = object.avatar;
            return {
                url: (0, $272oI.createObjectDetailUrl)(id),
                id: id,
                label: label,
                objectKey: objectKey,
                iconUrl: url48,
                mediaClientConfig: mediaClientConfig,
                schemaName: objectSchemaName,
                isSelected: selectedIndex === index,
                onClick: ()=>{
                    onResultClick();
                    (0, $ajJuu.fireObjectClickedUiEvent)({
                        analyticsEvent: createAnalyticsEvent({}),
                        objectId: id,
                        schemaId: objectSchemaId,
                        restrictedObjectSchemaIds: restrictedObjectSchemaIds
                    });
                }
            };
        }),
        emptyMessage: formatMessage((0, $6dXkO.default).noneFound),
        canShowMore: !displayAllObjects,
        onShowMore: ()=>{
            setDisplayAllObjects(true);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'insightRapidSearchResultViewMore', {
                searchResultType: 'object'
            });
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nk1E.DropdownContainer), {
        groupTitle: formatMessage((0, $6dXkO.default).objectTypes),
        items: displayedObjectTypes.map((objectType, index)=>{
            const { id: id, name: name, icon: icon, objectSchemaId: objectSchemaId, objectSchemaName: objectSchemaName } = objectType;
            return {
                url: (0, $272oI.createObjectTypeUrl)(objectSchemaId, id),
                id: id,
                label: name,
                iconUrl: icon.url48,
                schemaName: objectSchemaName,
                isSelected: selectedIndex === objects.length + index,
                onClick: ()=>{
                    onResultClick();
                    (0, $ajJuu.fireObjectTypeClickedUiEvent)({
                        analyticsEvent: createAnalyticsEvent({}),
                        objectTypeId: objectType.id,
                        schemaId: objectSchemaId,
                        restrictedObjectSchemaIds: restrictedObjectSchemaIds
                    });
                }
            };
        }),
        emptyMessage: formatMessage((0, $6dXkO.default).noneFound),
        canShowMore: !displayAllObjectTypes,
        onShowMore: ()=>{
            setDisplayAllObjectTypes(true);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'insightRapidSearchResultViewMore', {
                searchResultType: 'objectType'
            });
        }
    }));
};
const $38a30b17c5e5bc42$export$2a2c7ba12d3231e3 = ({ query: query, searchState: searchState, selectedIndex: selectedIndex, restrictedObjectSchemaIds: restrictedObjectSchemaIds, onResultClick: onResultClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (searchState.type === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($38a30b17c5e5bc42$var$StyledSpinner, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large"
    }));
    if (searchState.type === 'error') {
        (0, $9U2XD.rapidSearchExperience).failure();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2fT6O.ErrorContent), null);
    }
    if (query.trim().length < (0, $19a37bc8e22978f7$export$16d80a8e6849f8af)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($38a30b17c5e5bc42$var$QueryTooShortMessage, null, formatMessage((0, $6dXkO.default).typeMoreToSeeResults));
    (0, $9U2XD.rapidSearchExperience).success();
    const { searchResult: searchResult } = searchState;
    if (searchResult.objects.length === 0 && searchResult.objectTypes.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($38a30b17c5e5bc42$var$NoOptionsMessage, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($38a30b17c5e5bc42$export$70b3420806bcb550, {
        searchResult: searchState.searchResult,
        selectedIndex: selectedIndex,
        restrictedObjectSchemaIds: restrictedObjectSchemaIds,
        onResultClick: onResultClick
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $38a30b17c5e5bc42$var$DropdownWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1yt4u2gc _zulpu2gc _c71lufrr _18m91wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $38a30b17c5e5bc42$var$StyledSpinner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qpxbi _1e0c1txw _1bah1h6o _1tke1mjv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $38a30b17c5e5bc42$var$QueryTooShortMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt450w7 _y3gn1h6o _syaz1n3s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("a3oUr", function(module, exports) {

$parcel$export(module.exports, "default", () => $24146ecac69a5373$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $1hpSl = parcelRequire("1hpSl");

var $h5Il3 = parcelRequire("h5Il3");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $24146ecac69a5373$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($h5Il3)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($1hpSl))
});
var $24146ecac69a5373$export$2e2bcd8739ae039 = $24146ecac69a5373$var$Illustration;
// for advanced use only
const $24146ecac69a5373$export$a179c88182cb9d56 = [
    0,
    0,
    205,
    199
];

});
parcelRegister("1hpSl", function(module, exports) {
module.exports = new URL("empty-no-search-results-v2-darkmode.fad57704.svg", import.meta.url).toString();

});

parcelRegister("h5Il3", function(module, exports) {
module.exports = new URL("empty-no-search-results-v2.a81f25f1.svg", import.meta.url).toString();

});


parcelRegister("9nk1E", function(module, exports) {

$parcel$export(module.exports, "DropdownContainer", () => $728990107231e579$export$49166591ec160d97);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fEX93 = parcelRequire("fEX93");

var $mMK7f = parcelRequire("mMK7f");
const $728990107231e579$export$49166591ec160d97 = ({ groupTitle: groupTitle, items: items, emptyMessage: emptyMessage, canShowMore: canShowMore, onShowMore: onShowMore })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($728990107231e579$var$Title, null, groupTitle), items.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $728990107231e579$var$emptyMessageStyles
    }, emptyMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($728990107231e579$var$OptionsList, null, items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEX93.InsightRapidSearchDropdownOption), {
            key: item.id,
            ...item
        }))), canShowMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $728990107231e579$var$listFooterStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        spacing: "none",
        onClick: onShowMore,
        tabIndex: "-1",
        testId: "servicedesk-insight-rapid-search-bar.ui.popup-content.dropdown-container.show-more-button"
    }, formatMessage((0, $mMK7f.messages).showMore))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $728990107231e579$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1thw _1wyb1crf _1p1dangw _1yt4u2gc _k48pni7l",
            __cmplp.className
        ])
    });
});
const $728990107231e579$var$emptyMessageStyles = (0, $1ZAYh.xcss)({
    padding: 'space.100'
});
const $728990107231e579$var$listFooterStyles = (0, $1ZAYh.xcss)({
    padding: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $728990107231e579$var$OptionsList = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2mzuglyw _1pyaidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fEX93", function(module, exports) {

$parcel$export(module.exports, "InsightRapidSearchDropdownOption", () => $140d0b8db7484244$export$1d307d1846f567a6);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $2ziLQ = parcelRequire("2ziLQ");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


var $dnJL9 = parcelRequire("dnJL9");

var $lB25E = parcelRequire("lB25E");

var $6IHgl = parcelRequire("6IHgl");

var $hoasw = parcelRequire("hoasw");
const $140d0b8db7484244$export$1d307d1846f567a6 = ({ url: url, mediaClientConfig: mediaClientConfig, label: label, iconUrl: iconUrl, schemaName: schemaName, isSelected: isSelected, onClick: onClick, objectKey: objectKey })=>{
    const selectedElementReference = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (isSelected && selectedElementReference.current) selectedElementReference.current.scrollIntoView?.({
            block: 'center'
        });
    }, [
        isSelected
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
        ref: selectedElementReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($140d0b8db7484244$var$Row, {
        isSelected: isSelected,
        to: url,
        onClick: onClick,
        tabIndex: "-1",
        "data-testid": "servicedesk-insight-rapid-search-bar.ui.popup-content.dropdown-container.dropdown-option.dropdown-option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($140d0b8db7484244$var$ObjectContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hoasw.MemoizedInsightIcon), {
        mediaClientConfig: mediaClientConfig,
        iconUrl: iconUrl,
        label: label,
        size: "small"
    }), objectKey !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($140d0b8db7484244$var$ObjectKey, null, objectKey), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($140d0b8db7484244$var$Text, null, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($140d0b8db7484244$var$SchemaContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: (0, $6IHgl.SchemaGlyph),
        label: schemaName,
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($140d0b8db7484244$var$Text, null, schemaName))));
};
const $140d0b8db7484244$var$Text = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $140d0b8db7484244$var$textStyles
    }, children);
const $140d0b8db7484244$var$ObjectContainer = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $140d0b8db7484244$var$objectContainerStyles
    }, children);
const $140d0b8db7484244$var$ObjectKey = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $140d0b8db7484244$var$objectKeyStyles
    }, children);
const $140d0b8db7484244$var$SchemaContainer = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $140d0b8db7484244$var$schemaContainerStyles
    }, children);
const $140d0b8db7484244$var$schemaContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100',
    color: 'color.text.subtlest',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '12px',
    padding: 'space.100'
});
// @ts-expect-error - TS2345: Argument of type 'ForwardRefExoticComponent'
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $140d0b8db7484244$var$RowOld = /*#__PURE__*/ (0, $kwce8.default)((0, $lB25E.Link)).withConfig({
    componentId: "sc-1kjukd7-0"
})((props)=>({
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$exports).N800})`,
        padding: "var(--ds-space-100, 8px)",
        maxWidth: '100%',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$exports).N800})`,
            textDecoration: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor: `var(--ds-surface-raised, ${(0, $73a5c9d720aa66e1$exports).N30})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: props.isSelected ? `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$exports).N30})` : undefined
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $140d0b8db7484244$var$RowNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lB25E.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _80omtlke _syaz1fxt _1yt4u2gc _p12f1osq _30l31fxt _9oik18uv _1bnxglyw _jf4cnqa1 _irr3q29e",
            __cmplp.isSelected && "_bfhkbal5",
            __cmplp.className
        ])
    });
});
const $140d0b8db7484244$var$Row = (0, $dnJL9.componentWithFG)('fly-2204_jsmfa_styled_components', $140d0b8db7484244$var$RowNew, $140d0b8db7484244$var$RowOld);
const $140d0b8db7484244$export$7ed12d2a5241e393 = {
    ObjectKey: $140d0b8db7484244$var$ObjectKey
};
const $140d0b8db7484244$var$textStyles = (0, $1ZAYh.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $140d0b8db7484244$var$objectContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    gap: 'space.100',
    overflow: 'auto'
});
const $140d0b8db7484244$var$objectKeyStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    ...$140d0b8db7484244$var$textStyles,
    paddingRight: 'space.100',
    flexShrink: 0
});

});
parcelRegister("6IHgl", function(module, exports) {

$parcel$export(module.exports, "ObjectSchemasGlyph", () => $fa45b003c8150343$export$58cebcda192184d0);
$parcel$export(module.exports, "ObjectGraphGlyph", () => $fa45b003c8150343$export$fd4e4ffca6161634);
$parcel$export(module.exports, "ObjectGraphIcon", () => $fa45b003c8150343$export$7fd55e0f2e77172c);
$parcel$export(module.exports, "ShowObjectGraphDetailsIcon", () => $fa45b003c8150343$export$a96f5718ff672e9d);
$parcel$export(module.exports, "HideObjectGraphDetailsIcon", () => $fa45b003c8150343$export$cf601da3438765d9);
$parcel$export(module.exports, "SchemaGlyph", () => $fa45b003c8150343$export$e0e271b4f47de362);
$parcel$export(module.exports, "SchemaIcon", () => $fa45b003c8150343$export$fc6a25a0b4021903);
$parcel$export(module.exports, "ColumnsIcon", () => $fa45b003c8150343$export$38f001d9cffdd080);
$parcel$export(module.exports, "QrCodeIcon", () => $fa45b003c8150343$export$33dd147542b2195b);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $677R6 = parcelRequire("677R6");

var $80MAI = parcelRequire("80MAI");

var $2tsKo = parcelRequire("2tsKo");

var $38yMR = parcelRequire("38yMR");

var $agBXA = parcelRequire("agBXA");

var $1LvzE = parcelRequire("1LvzE");

var $9rSYg = parcelRequire("9rSYg");
const $fa45b003c8150343$export$58cebcda192184d0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 8C14.8954 8 14 8.89543 14 10V12C14 13.1046 14.8954 14 16 14H18C19.1046 14 20 13.1046 20 12V10C20 8.89543 19.1046 8 18 8H16ZM18 10H16V12H18V10Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 16C14.8954 16 14 16.8954 14 18V20C14 21.1046 14.8954 22 16 22H18C19.1046 22 20 21.1046 20 20V18C20 16.8954 19.1046 16 18 16H16ZM18 18H16V20H18V18Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 2C4.89543 2 4 2.89543 4 4V6C4 7.10457 4.89543 8 6 8H8C9.10457 8 10 7.10457 10 6V4C10 2.89543 9.10457 2 8 2H6ZM8 4H6V6H8V4Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "6",
        y: "7",
        width: "2",
        height: "11",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6 18H15V20H8C6.89543 20 6 19.1046 6 18Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6 10H15V12H8C6.89543 12 6 11.1046 6 10Z",
        fill: "currentColor"
    }));
const $fa45b003c8150343$export$fd4e4ffca6161634 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "4",
        cy: "4",
        r: "2",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "6",
        cy: "18",
        r: "2",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "20",
        cy: "6",
        r: "2",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "18",
        cy: "19",
        r: "2",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 15a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 100-4 2 2 0 000 4z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4 4l6 5.5m9.5-3l-5 3m-8 8l4-4.5m8 6.5l-5-6",
        stroke: "currentColor",
        strokeWidth: "1.5"
    }));
const $fa45b003c8150343$export$7fd55e0f2e77172c = (0, $677R6.createCustomAKIcon)($fa45b003c8150343$export$fd4e4ffca6161634);
const $fa45b003c8150343$export$663e20392543b207 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M20 2H2V4H9V9H11V4H20V20H11V15H9V20H2V22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M2.47 12.8835C2.19 12.7165 2 12.3835 2 11.9995C2 11.6155 2.19 11.2825 2.47 11.1155L5.086 8.49946C5.2746 8.3173 5.5272 8.21651 5.7894 8.21879C6.0516 8.22107 6.30241 8.32623 6.48782 8.51164C6.67323 8.69705 6.7784 8.94786 6.78067 9.21006C6.78295 9.47226 6.68216 9.72486 6.5 9.91346L4.938 10.9995H10.118C10.605 10.9995 11 11.4475 11 11.9995C11 12.5515 10.605 12.9995 10.118 12.9995H4.938L6.5 14.0855C6.68216 14.2741 6.78295 14.5267 6.78067 14.7889C6.7784 15.0511 6.67323 15.3019 6.48782 15.4873C6.30241 15.6727 6.0516 15.7779 5.7894 15.7801C5.5272 15.7824 5.2746 15.6816 5.086 15.4995L2.47 12.8835Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13 7C13 6.44772 13.4477 6 14 6H17C17.5523 6 18 6.44772 18 7C18 7.55228 17.5523 8 17 8H14C13.4477 8 13 7.55228 13 7Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13 11C13 10.4477 13.4477 10 14 10H17C17.5523 10 18 10.4477 18 11C18 11.5523 17.5523 12 17 12H14C13.4477 12 13 11.5523 13 11Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13 15C13 14.4477 13.4477 14 14 14H17C17.5523 14 18 14.4477 18 15C18 15.5523 17.5523 16 17 16H14C13.4477 16 13 15.5523 13 15Z",
        fill: "currentColor"
    }));
const $fa45b003c8150343$export$e525f0ae0465b224 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19 2H2V4H14V9H16V4H19V20H16V15H14V20H2V22H19C20.1046 22 21 21.1046 21 20V4C21 2.89543 20.1046 2 19 2Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.53 12.8835C12.81 12.7165 13 12.3835 13 11.9995C13 11.6155 12.81 11.2825 12.53 11.1155L9.914 8.49946C9.7254 8.3173 9.4728 8.21651 9.2106 8.21879C8.9484 8.22107 8.69759 8.32623 8.51218 8.51164C8.32677 8.69705 8.2216 8.94786 8.21933 9.21006C8.21705 9.47226 8.31784 9.72486 8.5 9.91346L10.062 10.9995H2.882C2.395 10.9995 2 11.4475 2 11.9995C2 12.5515 2.395 12.9995 2.882 12.9995H10.062L8.5 14.0855C8.31784 14.2741 8.21705 14.5267 8.21933 14.7889C8.2216 15.0511 8.32677 15.3019 8.51218 15.4873C8.69759 15.6727 8.9484 15.7779 9.2106 15.7801C9.4728 15.7824 9.7254 15.6816 9.914 15.4995L12.53 12.8835Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 9H16V15H14V9Z",
        fill: "currentColor"
    }));
const $fa45b003c8150343$export$a96f5718ff672e9d = (0, $677R6.createCustomAKIcon)($fa45b003c8150343$export$663e20392543b207);
const $fa45b003c8150343$export$cf601da3438765d9 = (0, $677R6.createCustomAKIcon)($fa45b003c8150343$export$e525f0ae0465b224);
const $fa45b003c8150343$var$ServicesGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 20 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 4C18 5.10457 17.1046 6 16 6C14.8954 6 14 5.10457 14 4C14 2.89543 14.8954 2 16 2C17.1046 2 18 2.89543 18 4ZM18 16C18 17.1046 17.1046 18 16 18C14.8954 18 14 17.1046 14 16C14 14.8954 14.8954 14 16 14C17.1046 14 18 14.8954 18 16ZM16 8C18.2091 8 20 6.20914 20 4C20 1.79086 18.2091 0 16 0C13.7909 0 12 1.79086 12 4C12 6.20914 13.7909 8 16 8ZM16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20ZM9.1377 3C8.803 3 8.4904 3.16747 8.3051 3.44617L7.28468 4.98023C6.97881 5.44008 7.10363 6.06082 7.56348 6.36669C8.0233 6.67256 8.6441 6.54774 8.9499 6.08789L9.6736 5H10.5688C11.1211 5 11.5688 4.55228 11.5688 4C11.5688 3.44772 11.1211 3 10.5688 3H9.1377ZM6.90917 9.156C7.21504 8.6962 7.09022 8.0754 6.63037 7.76954C6.17052 7.46367 5.54978 7.5885 5.24391 8.0483L4.49738 9.1707C4.19106 9.377 4.03512 9.7238 4.0583 10.0681C4.03512 10.4124 4.19106 10.7592 4.49738 10.9656L5.24391 12.0879C5.54978 12.5477 6.17052 12.6726 6.63037 12.3667C7.09022 12.0608 7.21504 11.4401 6.90917 10.9802L6.30247 10.0681L6.90917 9.156ZM1 9C0.44772 9 0 9.4477 0 10C0 10.0229 0.000769997 10.0456 0.00228 10.0681C0.000769997 10.0906 0 10.1133 0 10.1362C0 10.6885 0.44772 11.1362 1 11.1362H3.02808C3.58036 11.1362 4.02808 10.6885 4.02808 10.1362C4.02808 10.1133 4.02731 10.0906 4.02579 10.0681C4.02731 10.0456 4.02808 10.0229 4.02808 10C4.02808 9.4477 3.58036 9 3.02808 9H1ZM8.9499 14.0483C8.6441 13.5885 8.0233 13.4637 7.56348 13.7695C7.10363 14.0754 6.97881 14.6962 7.28468 15.156L8.3051 16.6901C8.4904 16.9688 8.803 17.1362 9.1377 17.1362H10.5688C11.1211 17.1362 11.5688 16.6885 11.5688 16.1362C11.5688 15.5839 11.1211 15.1362 10.5688 15.1362H9.6736L8.9499 14.0483Z",
        fill: "#42526E"
    }));
const $fa45b003c8150343$export$63875af9e9342035 = (0, $677R6.createCustomAKIcon)($fa45b003c8150343$var$ServicesGlyph);
const $fa45b003c8150343$export$43fa118b7efcebfc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M3 12a9 9 0 1118 0 9 9 0 01-18 0zm2 0a7 7 0 1014 0 7 7 0 00-14 0zm3.213.617l.08.09a1.009 1.009 0 01-.289-.617A1.026 1.026 0 018 12v-.02c0-.023.002-.047.004-.07L8 12a1.007 1.007 0 01.26-.672l.033-.035 3-3a1 1 0 011.497 1.32l-.083.094L11.415 11H15a1 1 0 01.126 1.992L15 13h-3.587l1.294 1.293a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.32.083l-.094-.083-3.003-3.003a.995.995 0 01-.077-.087z",
        fill: "currentColor"
    }));
const $fa45b003c8150343$export$e97a49df0b050d1e = (0, $677R6.createCustomAKIcon)($fa45b003c8150343$export$43fa118b7efcebfc);
const $fa45b003c8150343$export$74d77379c5f1391 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "7",
        y: "4",
        width: "15",
        height: "10",
        rx: "2",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 10H5V12H4V18H15V16H17V18C17 19.1046 16.1046 20 15 20H4C2.89543 20 2 19.1046 2 18V12C2 10.8954 2.89543 10 4 10Z",
        fill: "#42526E"
    }));
const $fa45b003c8150343$export$7c3eb9c5ff5195cf = (0, $677R6.createCustomAKIcon)($fa45b003c8150343$export$74d77379c5f1391);
const $fa45b003c8150343$export$e0e271b4f47de362 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "47",
        height: "47",
        rx: "4.5",
        fill: "white",
        stroke: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.6665 18.6667C27.5619 18.6667 26.6665 19.5621 26.6665 20.6667V24.6667C26.6665 25.7713 27.5619 26.6667 28.6665 26.6667H32.6665C33.7711 26.6667 34.6665 25.7713 34.6665 24.6667V20.6667C34.6665 19.5621 33.7711 18.6667 32.6665 18.6667H28.6665ZM31.9998 21.3334H29.3331V24.0001H31.9998V21.3334Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.6665 29.3333C27.5619 29.3333 26.6665 30.2287 26.6665 31.3333V35.3333C26.6665 36.4379 27.5619 37.3333 28.6665 37.3333H32.6665C33.7711 37.3333 34.6665 36.4379 34.6665 35.3333V31.3333C34.6665 30.2287 33.7711 29.3333 32.6665 29.3333H28.6665ZM31.9998 31.9999H29.3331V34.6666H31.9998V31.9999Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.3335 10.6667C14.2289 10.6667 13.3335 11.5621 13.3335 12.6667V16.6667C13.3335 17.7713 14.2289 18.6667 15.3335 18.6667H19.3335C20.4381 18.6667 21.3335 17.7713 21.3335 16.6667V12.6667C21.3335 11.5621 20.4381 10.6667 19.3335 10.6667H15.3335ZM18.6669 13.3334H16.0002V16.0001H18.6669V13.3334Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "16",
        y: "17.3333",
        width: "2.66667",
        height: "14.6667",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16 32H28V34.6667H18C16.8954 34.6667 16 33.7712 16 32.6667V32Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16 21.3333H28V24H18C16.8954 24 16 23.1046 16 22V21.3333Z",
        fill: "#42526E"
    }));
const $fa45b003c8150343$export$fc6a25a0b4021903 = (0, $677R6.createCustomAKIcon)($fa45b003c8150343$export$e0e271b4f47de362);
const $fa45b003c8150343$export$da6ce04815aafa86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 6H2V8V20V22H4H7H9V20V19H7V20H4V8H5V6H4Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 8H17V20H20V8ZM15 6V22H22V6H15Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 4H9V15H12V4ZM7 2V17H14V2H7Z",
        fill: "currentColor"
    }));
const $fa45b003c8150343$export$38f001d9cffdd080 = (0, $677R6.createCustomAKIcon)($fa45b003c8150343$export$da6ce04815aafa86);
const $fa45b003c8150343$var$QrCodeGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 4V7H4V4H7V2H4H2V4ZM4 17H2V20V22H4H7V20H4V17ZM22 4V7H20V4H17V2H20H22V4ZM22 17H20V20H17V22H20H22V20V17ZM19 9H13V11H19V9ZM8 13H11V15H8V13ZM11 17H8V19H11V17ZM13 5H15V8H13V5ZM7 13H5V19H7V13ZM17 5H19V8H17V5ZM11 5H5V11H11V5ZM9 7H7V9H9V7ZM13 13H19V19H13V13ZM15 15H17V17H15V15Z",
        fill: "currentColor"
    }));
const $fa45b003c8150343$export$33dd147542b2195b = (0, $677R6.createCustomAKIcon)($fa45b003c8150343$var$QrCodeGlyph);

});
parcelRegister("677R6", function(module, exports) {

$parcel$export(module.exports, "createCustomAKIcon", () => $4cc8d49f3fc0c24b$export$80e74912a0a07a42);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $4cc8d49f3fc0c24b$export$80e74912a0a07a42 = (glyph)=>(props)=>// @ts-expect-error - TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, $eUqFw.createElement)((0, $2ziLQ.default), {
            glyph: glyph,
            ...props
        });

});

parcelRegister("80MAI", function(module, exports) {
module.exports = new URL("generic-empty-state.f12fdcef.svg", import.meta.url).toString();

});

parcelRegister("2tsKo", function(module, exports) {
module.exports = new URL("csv-icon.a0071194.svg", import.meta.url).toString();

});

parcelRegister("38yMR", function(module, exports) {
module.exports = new URL("discovery-icon.d596fa4f.svg", import.meta.url).toString();

});

parcelRegister("agBXA", function(module, exports) {
module.exports = new URL("json-icon.2bb3a37b.svg", import.meta.url).toString();

});

parcelRegister("1LvzE", function(module, exports) {
module.exports = new URL("external-icon.ef0f44a0.svg", import.meta.url).toString();

});

parcelRegister("9rSYg", function(module, exports) {
module.exports = new URL("type-error.f8bb5761.svg", import.meta.url).toString();

});



parcelRegister("mMK7f", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1ae07cdc30b0e126$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1ae07cdc30b0e126$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    showMore: {
        "id": "servicedesk-insight-rapid-search-bar.popup-content.dropdown-container.show-more",
        "defaultMessage": "Show more"
    }
});

});


parcelRegister("2fT6O", function(module, exports) {

$parcel$export(module.exports, "ErrorContent", () => $4d8467d591d9348b$export$a9f602ed820d9782);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $2BP1Y = parcelRequire("2BP1Y");

var $4Es8k = parcelRequire("4Es8k");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2A5eD = parcelRequire("2A5eD");
const $4d8467d591d9348b$export$a9f602ed820d9782 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const renderImage = ()=>(0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $2BP1Y.default))({
            imageWidth: 164,
            maxImageWidth: 164,
            maxImageHeight: 212
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        size: "wide",
        renderImage: renderImage,
        header: formatMessage((0, $2A5eD.messages).errorTitle),
        description: formatMessage((0, $2A5eD.messages).errorDescription)
    });
};

});
parcelRegister("2A5eD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2a464ceebc4f40bd$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $2a464ceebc4f40bd$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "servicedesk-insight-rapid-search-bar.popup-content.error.error-title",
        "defaultMessage": "We can\u2019t show your results right now"
    },
    errorDescription: {
        "id": "servicedesk-insight-rapid-search-bar.popup-content.error.error-description",
        "defaultMessage": "Give it a minute and try again."
    }
});

});


parcelRegister("6dXkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b8b62f8ef363742$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2b8b62f8ef363742$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noResultsFoundMessage: {
        "id": "servicedesk-insight-rapid-search-bar.popup-content.no-results-found-message",
        "defaultMessage": "We couldn't find any results matching your search"
    },
    objects: {
        "id": "servicedesk-insight-rapid-search-bar.popup-content.objects",
        "defaultMessage": "Objects"
    },
    objectTypes: {
        "id": "servicedesk-insight-rapid-search-bar.popup-content.object-types",
        "defaultMessage": "Object types"
    },
    noneFound: {
        "id": "servicedesk-insight-rapid-search-bar.popup-content.none-found",
        "defaultMessage": "None found"
    },
    typeMoreToSeeResults: {
        "id": "servicedesk-insight-rapid-search-bar.popup-content.type-more-to-see-results",
        "defaultMessage": "Keep typing to see search results"
    }
});

});


parcelRegister("3aZFW", function(module, exports) {

$parcel$export(module.exports, "TextfieldTrigger", () => $48892b21af80a0ec$export$ea52c713ac76896c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $dsroq = parcelRequire("dsroq");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3VOyM = parcelRequire("3VOyM");
const $48892b21af80a0ec$export$ea52c713ac76896c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isOpen: isOpen, setPopupWidth: setPopupWidth, onChange: onChange, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, value: value, renderSearchTextfield: renderSearchTextfield, ...triggerProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const containerRef = (0, $eUqFw.useRef)(null); // @ts-expect-error - Type 'null' is not assignable to type 'HTMLElement'
    (0, $eUqFw.useImperativeHandle)(ref, ()=>containerRef.current);
    (0, $eUqFw.useEffect)(()=>{
        if (containerRef && containerRef.current) setPopupWidth(containerRef.current.clientWidth);
    }, [
        containerRef?.current?.clientWidth,
        setPopupWidth
    ]);
    const searchTextfieldProps = {
        value: value,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($48892b21af80a0ec$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
            label: formatMessage((0, $3VOyM.default).searchIconLabel)
        })),
        onChange: onChange,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        maxLength: 256
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: containerRef,
        ...triggerProps
    }, renderSearchTextfield({
        isOpen: isOpen,
        searchTextfieldProps: searchTextfieldProps
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $48892b21af80a0ec$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _19bvu2gc _syazqjbk",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3VOyM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1367c190eb856fd9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1367c190eb856fd9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    searchIconLabel: {
        "id": "servicedesk-insight-rapid-search-bar.trigger.search-icon-label",
        "defaultMessage": "Search icon label"
    }
});

});



parcelRegister("2AirB", function(module, exports) {

$parcel$export(module.exports, "SchemaContainer", () => $71bc899228e14644$export$423976b269b7be7d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $bkIGg = parcelRequire("bkIGg");

var $jgrQL = parcelRequire("jgrQL");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $ifE1L = parcelRequire("ifE1L");

var $1CIRW = parcelRequire("1CIRW");

var $hqVAg = parcelRequire("hqVAg");

var $eop8M = parcelRequire("eop8M");

var $5zCQy = parcelRequire("5zCQy");

var $ixjcP = parcelRequire("ixjcP");

var $4nnPJ = parcelRequire("4nnPJ");

var $iwvfb = parcelRequire("iwvfb");

var $6TCXr = parcelRequire("6TCXr");
const $71bc899228e14644$export$fdcb1fa0b36cbdef = (props)=>{
    const { schemas: schemas } = props;
    const listItems = schemas.map((schema, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($71bc899228e14644$var$SchemaCardListItem, {
            key: index,
            "data-testid": "servicedesk-insight-schema-container.ui.schema-card-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eop8M.SchemaCard), {
            schema: schema
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($71bc899228e14644$var$SchemaCardList, null, listItems);
};
const $71bc899228e14644$var$InfoTooltip = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: props.content,
        position: "top",
        testId: "servicedesk-insight-schema-container.ui.schema-limit-tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($71bc899228e14644$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jgrQL))), {
        size: "small",
        label: ""
    })));
const $71bc899228e14644$export$423976b269b7be7d = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ schemaState: schemaState }] = (0, $hqVAg.useLandingPageState)();
    const [isCreateModalOpen, setIsCreateModalOpen] = (0, $eUqFw.useState)(false); // Enrich the schema object with the restricted value
    // (to identify the service schema)
    const [{ config: globalConfigData }] = (0, $1CIRW.useInsightGlobalConfig)();
    const { restrictedObjectSchemaIds: restrictedObjectSchemaIds, insightAdministrator: isAdmin, limitInfo: limitInfo } = globalConfigData ?? {};
    const objectSchemaList = (0, $eUqFw.useMemo)(()=>{
        if (schemaState.type !== 'success') return [];
        if (restrictedObjectSchemaIds) return schemaState.schemas.map((schema)=>({
                ...schema,
                isRestricted: restrictedObjectSchemaIds.includes(Number(schema.id))
            }));
        return schemaState.schemas;
    }, [
        schemaState,
        restrictedObjectSchemaIds
    ]);
    const openCreateSchemaModal = ()=>{
        setIsCreateModalOpen(true);
    };
    const closeCreateSchemaModal = ()=>{
        setIsCreateModalOpen(false);
    };
    if (schemaState.type === 'success') (0, $4nnPJ.GlobalPageLoadExperience).success({
        force: true
    });
    else if (schemaState.type === 'error') {
        if ((0, $eI5EY.fg)('assets_fire_experience_failure_only_on_5xx')) {
            if ((0, $5zCQy.isUnexpectedFetchError)(schemaState.error, [
                '5xx'
            ])) (0, $4nnPJ.GlobalPageLoadExperience).failure({
                force: true
            });
        } else (0, $4nnPJ.GlobalPageLoadExperience).failure({
            force: true
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, schemaState.type === 'loading' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ixjcP.InsightSchemaContainerSkeleton), null), (schemaState.type === 'error' || schemaState.type === 'success') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $71bc899228e14644$var$listHeaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $71bc899228e14644$var$secondaryListHeaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $6TCXr.messages).objectSchemas)), isAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($71bc899228e14644$var$ObjectSchemaCounter, null, `(${limitInfo?.objectSchemaCount}/${limitInfo?.objectSchemaLimit})`))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $71bc899228e14644$var$secondaryListHeaderStyles
    }, isAdmin && (limitInfo?.objectSchemaCount && limitInfo?.objectLimit && limitInfo?.objectSchemaCount >= limitInfo?.objectSchemaLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $71bc899228e14644$var$schemaLimitLabelStyles
    }, formatMessage((0, $6TCXr.messages).schemaLimitReached), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($71bc899228e14644$var$InfoTooltip, {
        content: formatMessage((0, $6TCXr.messages).schemaLimitErrorMessage, {
            limit: limitInfo.objectSchemaLimit
        })
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "default",
        spacing: "compact",
        onClick: (_event, analyticsEvent)=>{
            openCreateSchemaModal();
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'openCreateSchemaDrawer');
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
            label: "",
            size: "medium"
        }),
        testId: "servicedesk-insight-schema-container.ui.create-icon-button",
        interactionName: "servicedesk-insight-schema-container.ui.create"
    }, formatMessage((0, $6TCXr.messages).createSchema)))))), schemaState.type === 'error' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iwvfb.ErrorContent), null), schemaState.type === 'success' && schemaState.schemas.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($71bc899228e14644$export$fdcb1fa0b36cbdef, {
        schemas: objectSchemaList
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ifE1L.AsyncCmdbGettingStarted), {
        isOpen: isCreateModalOpen,
        onClose: closeCreateSchemaModal
    }));
};
const $71bc899228e14644$var$listHeaderStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 'space.300',
    width: '100%',
    marginTop: 'space.200'
});
const $71bc899228e14644$var$secondaryListHeaderStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $71bc899228e14644$var$SchemaCardList = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4ze3t _2mzuglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $71bc899228e14644$var$SchemaCardListItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyru2gc",
            __cmplp.className
        ])
    });
});
const $71bc899228e14644$var$schemaLimitLabelStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    height: '24px',
    alignItems: 'center'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $71bc899228e14644$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt4otz2",
            __cmplp.isDisabled ? "_80om13gf" : "_80om1kw7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $71bc899228e14644$var$ObjectSchemaCounter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81vlj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jgrQL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0651d627acb5549$var$_react = $e0651d627acb5549$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $e0651d627acb5549$var$_information = $e0651d627acb5549$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $e0651d627acb5549$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e0651d627acb5549$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $e0651d627acb5549$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
    }, props, {
        newIcon: $e0651d627acb5549$var$_information.default
    }));
$e0651d627acb5549$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $e0651d627acb5549$var$_default = module.exports.default = $e0651d627acb5549$var$EditorInfoIcon;

});
parcelRegister("h6FFs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cfc592cc61140d99cb4eaed527408acf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c743518dce4b322a$var$_react = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c743518dce4b322a$var$_UNSAFE_baseNew = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c743518dce4b322a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c743518dce4b322a$var$InformationIcon = (props)=>/*#__PURE__*/ $c743518dce4b322a$var$_react.default.createElement($c743518dce4b322a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$c743518dce4b322a$var$InformationIcon.displayName = 'InformationIcon';
var $c743518dce4b322a$var$_default = module.exports.default = $c743518dce4b322a$var$InformationIcon;

});


parcelRegister("ifE1L", function(module, exports) {

$parcel$export(module.exports, "AsyncCmdbGettingStarted", () => $6e8f356f1c38eec8$export$af4e30f085039e49);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6e8f356f1c38eec8$var$LazyCmdbGettingStarted = (0, $7rh0R.lazy)(()=>(parcelRequire("bGNnb")).then((module)=>module.CmdbGettingStarted), {
    moduleId: "./src/packages/servicedesk/cmdb-getting-started/src/ui/index.tsx"
});
const $6e8f356f1c38eec8$export$af4e30f085039e49 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "cmdb-getting-started",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e8f356f1c38eec8$var$LazyCmdbGettingStarted, props));

});
parcelRegister("bGNnb", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("fP5EI")
]).then(()=>parcelRequire('3nbFI'));

});


parcelRegister("eop8M", function(module, exports) {

$parcel$export(module.exports, "SchemaCard", () => $4f9e7156ed538518$export$eebd315af76f7497);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $f4A0J = parcelRequire("f4A0J");

var $jG1wZ = parcelRequire("jG1wZ");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lB25E = parcelRequire("lB25E");

var $6IHgl = parcelRequire("6IHgl");

var $hD6GJ = parcelRequire("hD6GJ");

var $gg3OU = parcelRequire("gg3OU");

var $8apha = parcelRequire("8apha");

var $272oI = parcelRequire("272oI");

var $cdP9F = parcelRequire("cdP9F");

var $dTkXT = parcelRequire("dTkXT");
const $4f9e7156ed538518$var$IconAndMenu = ({ schema: schema })=>{
    const { push: push } = (0, $lB25E.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    if (schema.isRestricted === true) {
        const content = formatMessage((0, $dTkXT.messages).tooltipRestrictedSchema);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdP9F.FocusableTooltip), {
            content: content,
            position: "top",
            testId: "servicedesk-insight-schema-card.ui.restricted-tooltip"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f9e7156ed538518$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f4A0J))), {
            size: "medium",
            label: content
        })));
    }
    if (schema.canManage === false) {
        const content = formatMessage((0, $dTkXT.messages).tooltipDisabled);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdP9F.FocusableTooltip), {
            content: content,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f9e7156ed538518$var$IconWrapper, {
            isDisabled: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
            size: "medium",
            label: content
        })));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gg3OU.MeatballsMenu), {
        testId: `servicedesk-insight-schema-card.ui.meatballs-menu-${schema.id}`,
        moreIconLabel: `${schema.name} ${formatMessage((0, $dTkXT.messages).more)}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        href: (0, $272oI.createObjectSchemaConfigUrl)(schema.id),
        onClick: (event)=>{
            push((0, $272oI.createObjectSchemaConfigUrl)(schema.id));
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'configureInsightSchema');
            event.preventDefault();
        }
    }, formatMessage((0, $dTkXT.messages).configuration)));
};
const $4f9e7156ed538518$var$SchemaTooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f9e7156ed538518$var$StyledTooltipTag, {
        ref: ref,
        ...props
    }));
const $4f9e7156ed538518$export$eebd315af76f7497 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { schema: schema } = props;
    const { id: id } = schema;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f9e7156ed538518$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f9e7156ed538518$var$StyledLink, {
        "data-testId": "servicedesk-insight-landing-insight-schema-card.styled-link",
        href: (0, $272oI.createObjectSchemaUrl)(id),
        onClick: (event)=>{
            push((0, $272oI.createObjectSchemaUrl)(id));
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'card clicked', 'insightObjectSchemaCard', // the service schema will always have isRestricted = true (and isRestricted is always false for Insight schemas)
            (0, $8apha.getCmdbAnalyticAttributesFromSchema)(schema));
            event.preventDefault();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: (0, $6IHgl.SchemaGlyph),
        label: "",
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f9e7156ed538518$var$CardText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f9e7156ed538518$var$NameAndKey, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: schema.name,
        tag: $4f9e7156ed538518$var$SchemaTooltipTag,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f9e7156ed538518$var$SchemaName, null, schema.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "(", schema.objectSchemaKey, ")")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f9e7156ed538518$var$ObjectCount, null, formatMessage((0, $dTkXT.messages).objects, {
        objectNumber: schema.objectCount
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f9e7156ed538518$var$IconAndMenu, {
        schema: schema
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f9e7156ed538518$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16qs1bpa _1e0c1txw _4cvr1h6o _zulpu2gc _4t3izwfg _2rko1l7b _bfhkhp5a _1yt418iy _19lc1dko",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f9e7156ed538518$var$CardText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9idpf _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _zulp1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f9e7156ed538518$var$ObjectCount = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f9e7156ed538518$var$NameAndKey = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9idpf _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _zulpu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f9e7156ed538518$var$StyledTooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f9e7156ed538518$var$SchemaName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pni7l _1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f9e7156ed538518$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _1yt4otz2",
            __cmplp.isDisabled ? "_syaz1cf5" : "_syaz1kw7",
            __cmplp.isDisabled ? "_80om13gf" : "_80om1kw7",
            __cmplp.className
        ])
    });
});
const $4f9e7156ed538518$var$StyledLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9idpf _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _80omtlke _zulpu2gc _syaz1thw _30l31thw _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
$4f9e7156ed538518$var$StyledLink.displayName = 'StyledLink';

});
parcelRegister("f4A0J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02d4f449435745cf$var$_react = $02d4f449435745cf$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $02d4f449435745cf$var$_lockLocked = $02d4f449435745cf$var$_interopRequireDefault((parcelRequire("gWhpp")));
function $02d4f449435745cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $02d4f449435745cf$var$LockFilledIcon = (props)=>/*#__PURE__*/ $02d4f449435745cf$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $02d4f449435745cf$var$_lockLocked.default
    }));
$02d4f449435745cf$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $02d4f449435745cf$var$_default = module.exports.default = $02d4f449435745cf$var$LockFilledIcon;

});
parcelRegister("gWhpp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1d1b3dafeedb3bcbc92be5929839e615>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c54f9120ca8b9e22$var$_react = $c54f9120ca8b9e22$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c54f9120ca8b9e22$var$_UNSAFE_baseNew = $c54f9120ca8b9e22$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c54f9120ca8b9e22$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c54f9120ca8b9e22$var$LockLockedIcon = (props)=>/*#__PURE__*/ $c54f9120ca8b9e22$var$_react.default.createElement($c54f9120ca8b9e22$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 7.75H4c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25h-.75m-6.5 0V4a3.25 3.25 0 1 1 6.5 0v3.75m-6.5 0h6.5M8 10v3"/>`
    }, props));
$c54f9120ca8b9e22$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $c54f9120ca8b9e22$var$_default = module.exports.default = $c54f9120ca8b9e22$var$LockLockedIcon;

});


parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    const handleItemClick = (0, $eUqFw.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});
parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});
parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);


var $XHGTv = parcelRequire("XHGTv");

var $8gwL5 = parcelRequire("8gwL5");
const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if ((0, $XHGTv.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $8gwL5.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});





parcelRegister("gg3OU", function(module, exports) {

$parcel$export(module.exports, "MeatballsMenu", () => $707612239a75f4a6$export$cdd8c33ef508c851);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $fEubG = parcelRequire("fEubG");

var $jG1wZ = parcelRequire("jG1wZ");
const $707612239a75f4a6$export$cdd8c33ef508c851 = ({ id: id, tabIndex: tabIndex, onKeyDown: onKeyDown, moreIconLabel: moreIconLabel, children: children, isDisabled: isDisabled = false, testId: testId, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...props,
                id: id,
                testId: testId,
                tabIndex: tabIndex,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    label: moreIconLabel,
                    size: "medium"
                }),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled,
                onKeyDown: onKeyDown
            }),
        ...restProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, children));

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $epS3S = parcelRequire("epS3S");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $eUqFw.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event, currentLevel)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(()=>{
            triggerRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $epS3S.DropdownMenuProvider), {
        value: {
            returnFocusRef: triggerRef
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    })));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("epS3S", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuProvider", () => $ee1dc8dd27dd916a$export$9357e33608f1035a);

var $eUqFw = parcelRequire("eUqFw");
const $ee1dc8dd27dd916a$var$DropdownMenuContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $ee1dc8dd27dd916a$export$9357e33608f1035a = $ee1dc8dd27dd916a$var$DropdownMenuContext.Provider;

});

parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});


parcelRegister("fEubG", function(module, exports) {

$parcel$export(module.exports, "default", () => $920365f1041780e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ki32l = parcelRequire("ki32l");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $920365f1041780e0$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $ki32l.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children);
});
var $920365f1041780e0$export$2e2bcd8739ae039 = $920365f1041780e0$var$DropdownMenuItemGroup;

});
parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});



parcelRegister("cdP9F", function(module, exports) {

$parcel$export(module.exports, "FocusableTooltip", () => $19b3e609e91b6d77$export$9a54147e6bad2667);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8cU5f = parcelRequire("8cU5f");
const $19b3e609e91b6d77$export$9a54147e6bad2667 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($19b3e609e91b6d77$var$UnstyledButton, null, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $19b3e609e91b6d77$var$UnstyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _19itidpf _11q7glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1kw7",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dTkXT", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f8b5f31986cd4b45$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $f8b5f31986cd4b45$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    objects: {
        "id": "servicedesk-insight-schema-card.objects",
        "defaultMessage": "{objectNumber} {objectNumber, plural, one {object} other {objects}}"
    },
    configuration: {
        "id": "servicedesk-insight-schema-card.configuration",
        "defaultMessage": "Configuration"
    },
    more: {
        "id": "servicedesk-insight-schema-card.more",
        "defaultMessage": "More"
    },
    locked: {
        "id": "servicedesk-insight-schema-card.locked",
        "defaultMessage": "Locked"
    },
    tooltipDisabled: {
        "id": "servicedesk-insight-schema-card.tooltip-disabled",
        "defaultMessage": "You don't have permission to edit the object schema"
    },
    tooltipRestrictedSchema: {
        "id": "servicedesk-insight-schema-card.tooltip-restricted-schema",
        "defaultMessage": "This system-defined schema is read-only."
    }
});

});


parcelRegister("5zCQy", function(module, exports) {

$parcel$export(module.exports, "isUnexpectedFetchError", () => $e200b29e7199f52c$export$cd70b8b287611e8f);
$parcel$export(module.exports, "isSignal", () => $e200b29e7199f52c$export$a9a36f4641f8c6f0);

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");
const $e200b29e7199f52c$export$bc9678df7c38e24d = [
    503
];
const $e200b29e7199f52c$export$cd70b8b287611e8f = (error, errorStatusCodeGroups = [
    '5xx'
], excludeStatusCodes)=>{
    if (!error || !(error instanceof (0, $7byHA.default))) return false;
    // If excludeStatusCodes defined, check first before proceeding to check group
    if (excludeStatusCodes && excludeStatusCodes.length) {
        const { statusCode: statusCode } = error;
        if (excludeStatusCodes.includes(statusCode)) return false;
    }
    const statusCodeGroup = (0, $guiFP.getStatusCodeGroup)(error);
    return errorStatusCodeGroups.includes(statusCodeGroup);
};
const $e200b29e7199f52c$export$a9a36f4641f8c6f0 = (error, errorStatusCodeGroups = [
    '4xx',
    '5xx'
])=>$e200b29e7199f52c$export$cd70b8b287611e8f(error, errorStatusCodeGroups, $e200b29e7199f52c$export$bc9678df7c38e24d);

});

parcelRegister("iwvfb", function(module, exports) {

$parcel$export(module.exports, "ErrorContent", () => $1ac5a85b74f91c19$export$a9f602ed820d9782);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $2BP1Y = parcelRequire("2BP1Y");

var $4Es8k = parcelRequire("4Es8k");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fvkNf = parcelRequire("fvkNf");
const $1ac5a85b74f91c19$export$a9f602ed820d9782 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const renderImage = ()=>(0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $2BP1Y.default))({
            imageWidth: 164,
            maxImageWidth: 164,
            maxImageHeight: 212
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        size: "wide",
        renderImage: renderImage,
        header: formatMessage((0, $fvkNf.messages).errorTitle),
        description: formatMessage((0, $fvkNf.messages).errorDescription),
        testId: "servicedesk-insight-schema-container.ui.error"
    });
};

});
parcelRegister("fvkNf", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6a137d05a1084a96$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $6a137d05a1084a96$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "servicedesk-insight-schema-container.error.error-title",
        "defaultMessage": "There\u2019s been a problem loading the object schemas"
    },
    errorDescription: {
        "id": "servicedesk-insight-schema-container.error.error-description",
        "defaultMessage": "Try refreshing the page."
    }
});

});


parcelRegister("6TCXr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $559cf3611947477e$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $559cf3611947477e$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    objectSchemas: {
        "id": "servicedesk-insight-schema-container.object-schemas",
        "defaultMessage": "Object schemas"
    },
    addSchema: {
        "id": "servicedesk-insight-schema-container.add-schema",
        "defaultMessage": "Add schema"
    },
    createSchema: {
        "id": "servicedesk-insight-schema-container.create-schema",
        "defaultMessage": "Create schema"
    },
    schemaLimitReached: {
        "id": "servicedesk-insight-schema-container.schema-limit-reached",
        "defaultMessage": "Schema limit reached"
    },
    schemaLimitErrorMessage: {
        "id": "servicedesk-insight-schema-container.schema-limit-error-message",
        "defaultMessage": "You\u2019ve reached your site\u2019s maximum limit of {limit} {limit, plural, one {object schema} other {object schemas}}. Reduce the number of schemas or contact support."
    }
});

});


parcelRegister("fD30B", function(module, exports) {

$parcel$export(module.exports, "DATA_MANAGER_ADMIN", () => $c9771a4ef8b4afb6$export$48abe9ccfdd98170);
$parcel$export(module.exports, "DATA_MANAGER_REPORT_VIEWER", () => $c9771a4ef8b4afb6$export$8939b849d295aa4c);
$parcel$export(module.exports, "DATA_MANAGER_REPORT_EDITOR", () => $c9771a4ef8b4afb6$export$4ca2081d195ddbdb);
$parcel$export(module.exports, "DATA_MANAGER_ADAPTERS_ADMIN", () => $c9771a4ef8b4afb6$export$4c3d5fe6bdc107f1);
$parcel$export(module.exports, "DATA_MANAGER_ROLES", () => $c9771a4ef8b4afb6$export$48703faa5030b273);
$parcel$export(module.exports, "DATA_MANAGER_ADAPTERS_ROLES", () => $c9771a4ef8b4afb6$export$8b2dfd13f5f35ee4);
$parcel$export(module.exports, "ORDERED_ASSETS_DATA_MANAGER_ROLES", () => $c9771a4ef8b4afb6$export$1d276f65230af2e);
const $c9771a4ef8b4afb6$export$48abe9ccfdd98170 = 'ari:cloud:cmdb::role/airtrack/admin';
const $c9771a4ef8b4afb6$export$8939b849d295aa4c = 'ari:cloud:cmdb::role/airtrack/report-viewer';
const $c9771a4ef8b4afb6$export$4ca2081d195ddbdb = 'ari:cloud:cmdb::role/airtrack/report-editor';
const $c9771a4ef8b4afb6$export$4c3d5fe6bdc107f1 = 'ari:cloud:cmdb::role/airtrack-buoy/admin';
const $c9771a4ef8b4afb6$export$48703faa5030b273 = [
    $c9771a4ef8b4afb6$export$48abe9ccfdd98170,
    $c9771a4ef8b4afb6$export$8939b849d295aa4c,
    $c9771a4ef8b4afb6$export$4ca2081d195ddbdb
];
const $c9771a4ef8b4afb6$export$8b2dfd13f5f35ee4 = [
    $c9771a4ef8b4afb6$export$4c3d5fe6bdc107f1
];
const $c9771a4ef8b4afb6$export$1d276f65230af2e = [
    $c9771a4ef8b4afb6$export$48abe9ccfdd98170,
    $c9771a4ef8b4afb6$export$4c3d5fe6bdc107f1,
    $c9771a4ef8b4afb6$export$4ca2081d195ddbdb,
    $c9771a4ef8b4afb6$export$8939b849d295aa4c
];

});

parcelRegister("i35iP", function(module, exports) {

$parcel$export(module.exports, "FormattedLinkMessage", () => $bbb9034acc49e6eb$export$90d9bea5d5af37e0);

var $eUqFw = parcelRequire("eUqFw");

var $3x4sL = parcelRequire("3x4sL");

var $4ksts = parcelRequire("4ksts");

var $lB25E = parcelRequire("lB25E");
const $bbb9034acc49e6eb$export$90d9bea5d5af37e0 = ({ message: message, linkProps: linkProps })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        message: formatMessage(message, {
            linkTagStart: '{linkTagStart}',
            linkTagEnd: '{linkTagEnd}'
        }),
        componentsMapping: {
            linkTag: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), linkProps, children)
        }
    });
};

});
parcelRegister("3x4sL", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $88ddecd12f0773cd$export$200d7bd7633253ce);

var $eUqFw = parcelRequire("eUqFw");

var $dO2kc = parcelRequire("dO2kc");

var $6nVYw = parcelRequire("6nVYw");
const $88ddecd12f0773cd$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $eUqFw.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $6nVYw.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $6nVYw.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $6nVYw.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $dO2kc.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $dO2kc.MalformedMessageError)) {
                (0, $dO2kc.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $dO2kc.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("dO2kc", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $1a42e2705665fc85$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $1a42e2705665fc85$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $1a42e2705665fc85$export$40d900e818b9630e);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

const $1a42e2705665fc85$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $1a42e2705665fc85$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $guiFP.default)({
            meta: {
                packageName: packageName,
                id: (0, $376af31d5cd90f0d$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $376af31d5cd90f0d$export$f3390a0e172fee41)}`;
        (0, $gUUjF.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $1a42e2705665fc85$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $376af31d5cd90f0d$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("6nVYw", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $ec16d76793463e9e$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $ec16d76793463e9e$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $ec16d76793463e9e$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $ec16d76793463e9e$export$d5170904651e91b1);

const $ec16d76793463e9e$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $ec16d76793463e9e$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$d5170904651e91b1 = (letter)=>letter === (0, $a86f32165c278403$export$a10c567c3288a6b4);

});
const $a86f32165c278403$export$a10c567c3288a6b4 = '}';




parcelRegister("cb764", function(module, exports) {

$parcel$export(module.exports, "DataManagerGAChangeBoardingModal", () => $d33d9eabf71726fc$export$a6d366ad2609d7e6);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $2pG8n = parcelRequire("2pG8n");

var $9TyFx = parcelRequire("9TyFx");
const $d33d9eabf71726fc$export$a6d366ad2609d7e6 = (props)=>{
    const { isEnabledForGA: isEnabledForGA } = props;
    const [isDataManagerModalLoaded, setDataManagerModalLoaded] = (0, $eUqFw.useState)(false);
    const { entryPointActions: entryPointActions } = (0, $6j4bv.useEntryPoint)((0, $2pG8n.cmdbDataManagerChangeBoardingEntryPoint), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        if (!isDataManagerModalLoaded && isEnabledForGA) {
            entryPointActions.load();
            setDataManagerModalLoaded(true);
        }
    }, [
        entryPointActions,
        isDataManagerModalLoaded,
        isEnabledForGA
    ]);
    if (!isEnabledForGA) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9TyFx.CmdbDataManagerChangeBoarding), null);
};

});
parcelRegister("2pG8n", function(module, exports) {

$parcel$export(module.exports, "cmdbDataManagerChangeBoardingEntryPoint", () => $b906c12707f23f75$export$3925cb0b08e1f394);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $b906c12707f23f75$export$3925cb0b08e1f394 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("c43pj")), {
        moduleId: "3740e65a"
    }),
    getPreloadProps: ()=>({
            queries: {}
        })
});

});
parcelRegister("c43pj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4O3J7").then(()=>parcelRequire('6ZWTt'));

});


parcelRegister("9TyFx", function(module, exports) {

$parcel$export(module.exports, "CmdbDataManagerChangeBoarding", () => $9eafbdf01ba97861$export$c1e6758d8da69448);

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");
var $Sibrq = parcelRequire("Sibrq");

var $iFmgL = parcelRequire("iFmgL");

var $aOw1G = parcelRequire("aOw1G");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $jPr84 = parcelRequire("jPr84");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $kGQen = parcelRequire("kGQen");

var $5ge6s = parcelRequire("5ge6s");

var $0cdA8 = parcelRequire("0cdA8");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");


var $6EXcf = parcelRequire("6EXcf");

var $aYKro = parcelRequire("aYKro");
const $9eafbdf01ba97861$export$1f04342a44ce11ca = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isFinished, setIsFinished] = (0, $eUqFw.useState)(false);
    const finishChangeBoarding = ()=>{
        props.stop?.();
        setIsFinished(true);
    };
    const onDone = ()=>{
        window.open('https://www.atlassian.com/software/jira/service-management/features/assets-data-manager', '_blank');
        finishChangeBoarding();
    };
    const onClose = ()=>{
        finishChangeBoarding();
    };
    if (isFinished) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Sibrq.default).Provider, {
        value: (0, $jPr84.modalButtonTheme)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: 600,
        onClose: onClose,
        autoFocus: false,
        testId: "servicedesk-cmdb-data-manager-change-boarding.ui.modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9eafbdf01ba97861$var$modalContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9eafbdf01ba97861$var$modaImageContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6EXcf))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($6EXcf))),
        alt: formatMessage((0, $aYKro.messages).modalHeroBannerImageAltText),
        testId: "servicedesk-cmdb-data-manager-change-boarding.ui.image"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9eafbdf01ba97861$var$noBorderContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9eafbdf01ba97861$var$modalTitleWrapper,
        paddingBlockStart: "space.500",
        paddingBlockEnd: "space.200",
        paddingInlineStart: "space.600",
        paddingInlineEnd: "space.600"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $aYKro.messages).modalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9eafbdf01ba97861$var$modalContentWrapper,
        paddingBlockStart: "space.0",
        paddingBlockEnd: "space.0",
        paddingInlineStart: "space.600",
        paddingInlineEnd: "space.600"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $aYKro.messages).modalContent,
        values: {
            p: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, msg)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockStart: "space.400",
        paddingBlockEnd: "space.500",
        paddingInlineStart: "space.500",
        paddingInlineEnd: "space.500",
        xcss: $9eafbdf01ba97861$var$noBorderContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        direction: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        appearance: "subtle",
        onClick: onClose,
        testId: "servicedesk-cmdb-data-manager-change-boarding.ui.cancel-button"
    }, formatMessage((0, $aYKro.messages).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        appearance: "primary",
        onClick: onDone,
        testId: "servicedesk-cmdb-data-manager-change-boarding.ui.confirm-button"
    }, formatMessage((0, $aYKro.messages).confirmButton))))))));
};
const $9eafbdf01ba97861$export$c1e6758d8da69448 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "CmdbDataManagerChangeBoarding",
        packageName: "jiraServicedeskCmdbDataManagerChangeBoarding",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ge6s.default), {
        messageId: (0, $27370378dbcb5bed$export$78f2c56846ab905c)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9eafbdf01ba97861$export$1f04342a44ce11ca, null))));
const $9eafbdf01ba97861$var$modalTitleWrapper = (0, $1ZAYh.xcss)({
    textAlign: 'center',
    fontWeight: `${"var(--ds-font-weight-semibold, 510)"}`
});
const $9eafbdf01ba97861$var$modalContentWrapper = (0, $1ZAYh.xcss)({
    textAlign: 'center'
});
const $9eafbdf01ba97861$var$modalContainer = (0, $1ZAYh.xcss)({
    backgroundColor: 'elevation.surface',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`
});
const $9eafbdf01ba97861$var$modaImageContainer = (0, $1ZAYh.xcss)({
    borderRadius: `${"var(--ds-border-radius, 3px)"} ${"var(--ds-border-radius, 3px)"} 0 0`,
    overflow: 'hidden'
});
const $9eafbdf01ba97861$var$noBorderContainer = (0, $1ZAYh.xcss)({
    border: 'none'
});

});
parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("5ge6s", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $67d1cec28351d2e7$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $67d1cec28351d2e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1C9jQ = parcelRequire("1C9jQ");

var $xMKqn = parcelRequire("xMKqn");
var $DEVKo = parcelRequire("DEVKo");

var $67SDP = parcelRequire("67SDP");

var $hS6Nu = parcelRequire("hS6Nu");

var $6uNFR = parcelRequire("6uNFR");

var $jGBLd = parcelRequire("jGBLd");

var $e91YZ = parcelRequire("e91YZ");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $jD3pk = parcelRequire("jD3pk");

var $38OPi = parcelRequire("38OPi");
const $67d1cec28351d2e7$var$isSyntheticTenant = ()=>(0, $6rW04.default)('ajs-is-synthetic') === 'true';
class $67d1cec28351d2e7$export$580a2294c917898c extends (0, $DEVKo.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
        const environment = (0, $38OPi.toEnvironment)((0, $6rW04.default)('ajs-environment'));
        const getEnvironmentType = (env)=>{
            if (env === 'prod') return (0, $1C9jQ.envType).PROD;
            if (env === 'staging') return (0, $1C9jQ.envType).STAGING;
            return (0, $1C9jQ.envType).DEV;
        };
        // If a ancestor (e.g. CoordinationClient wraps CoordinationClient) is already choreographed,
        // we should not re-choreograph this CoordinationClient
        const enableChoreographer = (0, $jGBLd.shouldBeChoreographed)({
            messageType: messageType
        }) && (0, $1ybV0.ff)('post-office_enable_jira_choreographer') && !isAlreadyChoreographedAtAncestor;
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: getEnvironmentType(environment),
            additionalData: {
                sourceProductId: (0, $67SDP.ProductIds).JIRA
            }
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $67d1cec28351d2e7$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        this.enableChoreographer = enableChoreographer;
        this.onMessageDisposition = onMessageDisposition;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $1ybV0.ff)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, $67SDP.MessageDeliveryStatus).STARTED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) {
                const didStop = await super.stop(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $67SDP.MessageDeliveryStatus).STOPPED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            }
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId).then((didStart)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, $67SDP.MessageDeliveryStatus).STARTED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            return didStart;
        });
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId).then((didStop)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $67SDP.MessageDeliveryStatus).STOPPED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            return didStop;
        });
    }
}
function $67d1cec28351d2e7$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $6uNFR.useChoreographedStatusContext)();
    const client = new $67d1cec28351d2e7$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor);
    const { fallback: fallback, messageId: messageId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hS6Nu.ChoreographerContextProvider), {
        isChoreographed: client.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xMKqn.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children));
}

});
parcelRegister("hS6Nu", function(module, exports) {

$parcel$export(module.exports, "ChoreographerContextProvider", () => $ea4a43adc0d84a49$export$c3226151caaf2fbf);

var $eUqFw = parcelRequire("eUqFw");

var $6uNFR = parcelRequire("6uNFR");
const $ea4a43adc0d84a49$var$choreographedStatusContextValue = {
    isAlreadyChoreographedAtAncestor: true
};
const $ea4a43adc0d84a49$export$c3226151caaf2fbf = ({ isChoreographed: isChoreographed, children: children })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $6uNFR.useChoreographedStatusContext)();
    const shouldUseChoreographerContextProvider = !isAlreadyChoreographedAtAncestor && isChoreographed;
    return shouldUseChoreographerContextProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uNFR.ChoreographedStatusContext).Provider, {
        value: $ea4a43adc0d84a49$var$choreographedStatusContextValue
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};

});


const $27370378dbcb5bed$export$78f2c56846ab905c = 'jsm-cmdb-data-manager-changeboarding';

parcelRegister("6EXcf", function(module, exports) {
module.exports = new URL("background.66b3a48c.png", import.meta.url).toString();

});

parcelRegister("aYKro", function(module, exports) {

$parcel$export(module.exports, "messages", () => $00c00d03eea9edb2$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $00c00d03eea9edb2$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    modalHeroBannerImageAltText: {
        "id": "servicedesk-cmdb-data-manager-change-boarding.modal-hero-banner-image-alt-text",
        "defaultMessage": "Data Manager modal banner image"
    },
    modalTitle: {
        "id": "servicedesk-cmdb-data-manager-change-boarding.modal-title",
        "defaultMessage": "Introducing Data Manager"
    },
    modalContent: {
        "id": "servicedesk-cmdb-data-manager-change-boarding.modal-content",
        "defaultMessage": "<p>With Data Manager, you can now import your data from anywhere. Data Manager gathers, aggregates and analyses multiple sources of data, making it easy to pinpoint issues so you can move on to more important tasks.</p><p>Go to Assets configuration to enable Data Manager on your site.</p>"
    },
    cancelButton: {
        "id": "servicedesk-cmdb-data-manager-change-boarding.cancel-button",
        "defaultMessage": "Remind me later"
    },
    confirmButton: {
        "id": "servicedesk-cmdb-data-manager-change-boarding.confirm-button",
        "defaultMessage": "Read about Data Manager"
    }
});

});



parcelRegister("1BawU", function(module, exports) {

$parcel$export(module.exports, "AsyncInsightLandingPageChangeboarding", () => $b0870fc5a1abac9e$export$74d1b0d7eee76602);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/deprecations/no-rll-client-async-experiences
const $b0870fc5a1abac9e$var$InsightLandingPageChangeboarding = (0, $7rh0R.lazy)(()=>(parcelRequire("7rjuI")), {
    moduleId: "./src/packages/servicedesk/insight-landing/insight-landing-page/src/ui/changeboarding/index.tsx"
});
const $b0870fc5a1abac9e$export$74d1b0d7eee76602 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-insight-landing-page-changeboarding-check",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0870fc5a1abac9e$var$InsightLandingPageChangeboarding, null));

});
parcelRegister("7rjuI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("57obw").then(()=>parcelRequire('3FZdx'));

});


parcelRegister("aFp4n", function(module, exports) {

$parcel$export(module.exports, "ConfigLink", () => $8d0e42b59702586e$export$69f8d6558940afc4);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $8mHDC = parcelRequire("8mHDC");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lB25E = parcelRequire("lB25E");
const $8d0e42b59702586e$export$69f8d6558940afc4 = ({ children: children, onClick: onClick, testId: testId, to: to })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $8d0e42b59702586e$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: to,
        component: (0, $lB25E.Link),
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8mHDC))), {
            label: "",
            size: "medium"
        }),
        testId: testId,
        onClick: (event, analyticsEvent)=>{
            onClick?.(analyticsEvent);
        }
    }, children));
const $8d0e42b59702586e$var$wrapperStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("8mHDC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61723a6b5c2ed414$var$_react = $61723a6b5c2ed414$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $61723a6b5c2ed414$var$_settings = $61723a6b5c2ed414$var$_interopRequireDefault((parcelRequire("dW1OX")));
function $61723a6b5c2ed414$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $61723a6b5c2ed414$var$EditorSettingsIcon = (props)=>/*#__PURE__*/ $61723a6b5c2ed414$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.002 15.504a3.502 3.502 0 1 1 0-7.004 3.502 3.502 0 0 1 0 7.004m6.732-1.987a1.605 1.605 0 0 1-.001-3.034.386.386 0 0 0 .253-.462 7.2 7.2 0 0 0-.672-1.604.384.384 0 0 0-.481-.156c-.31.127-.668.16-1.039.065a1.6 1.6 0 0 1-1.129-1.124 1.64 1.64 0 0 1 .061-1.043.385.385 0 0 0-.157-.48 7.2 7.2 0 0 0-1.59-.665.385.385 0 0 0-.461.252 1.604 1.604 0 0 1-3.032 0 .387.387 0 0 0-.463-.252c-.57.16-1.11.39-1.613.677a.38.38 0 0 0-.159.468 1.611 1.611 0 0 1-2.088 2.108.385.385 0 0 0-.479.158 7.2 7.2 0 0 0-.67 1.604.386.386 0 0 0 .248.46 1.605 1.605 0 0 1 0 3.021.385.385 0 0 0-.249.46c.143.504.34.986.582 1.44.096.179.318.24.502.156.479-.22 1.08-.213 1.693.191a.9.9 0 0 1 .243.242c.424.643.412 1.272.16 1.76a.38.38 0 0 0 .134.506 7.2 7.2 0 0 0 1.697.721.38.38 0 0 0 .459-.251A1.605 1.605 0 0 1 12 17.645c.707 0 1.302.457 1.518 1.09.066.19.265.306.459.251a7.2 7.2 0 0 0 1.677-.71.38.38 0 0 0 .134-.508c-.256-.49-.271-1.12.154-1.766a.9.9 0 0 1 .243-.243c.62-.411 1.228-.413 1.71-.185a.384.384 0 0 0 .505-.153q.367-.683.585-1.443a.385.385 0 0 0-.252-.461"/></svg>`
    }, props, {
        newIcon: $61723a6b5c2ed414$var$_settings.default
    }));
$61723a6b5c2ed414$var$EditorSettingsIcon.displayName = 'EditorSettingsIcon';
var $61723a6b5c2ed414$var$_default = module.exports.default = $61723a6b5c2ed414$var$EditorSettingsIcon;

});


parcelRegister("6xc55", function(module, exports) {

$parcel$export(module.exports, "DataManagerAdaptersGlyph", () => $262ae0fde6aeda0b$export$cff497901afe8164);
$parcel$export(module.exports, "DataManagerLink", () => $262ae0fde6aeda0b$export$905e681c1cad3de);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $2ziLQ = parcelRequire("2ziLQ");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lB25E = parcelRequire("lB25E");
const $262ae0fde6aeda0b$export$fb5ad6208dd8d5f1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7.5 6.5C7.5 7.05228 7.05228 7.5 6.5 7.5C5.94772 7.5 5.5 7.05228 5.5 6.5C5.5 5.94772 5.94772 5.5 6.5 5.5C7.05228 5.5 7.5 5.94772 7.5 6.5ZM7.5 17.5C7.5 18.0523 7.05228 18.5 6.5 18.5C5.94772 18.5 5.5 18.0523 5.5 17.5C5.5 16.9477 5.94772 16.5 6.5 16.5C7.05228 16.5 7.5 16.9477 7.5 17.5ZM18.5 12C18.5 12.5523 18.0523 13 17.5 13C16.9477 13 16.5 12.5523 16.5 12C16.5 11.4477 16.9477 11 17.5 11C18.0523 11 18.5 11.4477 18.5 12ZM8.88555 7.25C8.56698 8.26428 7.61941 9 6.5 9C5.11929 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.61941 4 8.56698 4.73572 8.88555 5.75H10.5523C11.697 5.75 12.625 6.67797 12.625 7.82267V11.25H14.5H15.1145C15.433 10.2357 16.3806 9.5 17.5 9.5C18.8807 9.5 20 10.6193 20 12C20 13.3807 18.8807 14.5 17.5 14.5C16.3806 14.5 15.433 13.7643 15.1145 12.75H14.5H12.625V16.1773C12.625 17.322 11.697 18.25 10.5523 18.25H8.88555C8.56698 19.2643 7.61941 20 6.5 20C5.11929 20 4 18.8807 4 17.5C4 16.1193 5.11929 15 6.5 15C7.61941 15 8.56698 15.7357 8.88555 16.75H10.5523C10.8686 16.75 11.125 16.4936 11.125 16.1773V12.75V12V11.25V7.82267C11.125 7.50639 10.8686 7.25 10.5523 7.25H8.88555Z",
        fill: "#44546F"
    }));
const $262ae0fde6aeda0b$export$cff497901afe8164 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        "clip-path": "url(#clip0_2374_102539)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10.5076 15.8019C10.8212 16.0862 11 16.4898 11 16.913V18.5H13V16.913C13 16.4898 13.1788 16.0862 13.4924 15.8019L16.5 13.0745V9.5H7.5V13.0745L10.5076 15.8019ZM6 13.7391V9C6 8.44771 6.44772 8 7 8H17C17.5523 8 18 8.44772 18 9V13.7391L14.5 16.913V19C14.5 19.5523 14.0523 20 13.5 20H10.5C9.94772 20 9.5 19.5523 9.5 19V16.913L6 13.7391Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9 9L9 4L10.5 4V9H9Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M13.5 9V4L15 4V9H13.5Z",
        fill: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_2374_102539"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "currentColor"
    }))));
const $262ae0fde6aeda0b$export$905e681c1cad3de = ({ children: children, onClick: onClick, testId: testId, to: to, app: app })=>{
    const getIcon = ()=>{
        if (app === 'data-manager') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
            glyph: $262ae0fde6aeda0b$export$fb5ad6208dd8d5f1,
            label: "Data manager icon",
            size: "medium"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
            glyph: $262ae0fde6aeda0b$export$cff497901afe8164,
            label: "Adapters icon",
            size: "medium"
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $262ae0fde6aeda0b$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: to,
        component: (0, $lB25E.Link),
        appearance: "subtle",
        iconBefore: getIcon(),
        testId: testId,
        onClick: (event, analyticsEvent)=>{
            onClick?.(analyticsEvent);
        },
        target: "_blank"
    }, children));
};
const $262ae0fde6aeda0b$var$wrapperStyles = (0, $1ZAYh.xcss)({});

});

parcelRegister("eVv4l", function(module, exports) {

$parcel$export(module.exports, "messages", () => $332142f4e792fc5a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $332142f4e792fc5a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    descriptionCmdbAssets: {
        "id": "servicedesk-insight-landing-page.description-cmdb-assets",
        "defaultMessage": "Connect, track and manage the assets that matter to your team - application services, infrastructure, hardware, people, and much more. {linkTagStart}Learn more about Assets{linkTagEnd}"
    },
    navRefreshAssetsSchemasTile: {
        "id": "servicedesk-insight-landing-page.nav-refresh-assets-schemas-tile",
        "defaultMessage": "Schemas"
    },
    assetsBreadcrumbs: {
        "id": "servicedesk-insight-landing-page.assets-breadcrumbs",
        "defaultMessage": "Assets"
    },
    documentTitleCmdbAssets: {
        "id": "servicedesk-insight-landing-page.document-title-cmdb-assets",
        "defaultMessage": "Asset and configuration management"
    },
    configLink: {
        "id": "servicedesk-insight-landing-page.config-link",
        "defaultMessage": "Configuration"
    },
    searchPlaceholder: {
        "id": "servicedesk-insight-landing-page.search-placeholder",
        "defaultMessage": "Search all schemas for objects..."
    },
    searchPlaceholderAriaLabel: {
        "id": "servicedesk-insight-landing-page.search-placeholder-aria-label",
        "defaultMessage": "Start typing, then use the up and down arrows to select an option from the list"
    },
    reportsLink: {
        "id": "servicedesk-insight-landing-page.reports-link",
        "defaultMessage": "Reports"
    },
    dataManagerLink: {
        "id": "servicedesk-insight-landing-page.data-manager-link",
        "defaultMessage": "Data Manager"
    },
    adaptersLink: {
        "id": "servicedesk-insight-landing-page.adapters-link",
        "defaultMessage": "Adapters"
    }
});

});

parcelRegister("buK2c", function(module, exports) {

$parcel$export(module.exports, "AsyncInsightLandingPageReportsLink", () => $2ee8c7eeb0b65049$export$ade00b93735f7ab1);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ee8c7eeb0b65049$var$ReportsLink = (0, $7rh0R.lazy)(()=>(parcelRequire("Ifh5Z")), {
    moduleId: "./src/packages/servicedesk/insight-landing/insight-landing-page/src/ui/reports-link/link/index.tsx"
});
const $2ee8c7eeb0b65049$export$ade00b93735f7ab1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-insight-landing-page-reports-link",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ee8c7eeb0b65049$var$ReportsLink, props));

});
parcelRegister("Ifh5Z", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fstN8").then(()=>parcelRequire('a8V8m'));

});


parcelRegister("aqMn6", function(module, exports) {

$parcel$export(module.exports, "UsagePanel", () => $1b14c5081260c1ab$export$3660c3fa9bf0d23c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $aUqTb = parcelRequire("aUqTb");

var $23NQ5 = parcelRequire("23NQ5");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $3QLcd = parcelRequire("3QLcd");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1CIRW = parcelRequire("1CIRW");

var $272oI = parcelRequire("272oI");

var $40s32 = parcelRequire("40s32");
const $1b14c5081260c1ab$export$3660c3fa9bf0d23c = ()=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $5JgJ2.default)();
    const [{ config: config }] = (0, $1CIRW.useInsightGlobalConfig)();
    const [isHelpOpen, setIsHelpOpen] = (0, $eUqFw.useState)(false);
    if (!config) return null;
    const { insightAdministrator: insightAdministrator, limitInfo: limitInfo } = config;
    const { objectCount: objectCount } = limitInfo;
    const calculationInfo = formatMessage((0, $40s32.messages).calculationInfo);
    const renderHelpContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            padding: "space.200",
            xcss: $1b14c5081260c1ab$var$helpBoxStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $40s32.messages).excludedSchemasInfo)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
            articleId: "3sbbZSMOEhRWrOLZI4UNNs",
            appearance: "link",
            spacing: "none",
            onClick: ()=>setIsHelpOpen(false),
            fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: "https://support.atlassian.com/jira-service-management-cloud/docs/what-is-feature-usage-and-how-it-works",
                target: "_blank",
                rel: "noopener noreferrer"
            }, calculationInfo)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b14c5081260c1ab$var$HelpText, null, calculationInfo)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b14c5081260c1ab$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $40s32.messages).objects), ' '), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isHelpOpen,
        onClose: ()=>setIsHelpOpen(false),
        placement: "top-start",
        content: renderHelpContent,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "none",
                iconBefore: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
                    label: formatMessage((0, $40s32.messages).assetsUsageInfo),
                    primaryColor: isHelpOpen ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon-subtle, #626F86)"
                }),
                isSelected: isHelpOpen,
                onClick: ()=>setIsHelpOpen(!isHelpOpen)
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b14c5081260c1ab$var$Count, null, formatNumber(objectCount)), insightAdministrator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: (0, $272oI.getFeatureUsagePageUrl)(),
        target: "_blank",
        rel: "noopener noreferrer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $40s32.messages).viewDetailedUsage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
        size: "small",
        label: ""
    })))));
};
const $1b14c5081260c1ab$var$helpBoxStyles = (0, $1ZAYh.xcss)({
    maxWidth: '210px'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b14c5081260c1ab$var$HelpText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5724jg8 _y3gnv2br",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b14c5081260c1ab$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulputpp _2lx21bp4 _19pkpxbi _otyr1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b14c5081260c1ab$var$Count = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pbfng _1wyb1tcg _syaz1fxt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aUqTb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f13fdf9f823d771$var$_react = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $7f13fdf9f823d771$var$_information = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $7f13fdf9f823d771$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7f13fdf9f823d771$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $7f13fdf9f823d771$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $7f13fdf9f823d771$var$_information.default
    }));
$7f13fdf9f823d771$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $7f13fdf9f823d771$var$_default = module.exports.default = $7f13fdf9f823d771$var$EditorPanelIcon;

});

parcelRegister("3QLcd", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $82adde900735644c$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $82adde900735644c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $cEaY5 = parcelRequire("cEaY5");

var $zcJ0y = parcelRequire("zcJ0y");

var $1ybV0 = parcelRequire("1ybV0");

var $f2Poq = parcelRequire("f2Poq");

var $1zRTT = parcelRequire("1zRTT");

var $bUi2Q = parcelRequire("bUi2Q");
const $82adde900735644c$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $1zRTT.useHelpPanelActions)();
    const isIphEnabled = (0, $1ybV0.ff)('iph.enabled') && !(0, $zcJ0y.isIE11)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $f2Poq.HELP_PANEL_ID), (0, $f2Poq.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            }
        });
    };
    return isIphEnabled ? handleOnClick : undefined;
};
const $82adde900735644c$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, ...props })=>{
    const onOpenInProductHelpArticle = $82adde900735644c$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle?.(articleId, (0, $cEaY5.ARTICLE_TYPE)[type]);
    };
    return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $7JEyt.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fallbackComponent);
};
var $82adde900735644c$export$2e2bcd8739ae039 = $82adde900735644c$var$HelpPanelLink;
const $82adde900735644c$var$buttonWrapperStyles = null;

});

parcelRegister("40s32", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6a12d9334011dab7$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $6a12d9334011dab7$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    objects: {
        "id": "servicedesk-insight-landing-page.usage-panel.objects",
        "defaultMessage": "Objects"
    },
    excludedSchemasInfo: {
        "id": "servicedesk-insight-landing-page.usage-panel.excluded-schemas-info",
        "defaultMessage": "Excludes objects stored within system schemas."
    },
    assetsUsageInfo: {
        "id": "servicedesk-insight-landing-page.usage-panel.assets-usage-info",
        "defaultMessage": "Object usage information"
    },
    viewDetailedUsage: {
        "id": "servicedesk-insight-landing-page.usage-panel.view-detailed-usage",
        "defaultMessage": "View detailed usage"
    },
    calculationInfo: {
        "id": "servicedesk-insight-landing-page.usage-panel.calculation-info",
        "defaultMessage": "Read how Assets usage is calculated."
    }
});

});



parcelRegister("2RidI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3141fb0b4d3f9503$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");

var $iVSJI = parcelRequire("iVSJI");

var $frZnw = parcelRequire("frZnw");

var $fO5rB = parcelRequire("fO5rB");

var $bhwgQ = parcelRequire("bhwgQ");

var $1IzB8 = parcelRequire("1IzB8");
const $3141fb0b4d3f9503$var$ServiceDeskAppBase = ({ appName: appName, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1IzB8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "serviceDesk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVSJI.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $frZnw.toPackageName)(appName),
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, children))));
var $3141fb0b4d3f9503$export$2e2bcd8739ae039 = $3141fb0b4d3f9503$var$ServiceDeskAppBase;

});
parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("1IzB8", function(module, exports) {

$parcel$export(module.exports, "default", () => $edeca50de0b85084$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $10fdS = parcelRequire("10fdS");


var $bsgfb = parcelRequire("bsgfb");

var $1fuiA = parcelRequire("1fuiA");
const $edeca50de0b85084$var$AccessCheck = ({ children: children })=>{
    const isSettingsRoute = (0, $10fdS.useCurrentRoute)().path.includes(`${(0, $2df94debed157361$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
    const Gate = isSettingsRoute ? (0, $1fuiA.default) : (0, $bsgfb.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Gate, null, children);
};
var $edeca50de0b85084$export$2e2bcd8739ae039 = $edeca50de0b85084$var$AccessCheck;

});
const $2df94debed157361$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';

parcelRegister("bsgfb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d02215a42a3332$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");

var $fz8wa = parcelRequire("fz8wa");

var $11C4f = parcelRequire("11C4f");
const $a7d02215a42a3332$var$ProductAccessCheck = ({ children: children })=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $fz8wa.useApplicationPermissions)();
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    if (projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $11C4f.default), null, children);
    return hasServiceDeskAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: "/jira"
    });
};
var $a7d02215a42a3332$export$2e2bcd8739ae039 = $a7d02215a42a3332$var$ProductAccessCheck;

});
parcelRegister("11C4f", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2544b3bfea70255$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");

var $jyTef = parcelRequire("jyTef");


var $6tW8V = parcelRequire("6tW8V");
const $a2544b3bfea70255$var$AgentCheck = ({ children: children })=>{
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    const [{ data: data, error: error }] = (0, $jyTef.useServiceDeskContext)();
    if (data || error) {
        // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
        if (!(0, $6tW8V.isAccessError)(error)) {
            const { userRole: userRole = '' } = data || {};
            if (userRole === 'agent' || userRole === 'agent-project-admin') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
            if (error) throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: `${(0, $2df94debed157361$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
        });
    }
    return null;
};
var $a2544b3bfea70255$export$2e2bcd8739ae039 = $a2544b3bfea70255$var$AgentCheck;

});
parcelRegister("jyTef", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $3f940b317a874b53$export$712ead87353ac687);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $ct0sQ = parcelRequire("ct0sQ");

const $3f940b317a874b53$var$getServiceDeskContextResource = ()=>(0, $ct0sQ.serviceDeskContextResource);
const $3f940b317a874b53$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $iZJHG.useResourceWithCustomRouterContext)($3f940b317a874b53$var$getServiceDeskContextResource(), customContext);
    (0, $eUqFw.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});

parcelRegister("6tW8V", function(module, exports) {

$parcel$export(module.exports, "isAccessError", () => $5107715f0b974007$export$ddaebe4928e793cb);

const $5107715f0b974007$var$RESTRICTED_ACCESS_CODES = [
    (0, $1c3fbb431a173cc6$export$a3269a3914b007e3),
    (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef),
    (0, $1c3fbb431a173cc6$export$67d19e9a991baa07)
];
const $5107715f0b974007$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $5107715f0b974007$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;

});



parcelRegister("1fuiA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0788b3e6146363c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2Ba2b = parcelRequire("2Ba2b");

var $jyTef = parcelRequire("jyTef");

var $6tW8V = parcelRequire("6tW8V");
const $0788b3e6146363c4$var$SettingsAccessCheck = ({ children: children })=>{
    const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, $jyTef.useServiceDeskContext)();
    const userRole = serviceDeskContext?.userRole;
    // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
    const hasAccessError = (0, $6tW8V.isAccessError)(serviceDeskContextError);
    // Service desk context is updated on every route change
    // If context fails to give us an indicative result (e.g. fetch failed, 500 error)
    // We will continue to use current value to assess permissions
    if (userRole === 'agent-project-admin' && !hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    if (userRole !== undefined || hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.ProjectNotFound), null);
    if (serviceDeskContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.GenericError), null);
    return null;
};
var $0788b3e6146363c4$export$2e2bcd8739ae039 = $0788b3e6146363c4$var$SettingsAccessCheck;

});
parcelRegister("2Ba2b", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $abcdf98f8a718d25$export$849d319c342682a2);
$parcel$export(module.exports, "GenericError", () => $abcdf98f8a718d25$export$7d465be8efa67280);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $heNSb = parcelRequire("heNSb");

var $lQXqy = parcelRequire("lQXqy");

var $7QuzF = parcelRequire("7QuzF");

var $4Es8k = parcelRequire("4Es8k");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $6Yj0X = parcelRequire("6Yj0X");
const $abcdf98f8a718d25$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $6Yj0X.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $7QuzF.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $6Yj0X.default).notFoundTitle),
        description: formatMessage((0, $6Yj0X.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
            to: projectsPath
        }, formatMessage((0, $6Yj0X.default).notFoundAction))
    }));
};
const $abcdf98f8a718d25$export$7d465be8efa67280 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $6Yj0X.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $lQXqy.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $6Yj0X.default).genericErrorTitle),
        description: formatMessage((0, $6Yj0X.default).genericErrorDescription)
    }));
};

});
parcelRegister("lQXqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $30559913302f86cb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $30559913302f86cb$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("1cuWo")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("48S62")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $9TZf5 = parcelRequire("9TZf5");

var $48S62 = parcelRequire("48S62");

var $1cuWo = parcelRequire("1cuWo");
const $30559913302f86cb$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1cuWo)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($48S62))
});
var $30559913302f86cb$export$2e2bcd8739ae039 = $30559913302f86cb$var$Illustration;
// for advanced use only
const $30559913302f86cb$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("48S62", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("1cuWo", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("7QuzF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ab5059cf2dfabb6$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $9TZf5 = parcelRequire("9TZf5");

var $fCVbE = parcelRequire("fCVbE");
const $3ab5059cf2dfabb6$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($fCVbE)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($fCVbE))
});
var $3ab5059cf2dfabb6$export$2e2bcd8739ae039 = $3ab5059cf2dfabb6$var$Illustration;
// for advanced use only
const $3ab5059cf2dfabb6$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("fCVbE", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("6Yj0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c13e1fbd282caae$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6c13e1fbd282caae$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    }
});

});





parcelRegister("gXRa1", function(module, exports) {

$parcel$export(module.exports, "InsightAppBaseV2", () => $eadcae346abfef81$export$c9b1085d6a7138ac);

var $eUqFw = parcelRequire("eUqFw");

var $TjzlD = parcelRequire("TjzlD");

var $bEZRh = parcelRequire("bEZRh");

var $8PehF = parcelRequire("8PehF");

var $80nQh = parcelRequire("80nQh");

var $aeCba = parcelRequire("aeCba");

var $3o0h6 = parcelRequire("3o0h6");

var $gd0Sp = parcelRequire("gd0Sp");
const $eadcae346abfef81$export$c9b1085d6a7138ac = ({ children: children })=>{
    const { workspaceId: workspaceId, error: error, loading: loading } = (0, $80nQh.useWorkspaceContext)();
    const hasInsightPermission = (0, $80nQh.useInsightVisibility)();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    if (!(0, $8PehF.isCMDBEnabledInEnvironment)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.NotFoundErrorPageAsync), null);
    if (!(0, $aeCba.isLicensedPremiumUser)(tenantContext)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $TjzlD.AsyncCmdbUpsellPage), null);
    if (workspaceId == null) return !loading && !error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.NotFoundErrorPageAsync), null) : null;
    if (hasInsightPermission === false || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.GenericPermissionErrorPageAsync), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3o0h6.PageStyle), null, children({
        workspaceId: workspaceId
    }));
};

});
parcelRegister("TjzlD", function(module, exports) {

$parcel$export(module.exports, "AsyncCmdbUpsellPage", () => $4180e6b386c2e7f7$export$659eb30d49d6ed87);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4180e6b386c2e7f7$var$LazyCmdbUpsellPage = (0, $7rh0R.lazy)(()=>(parcelRequire("3NrkJ")).then((module)=>module.UpsellPage), {
    moduleId: "./src/packages/servicedesk/cmdb/cmdb-upsell-page/src/ui/index.tsx"
});
const $4180e6b386c2e7f7$export$659eb30d49d6ed87 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "cmdb-upsell-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4180e6b386c2e7f7$var$LazyCmdbUpsellPage, null));

});
parcelRegister("3NrkJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("6PNaw")
]).then(()=>parcelRequire('58VPC'));

});


parcelRegister("3o0h6", function(module, exports) {

$parcel$export(module.exports, "PageStyle", () => $d0c61d036d967c5f$export$c59987a647e9a55);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9c7gV = parcelRequire("9c7gV");
const $d0c61d036d967c5f$export$c59987a647e9a55 = ({ Page: Page, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0c61d036d967c5f$var$JSDSpaPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Page, null, children));
$d0c61d036d967c5f$export$c59987a647e9a55.defaultProps = {
    Page: (0, $9c7gV.default)
};
var $d0c61d036d967c5f$export$2e2bcd8739ae039 = $d0c61d036d967c5f$export$c59987a647e9a55;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d0c61d036d967c5f$var$JSDSpaPageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8zdiv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9c7gV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4be3daaa307b075d$export$2e2bcd8739ae039);

var $aJWi0 = parcelRequire("aJWi0");

var $j7bQJ = parcelRequire("j7bQJ");

var $6tahE = parcelRequire("6tahE");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$4be3daaa307b075d$export$2e2bcd8739ae039 = (0, $aJWi0.default);

});
parcelRegister("aJWi0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7341c6e5fd381e79$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");
function $7341c6e5fd381e79$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7341c6e5fd381e79$var$bannerStyles = {
    name: "4oew4k",
    styles: "width:100%;position:fixed"
};
const $7341c6e5fd381e79$var$bannerContainerStyles = {
    name: "1x3pv69",
    styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
};
const $7341c6e5fd381e79$var$pageContentStyles = {
    name: "15n167b",
    styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
};
const $7341c6e5fd381e79$var$wrapperStyles = {
    name: "m5v4sl",
    styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
};
const $7341c6e5fd381e79$var$mainContainerStyles = {
    name: "1cete8c",
    styles: "display:flex;flex:1 1 auto"
};
const $7341c6e5fd381e79$var$navigationStyles = {
    name: "wrqbg1",
    styles: "position:relative;z-index:2"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $7341c6e5fd381e79$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $cuCEk.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$wrapperStyles,
        "data-testid": testId
    }, banner ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$bannerContainerStyles,
        style: {
            height: isBannerOpen ? `${bannerHeight}px` : '0'
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? `${testId}--banner-container` : undefined
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$bannerStyles
    }, banner)) : null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$mainContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$navigationStyles
    }, navigation), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$pageContentStyles
    }, children)));
};
var $7341c6e5fd381e79$export$2e2bcd8739ae039 = $7341c6e5fd381e79$var$Page;

});
parcelRegister("cuCEk", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $63536614c324c20f$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $63536614c324c20f$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $63536614c324c20f$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $63536614c324c20f$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $63536614c324c20f$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $63536614c324c20f$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $63536614c324c20f$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $63536614c324c20f$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $63536614c324c20f$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $63536614c324c20f$export$936829b4511db3e4);
const $63536614c324c20f$export$3aaf3a78c909ea56 = 8;
const $63536614c324c20f$export$74797698e12f8baa = 12;
const $63536614c324c20f$export$b8241a1616ab1b96 = $63536614c324c20f$export$3aaf3a78c909ea56 * 10;
const $63536614c324c20f$export$2a89a65a43bab52d = {
    comfortable: $63536614c324c20f$export$3aaf3a78c909ea56 * 5,
    cosy: $63536614c324c20f$export$3aaf3a78c909ea56 * 2,
    compact: $63536614c324c20f$export$3aaf3a78c909ea56 * 0.5
};
const $63536614c324c20f$export$8ec7372efd74b753 = 'cosy';
const $63536614c324c20f$export$d77f83c3d17a7b8a = 52;
const $63536614c324c20f$export$f8725d21f81f3e01 = 0;
const $63536614c324c20f$export$2303d2bd9eeff99a = 'fixed';
const $63536614c324c20f$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $63536614c324c20f$export$8b7e31f391e6e681 = '--ds-column-span';
const $63536614c324c20f$export$936829b4511db3e4 = '--ds-grid-spacing';

});


parcelRegister("j7bQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $21cf405c5617943d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");

var $gw8fk = parcelRequire("gw8fk");

var $6tahE = parcelRequire("6tahE");

var $02LzD = parcelRequire("02LzD");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $21cf405c5617943d$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const { medium: medium } = (0, $eUqFw.useContext)((0, $6tahE.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $cuCEk.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $cuCEk.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02LzD.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gw8fk.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $21cf405c5617943d$export$2e2bcd8739ae039 = $21cf405c5617943d$var$GridWrapper;

});
parcelRegister("gw8fk", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $7946ba115b4da3a8$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
function $7946ba115b4da3a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7946ba115b4da3a8$var$gridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $7946ba115b4da3a8$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $cuCEk.varColumnsNum)}) * ${(0, $cuCEk.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $7946ba115b4da3a8$var$nestedGridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $cuCEk.varGridSpacing)}))`
});
const $7946ba115b4da3a8$export$ef2184bd89960b14 = ({ layout: layout = (0, $cuCEk.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $7946ba115b4da3a8$var$gridStyles,
            $7946ba115b4da3a8$var$gridLayoutStyles[layout],
            isNested && $7946ba115b4da3a8$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varGridSpacing)]: `${(0, $cuCEk.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("02LzD", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $abe6d6b3e91c4986$export$11cae3e04ab99fae);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");
const $abe6d6b3e91c4986$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $cuCEk.defaultSpacing),
    columns: (0, $cuCEk.defaultGridColumns)
});

});


parcelRegister("6tahE", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $384e4fce86f51330$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $384e4fce86f51330$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
var $384e4fce86f51330$var$ColumnVariant;
/**
 * Determines the method by which column width is calculated.
 */ (function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
})($384e4fce86f51330$var$ColumnVariant || ($384e4fce86f51330$var$ColumnVariant = {}));
const $384e4fce86f51330$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $cuCEk.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $384e4fce86f51330$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $384e4fce86f51330$var$singleColumnWidth = `(${$384e4fce86f51330$var$availableWidth} / var(${(0, $cuCEk.varColumnsNum)}))`;
const $384e4fce86f51330$var$gridColumnStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} - var(${(0, $cuCEk.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $384e4fce86f51330$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} *  var(${(0, $cuCEk.varColumnSpan)}) - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $384e4fce86f51330$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    medium: (0, $cuCEk.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $384e4fce86f51330$var$GridColumn = ({ medium: medium = (0, $cuCEk.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $384e4fce86f51330$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)($384e4fce86f51330$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $384e4fce86f51330$var$gridColumnStyles,
            $384e4fce86f51330$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $384e4fce86f51330$export$2e2bcd8739ae039 = $384e4fce86f51330$var$GridColumn;

});







//# sourceMappingURL=async-servicedesk-cmdb-landing-page.31f652da.js.map
